/*
 * @license
 * Palo Alto Theme (c)
 *
 * The contents of this file should not be modified.
 * add any minor changes to assets/custom.js
 *
 */
!(function (t, e, i, s, o) {
	'use strict'
	function n(t, e) {
		let i
		return function () {
			if (t) {
				const s = () => t.apply(this, arguments)
				clearTimeout(i), (i = setTimeout(s, e))
			}
		}
	}
	;(window.theme = window.theme || {}),
		(window.theme.sizes = {
			mobile: 480,
			small: 768,
			large: 1024,
			widescreen: 1440,
		}),
		(window.theme.keyboardKeys = {
			TAB: 'Tab',
			ENTER: 'Enter',
			NUMPADENTER: 'NumpadEnter',
			ESCAPE: 'Escape',
			SPACE: 'Space',
			LEFTARROW: 'ArrowLeft',
			RIGHTARROW: 'ArrowRight',
		}),
		(window.theme.focusable =
			'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
	const r = 'body',
		a = '[data-main]',
		l = '[data-site-header]',
		c = '[data-prevent-transparent-header]',
		h = 'supports-transparent-header',
		d = 'site-header--transparent',
		u = 'is-first-section-transparent',
		p = 'data-transparent',
		m = () => {
			const t = document.querySelector(r),
				e = t.querySelector(l)
			if (!e) return
			const i = 'true' === e.getAttribute(p),
				s = t.querySelector(a).children[0]
			if (!s) return
			const o = s.querySelector(`${c}:first-of-type`)
			window.isHeaderTransparent = i && s.classList.contains(h) && !o
			CSS.supports('(selector(:has(*)))') ||
				(t.classList.toggle(u, window.isHeaderTransparent),
				e.classList.toggle(d, window.isHeaderTransparent))
		}
	let g = L()
	const v = {
			body: 'body',
			main: '[data-main]',
			collectionFilters: '[data-collection-filters]',
			footer: '[data-section-type*="footer"]',
			header: '[data-header-height]',
			stickyHeader: '[data-site-header][data-position="fixed"]',
			announcementBar: '[data-announcement-bar]',
			collectionStickyBar: '[data-collection-sticky-bar]',
			logoTextLink: '[data-logo-text-link]',
		},
		y = {
			templateCollection: 'template-collection',
			templateSearch: 'template-search',
			supportsTransparentHeader: 'supports-transparent-header',
		}
	function f() {
		document.addEventListener('theme:resize', w),
			b(),
			document.dispatchEvent(new CustomEvent('theme:vars'), { bubbles: !1 })
	}
	function b() {
		E()
	}
	function w() {
		E(!0)
	}
	function E(t = !1) {
		const e = document.querySelector(v.body),
			i = document.querySelector(v.collectionFilters),
			s = null !== document.querySelector(v.logoTextLink)
		let {
			windowHeight: o,
			headerHeight: n,
			headerInitialHeight: r,
			announcementBarHeight: a,
			footerHeight: l,
			collectionStickyBarHeight: c,
		} = (function () {
			var t, e
			const i = {}
			return (
				(i.windowHeight = Math.min(window.screen.height, window.innerHeight)),
				(i.footerHeight = S(v.footer)),
				(i.headerHeight = S(v.header)),
				(i.headerInitialHeight =
					parseInt(
						(null === (t = document.querySelector(v.header)) || void 0 === t
							? void 0
							: t.dataset.height) ||
							(null === (e = document.querySelector(v.header)) || void 0 === e
								? void 0
								: e.offsetHeight),
					) || 0),
				(i.announcementBarHeight = S(v.announcementBar)),
				(i.collectionStickyBarHeight = S(v.collectionStickyBar)),
				i
			)
		})()
		s &&
			(n = (function () {
				document.documentElement.style.setProperty('--header-height', 'auto'),
					document.documentElement.style.setProperty(
						'--header-sticky-height',
						'auto',
					)
				const t = document.querySelector(v.header).offsetHeight
				return (
					requestAnimationFrame(() => {
						document.documentElement.style.setProperty(
							'--header-height',
							`${t}px`,
						),
							document.documentElement.style.setProperty(
								'--header-sticky-height',
								`${t}px`,
							)
					}),
					t
				)
			})())
		const h =
			window.isHeaderTransparent &&
			document
				.querySelector(v.main)
				.firstElementChild.classList.contains(y.supportsTransparentHeader)
				? o - a
				: o - r - a
		let d = document.querySelector(v.stickyHeader)
			? o - window.stickyHeaderHeight
			: o
		const u = e.classList.contains(y.templateCollection),
			p = e.classList.contains(y.templateSearch),
			m = (u && i) || (p && i)
		if (
			(document.documentElement.style.setProperty('--footer-height', `${l}px`),
			document.documentElement.style.setProperty('--content-full', `${h}px`),
			document.documentElement.style.setProperty(
				'--content-min',
				o - n - l + 'px',
			),
			document.documentElement.style.setProperty(
				'--collection-sticky-bar-height',
				`${c}px`,
			),
			m && (d = o),
			!t)
		)
			return void document.documentElement.style.setProperty(
				'--full-height',
				`${d}px`,
			)
		const f = L()
		f !== g &&
			(document.documentElement.style.setProperty('--full-height', `${d}px`),
			(g = f))
	}
	function S(t) {
		const e = document.querySelector(t)
		return e ? e.clientHeight : 0
	}
	function L() {
		return window.matchMedia('(orientation: portrait)').matches
			? 'portrait'
			: window.matchMedia('(orientation: landscape)').matches
			? 'landscape'
			: void 0
	}
	let k = !1,
		A = !1
	function q() {
		setTimeout(() => {
			if (k) return
			if (!A) return void q()
			const t = document.querySelectorAll('img[loading="lazy"]')
			t.length &&
				t.forEach((t) => {
					t.setAttribute('loading', 'eager')
				}),
				(k = !0)
		}, 3e3)
	}
	const C = {
		overflowBackground: '[data-overflow-background]',
		overflowFrame: '[data-overflow-frame]',
		overflowContent: '[data-overflow-content]',
		overflowContainer: '[data-overflow-container]',
		overflowWrapper: '[data-overflow-wrapper]',
	}
	function T(t, e) {
		let i = 0
		e.forEach((t) => {
			i = t.offsetHeight > i ? t.offsetHeight : i
		})
		const s = t.querySelectorAll(C.overflowBackground)
		;[t, ...s].forEach((t) => {
			t.style.setProperty('min-height', `calc(${i}px + var(--header-height))`)
		})
	}
	function P(t) {
		if (window.innerWidth < window.theme.sizes.small) {
			return void t.querySelectorAll(C.overflowFrame).forEach((t) => {
				const e = t.querySelectorAll(C.overflowContent)
				T(t, e)
			})
		}
		let e = 0
		const i = t.querySelectorAll(C.overflowFrame)
		t.querySelectorAll(C.overflowContent).forEach((t) => {
			t.offsetHeight > e && (e = t.offsetHeight)
		})
		;[...i, ...t.querySelectorAll(C.overflowBackground)].forEach((t) => {
			t.style.setProperty('min-height', `${e}px`)
		}),
			t.style.setProperty('min-height', `${e}px`)
	}
	function F(t) {
		const e = t.querySelectorAll(C.overflowContainer)
		e &&
			e.forEach((t) => {
				const e = t.querySelectorAll(C.overflowContent)
				T(t, e),
					document.addEventListener('theme:resize', () => {
						T(t, e)
					})
			})
		const i = t.querySelectorAll(C.overflowWrapper)
		i &&
			i.forEach((t) => {
				P(t),
					document.addEventListener('theme:resize', () => {
						P(t)
					})
			})
	}
	function I() {
		document.dispatchEvent(new CustomEvent('theme:resize', { bubbles: !0 })),
			window.lastWindowWidth !== window.innerWidth &&
				(document.dispatchEvent(
					new CustomEvent('theme:resize:width', { bubbles: !0 }),
				),
				(window.lastWindowWidth = window.innerWidth))
	}
	window.lastWindowWidth = window.innerWidth
	let x = window.pageYOffset,
		H = null,
		D = null,
		M = null,
		O = null,
		_ = 0
	const B = {
		quickViewVisible: 'js-quick-view-visible',
		cartDrawerOpen: 'js-drawer-open-cart',
	}
	function $(e) {
		setTimeout(() => {
			_ && clearTimeout(_),
				t.disablePageScroll(e.detail, {
					allowTouchMove: (t) => 'TEXTAREA' === t.tagName,
				}),
				document.documentElement.setAttribute('data-scroll-locked', '')
		})
	}
	function z(t) {
		const e = t.detail
		e ? (_ = setTimeout(R, e)) : R()
	}
	function R() {
		document.body.classList.contains(B.quickViewVisible) ||
			document.body.classList.contains(B.cartDrawerOpen) ||
			(t.clearQueueScrollLocks(),
			t.enablePageScroll(),
			document.documentElement.removeAttribute('data-scroll-locked'))
	}
	const V = (t, e = '', i) => {
		const s = i || document.createElement('div')
		return (
			s.classList.add(e),
			s.setAttribute('data-scroll-lock-scrollable', ''),
			t.parentNode.insertBefore(s, t),
			s.appendChild(t)
		)
	}
	function W(t) {
		t.querySelectorAll('table').forEach((t) => {
			V(t, 'table-wrapper')
		})
	}
	const N = { loading: 'is-loading' },
		U = { img: 'img.is-loading' }
	function j(t) {
		t.querySelectorAll(U.img).forEach((t) => {
			t.complete &&
				(t.classList.remove(N.loading),
				t.parentNode.classList.remove(N.loading))
		})
	}
	const K = {
			inputSearch: 'input[type="search"]',
			inputType: 'input[name="type"]',
			form: 'form',
			allVisibleElements: '[role="option"]',
			ariaSelected: '[aria-selected="true"]',
			selectedOption: '[aria-selected="true"] a, button[aria-selected="true"]',
			popularSearches: '[data-popular-searches]',
			popdownBody: '[data-popdown-body]',
			mainInputSearch: '[data-main-input-search]',
			predictiveSearchResults: '[data-predictive-search-results]',
			predictiveSearch: 'predictive-search',
			searchForm: 'search-form',
		},
		Q = 'is-searched',
		G = 'template-search'
	let X = class extends HTMLElement {
		getQuery() {
			return this.input.value.trim()
		}
		onFocus() {
			this.currentSearchTerm = this.getQuery()
		}
		onChange() {
			this.classList.toggle(Q, !this.isFormCleared()),
				(this.searchTerm = this.getQuery())
		}
		isFormCleared() {
			return 0 === this.input.value.length
		}
		submit() {
			this.form.submit()
		}
		reset() {
			this.input.val = ''
		}
		onFormSubmit(t) {
			;(this.getQuery().length && !this.querySelector(K.selectedLink)) ||
				t.preventDefault()
		}
		onKeydown(t) {
			;('ArrowUp' !== t.code && 'ArrowDown' !== t.code) || t.preventDefault()
		}
		onKeyup(t) {
			switch (
				(!this.getQuery().length && this.predictiveSearch && this.close(!0),
				t.preventDefault(),
				t.code)
			) {
				case 'ArrowUp':
					this.switchOption('up')
					break
				case 'ArrowDown':
					this.switchOption('down')
					break
				case 'Enter':
					this.selectOption()
			}
		}
		switchOption(t) {
			const e = 'up' === t,
				i =
					this.classList.contains(Q) && this.predictiveSearchResults
						? this.predictiveSearchResults
						: this.popularSearches
			if (!i) return
			this.selectedElement = i.querySelector(K.ariaSelected)
			const s = Array.from(i.querySelectorAll(K.allVisibleElements)).filter(
				(t) => null !== t.offsetParent,
			)
			let o = 0
			if (e && !this.selectedElement) return
			let n = -1,
				r = 0
			for (; -1 === n && r <= s.length; )
				s[r] === this.selectedElement && (n = r), r++
			!e && this.selectedElement
				? (o = n === s.length - 1 ? 0 : n + 1)
				: e && (o = 0 === n ? s.length - 1 : n - 1),
				o !== n &&
					((this.activeElement = s[o]), this.handleFocusableDescendants())
		}
		selectOption() {
			const t = this.querySelector(K.selectedOption)
			t && t.click()
		}
		handleFocusableDescendants(t = !1) {
			const e = this.selectedElement
				? this.selectedElement
				: this.querySelector(K.ariaSelected)
			var i
			if ((e && e.setAttribute('aria-selected', !1), !this.activeElement || t))
				return (
					(this.selectedElement = null),
					null === (i = this.activeElement) ||
						void 0 === i ||
						i.setAttribute('aria-selected', !1),
					this.input.setAttribute('aria-expanded', !1),
					void this.input.setAttribute('aria-activedescendant', '')
				)
			this.activeElement.setAttribute('aria-selected', !0),
				this.input.setAttribute('aria-activedescendant', this.activeElement.id)
		}
		constructor() {
			var t
			super(),
				(this.input = this.querySelector(K.inputSearch)),
				(this.form = this.querySelector(K.form)),
				(this.popdownBody = this.closest(K.popdownBody)),
				(this.popularSearches =
					null === (t = this.popdownBody) || void 0 === t
						? void 0
						: t.querySelector(K.popularSearches)),
				(this.predictiveSearchResults = this.querySelector(
					K.predictiveSearchResults,
				)),
				(this.predictiveSearch = this.matches(K.predictiveSearch)),
				(this.searchForm = this.matches(K.searchForm)),
				(this.selectedElement = null),
				(this.activeElement = null),
				(this.searchTerm = ''),
				(this.currentSearchTerm = ''),
				(this.isSearchPage = document.body.classList.contains(G)),
				this.input.addEventListener(
					'input',
					n((t) => {
						this.onChange(t)
					}, 300).bind(this),
				),
				this.input.addEventListener('focus', this.onFocus.bind(this)),
				this.input.form.addEventListener(
					'submit',
					this.onFormSubmit.bind(this),
				),
				this.addEventListener('keyup', this.onKeyup.bind(this)),
				this.addEventListener('keydown', this.onKeydown.bind(this)),
				this.isSearchPage &&
					((this.mainInputType = document.querySelector(
						`${K.mainInputSearch} ${K.inputType}`,
					)),
					(this.inputType = this.querySelector(K.inputType)),
					(this.inputType.value = this.mainInputType.value))
		}
	}
	customElements.define('search-form', X)
	const J = 'predictive-search',
		Y = '#shopify-section-api-predictive-search',
		Z = '[data-predictive-search-results]',
		tt = '[data-predictive-search-status]',
		et = '[data-predictive-search-live-region-count-value]',
		it = 'reset'
	customElements.define(
		'predictive-search',
		class extends X {
			connectedCallback() {
				this.predictiveSearchResults.addEventListener('transitionend', (t) => {
					t.target !== this.predictiveSearchResults ||
						this.getQuery().length ||
						(this.classList.remove(it),
						requestAnimationFrame(() => this.clearResultsHTML()))
				})
			}
			onChange() {
				super.onChange(),
					this.classList.remove(it),
					this.searchTerm.length
						? requestAnimationFrame(() =>
								this.getSearchResults(this.searchTerm),
						  )
						: this.classList.add(it)
			}
			onFocus() {
				super.onFocus(),
					this.currentSearchTerm.length &&
						(this.searchTerm !== this.currentSearchTerm
							? this.onChange()
							: 'true' === this.getAttribute('results')
							? this.open()
							: this.getSearchResults(this.searchTerm))
			}
			getSearchResults(t) {
				const e = t.replace(' ', '-').toLowerCase(),
					i = parseInt(window.theme.settings.suggestionsResultsLimit)
				let s = 'query'
				;(s += window.theme.settings.suggestArticles ? ',article' : ''),
					(s += window.theme.settings.suggestCollections ? ',collection' : ''),
					(s += window.theme.settings.suggestProducts ? ',product' : ''),
					(s += window.theme.settings.suggestPages ? ',page' : ''),
					this.setLiveRegionLoadingState(),
					this.cachedResults[e]
						? this.renderSearchResults(this.cachedResults[e])
						: fetch(
								`${theme.routes.predictiveSearchUrl}?q=${encodeURIComponent(
									t,
								)}&resources[type]=${s}&resources[limit]=${i}&section_id=api-predictive-search`,
								{ signal: this.abortController.signal },
						  )
								.then((t) => {
									if (!t.ok) {
										var e = new Error(t.status)
										throw (this.close(), e)
									}
									return t.text()
								})
								.then((t) => {
									const i = new DOMParser()
										.parseFromString(t, 'text/html')
										.querySelector(Y).innerHTML
									this.allPredictiveSearchInstances.forEach((t) => {
										t.cachedResults[e] = i
									}),
										this.renderSearchResults(i)
								})
								.catch((t) => {
									if (20 !== (null == t ? void 0 : t.code))
										throw (this.close(), t)
								})
			}
			switchOption(t) {
				super.switchOption(t),
					this.statusElement && (this.statusElement.textContent = '')
			}
			setLiveRegionLoadingState() {
				;(this.statusElement = this.statusElement || this.querySelector(tt)),
					(this.loadingText =
						this.loadingText || this.getAttribute('data-loading-text')),
					this.setLiveRegionText(this.loadingText),
					this.setAttribute('loading', !0)
			}
			setLiveRegionText(t) {
				this.statusElement.setAttribute('aria-hidden', 'false'),
					(this.statusElement.textContent = t),
					setTimeout(() => {
						this.statusElement.setAttribute('aria-hidden', 'true')
					}, 1e3)
			}
			renderSearchResults(t) {
				;(this.predictiveSearchResults.innerHTML = t),
					this.setAttribute('results', !0),
					this.setLiveRegionResults(),
					this.open()
			}
			setLiveRegionResults() {
				this.removeAttribute('loading'),
					this.setLiveRegionText(this.querySelector(et).textContent)
			}
			open() {
				this.setAttribute('open', !0)
			}
			close(t = !1) {
				this.closeResults(t)
			}
			closeResults(t = !1) {
				t &&
					(this.reset(),
					this.removeAttribute('results'),
					this.classList.remove(it)),
					this.removeAttribute('loading'),
					this.removeAttribute('open')
			}
			clearResultsHTML() {
				this.predictiveSearchResults.innerHTML = ''
			}
			constructor() {
				super(),
					(this.abortController = new AbortController()),
					(this.allPredictiveSearchInstances = document.querySelectorAll(J)),
					(this.predictiveSearchResults = this.querySelector(Z)),
					(this.cachedResults = {})
			}
		},
	),
		(window.requestIdleCallback =
			window.requestIdleCallback ||
			function (t) {
				var e = Date.now()
				return setTimeout(function () {
					t({
						didTimeout: !1,
						timeRemaining: function () {
							return Math.max(0, 50 - (Date.now() - e))
						},
					})
				}, 1)
			}),
		(window.cancelIdleCallback =
			window.cancelIdleCallback ||
			function (t) {
				clearTimeout(t)
			}),
		window.addEventListener('resize', n(I, 50)),
		(function () {
			let t
			window.addEventListener(
				'scroll',
				function () {
					t && window.cancelAnimationFrame(t),
						(t = window.requestAnimationFrame(function () {
							!(function () {
								const t = window.pageYOffset
								t > x
									? ((D = !0), (H = !1))
									: t < x
									? ((D = !1), (H = !0))
									: ((H = null), (D = null)),
									(x = t),
									document.dispatchEvent(
										new CustomEvent('theme:scroll', {
											detail: { up: H, down: D, position: t },
											bubbles: !1,
										}),
									),
									H &&
										!M &&
										document.dispatchEvent(
											new CustomEvent('theme:scroll:up', {
												detail: { position: t },
												bubbles: !1,
											}),
										),
									D &&
										!O &&
										document.dispatchEvent(
											new CustomEvent('theme:scroll:down', {
												detail: { position: t },
												bubbles: !1,
											}),
										),
									(O = D),
									(M = H)
							})()
						}))
				},
				{ passive: !0 },
			),
				window.addEventListener('theme:scroll:lock', $),
				window.addEventListener('theme:scroll:unlock', z)
		})(),
		'ontouchstart' in window ||
		navigator.maxTouchPoints > 0 ||
		navigator.msMaxTouchPoints > 0
			? ((document.documentElement.className =
					document.documentElement.className.replace(
						'no-touch',
						'supports-touch',
					)),
			  (window.theme.touch = !0))
			: (window.theme.touch = !1),
		document.addEventListener(
			'load',
			(t) => {
				'IMG' == t.target.tagName &&
					t.target.classList.contains(N.loading) &&
					(t.target.classList.remove(N.loading),
					t.target.parentNode.classList.remove(N.loading))
			},
			!0,
		)
	const st = n(() => {
		m()
	}, 300)
	window.addEventListener('DOMContentLoaded', () => {
		f(),
			F(document),
			W(document),
			j(document),
			document.documentElement.classList.remove('is-loading'),
			document.documentElement.classList.add('is-loaded'),
			window.fastNetworkAndCPU &&
				((document.onreadystatechange = () => {
					'complete' === document.readyState && ((A = !0), q())
				}),
				requestIdleCallback(q))
	}),
		document.addEventListener('shopify:section:load', (t) => {
			const e = t.target
			window.dispatchEvent(new Event('resize'), { bubbles: !0 }),
				F(e),
				W(e),
				f(),
				st()
		}),
		document.addEventListener('shopify:section:reorder', () => {
			st()
		}),
		document.addEventListener('shopify:section:unload', () => {
			st()
		}),
		(function () {
			function t(t) {
				var e = window.innerWidth || document.documentElement.clientWidth,
					i = window.innerHeight || document.documentElement.clientHeight,
					s = t.getBoundingClientRect()
				return s.top >= 0 && s.bottom <= i && s.left >= 0 && s.right <= e
			}
			function e(t) {
				var e = window.innerWidth || document.documentElement.clientWidth,
					i = window.innerHeight || document.documentElement.clientHeight,
					s = t.getBoundingClientRect(),
					o = (s.left >= 0 && s.left <= e) || (s.right >= 0 && s.right <= e),
					n = (s.top >= 0 && s.top <= i) || (s.bottom >= 0 && s.bottom <= i)
				return o && n
			}
			window.visibilityHelper = {
				isElementTotallyVisible: t,
				isElementPartiallyVisible: e,
				inViewportPartially: function (t, i) {
					function s() {
						var s = e(t)
						s != o && ((o = s), 'function' == typeof i && i(s, t))
					}
					var o = e(t)
					window.addEventListener('load', s),
						window.addEventListener('resize', s),
						window.addEventListener('scroll', s)
				},
				inViewportTotally: function (e, i) {
					function s() {
						var s = t(e)
						s != o && ((o = s), 'function' == typeof i && i(s, e))
					}
					var o = t(e)
					window.addEventListener('load', s),
						window.addEventListener('resize', s),
						window.addEventListener('scroll', s)
				},
			}
		})(),
		(window.Shopify = window.Shopify || {}),
		(window.Shopify.theme = window.Shopify.theme || {}),
		(window.Shopify.theme.sections = window.Shopify.theme.sections || {}),
		(window.Shopify.theme.sections.registered =
			window.Shopify.theme.sections.registered || {}),
		(window.Shopify.theme.sections.instances =
			window.Shopify.theme.sections.instances || [])
	const ot = window.Shopify.theme.sections.registered,
		nt = window.Shopify.theme.sections.instances,
		rt = { id: 'data-section-id', type: 'data-section-type' }
	let at = class {
			getStack() {
				return this.callStack
			}
			constructor(t = null, e = []) {
				;(this.type = t),
					(this.components = (function (t) {
						if ((void 0 !== t && 'object' != typeof t) || null === t)
							throw new TypeError(
								'Theme Sections: The components object provided is not a valid',
							)
						return t
					})(e)),
					(this.callStack = {
						onLoad: [],
						onUnload: [],
						onSelect: [],
						onDeselect: [],
						onBlockSelect: [],
						onBlockDeselect: [],
						onReorder: [],
					}),
					e.forEach((t) => {
						for (const [e, i] of Object.entries(t)) {
							const t = this.callStack[e]
							Array.isArray(t) && 'function' == typeof i
								? t.push(i)
								: (console.warn(
										`Unregisted function: '${e}' in component: '${this.type}'`,
								  ),
								  console.warn(i))
						}
					})
			}
		},
		lt = class {
			callFunctions(t, e = null) {
				this.callStack[t].forEach((t) => {
					const i = { id: this.id, type: this.type, container: this.container }
					e ? t.call(i, e) : t.call(i)
				})
			}
			onLoad() {
				this.callFunctions('onLoad')
			}
			onUnload() {
				this.callFunctions('onUnload')
			}
			onSelect(t) {
				this.callFunctions('onSelect', t)
			}
			onDeselect(t) {
				this.callFunctions('onDeselect', t)
			}
			onBlockSelect(t) {
				this.callFunctions('onBlockSelect', t)
			}
			onBlockDeselect(t) {
				this.callFunctions('onBlockDeselect', t)
			}
			onReorder(t) {
				this.callFunctions('onReorder', t)
			}
			constructor(t, e) {
				;(this.container = (function (t) {
					if (!(t instanceof Element))
						throw new TypeError(
							'Theme Sections: Attempted to load section. The section container provided is not a DOM element.',
						)
					if (null === t.getAttribute(rt.id))
						throw new Error(
							'Theme Sections: The section container provided does not have an id assigned to the ' +
								rt.id +
								' attribute.',
						)
					return t
				})(t)),
					(this.id = t.getAttribute(rt.id)),
					(this.type = e.type),
					(this.callStack = e.getStack())
				try {
					this.onLoad()
				} catch (t) {
					console.warn(`Error in section: ${this.id}`),
						console.warn(this),
						console.warn(t)
				}
			}
		}
	function ct(t, e) {
		if ('string' != typeof t)
			throw new TypeError(
				'Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered',
			)
		if (void 0 !== ot[t])
			throw new Error(
				'Theme Sections: A section of type "' +
					t +
					'" has already been registered. You cannot register the same section type twice',
			)
		Array.isArray(e) || (e = [e])
		const i = new at(t, e)
		return (ot[t] = i), ot
	}
	function ht(t, e) {
		;(t = pt(t)),
			void 0 === e && (e = document.querySelectorAll('[' + rt.type + ']')),
			(e = mt(e)),
			t.forEach(function (t) {
				const i = ot[t]
				void 0 !== i &&
					(e = e.filter(function (e) {
						return (
							!(dt(e).length > 0) &&
							null !== e.getAttribute(rt.type) &&
							(e.getAttribute(rt.type) !== t || (nt.push(new lt(e, i)), !1))
						)
					}))
			})
	}
	function dt(t) {
		var e = []
		if (NodeList.prototype.isPrototypeOf(t) || Array.isArray(t)) var i = t[0]
		if (t instanceof Element || i instanceof Element)
			mt(t).forEach(function (t) {
				e = e.concat(
					nt.filter(function (e) {
						return e.container === t
					}),
				)
			})
		else if ('string' == typeof t || 'string' == typeof i) {
			pt(t).forEach(function (t) {
				e = e.concat(
					nt.filter(function (e) {
						return e.type === t
					}),
				)
			})
		}
		return e
	}
	function ut(t) {
		for (var e, i = 0; i < nt.length; i++)
			if (nt[i].id === t) {
				e = nt[i]
				break
			}
		return e
	}
	function pt(t) {
		return (
			'*' === t
				? (t = Object.keys(ot))
				: 'string' == typeof t
				? (t = [t])
				: t.constructor === lt
				? (t = [t.prototype.type])
				: Array.isArray(t) &&
				  t[0].constructor === lt &&
				  (t = t.map(function (t) {
						return t.type
				  })),
			(t = t.map(function (t) {
				return t.toLowerCase()
			}))
		)
	}
	function mt(t) {
		return (
			NodeList.prototype.isPrototypeOf(t) && t.length > 0
				? (t = Array.prototype.slice.call(t))
				: (NodeList.prototype.isPrototypeOf(t) && 0 === t.length) || null === t
				? (t = [])
				: !Array.isArray(t) && t instanceof Element && (t = [t]),
			t
		)
	}
	window.Shopify.designMode &&
		(document.addEventListener('shopify:section:load', function (t) {
			var e = t.detail.sectionId,
				i = t.target.querySelector('[' + rt.id + '="' + e + '"]')
			null !== i && ht(i.getAttribute(rt.type), i)
		}),
		document.addEventListener('shopify:section:reorder', function (t) {
			var e = t.detail.sectionId,
				i = t.target.querySelector('[' + rt.id + '="' + e + '"]')
			'object' == typeof dt(i)[0] &&
				dt(i).forEach(function (t) {
					t.onReorder()
				})
		}),
		document.addEventListener('shopify:section:unload', function (t) {
			var e = t.detail.sectionId,
				i = t.target.querySelector('[' + rt.id + '="' + e + '"]')
			'object' == typeof dt(i)[0] &&
				dt(i).forEach(function (t) {
					var e = nt
						.map(function (t) {
							return t.id
						})
						.indexOf(t.id)
					nt.splice(e, 1), t.onUnload()
				})
		}),
		document.addEventListener('shopify:section:select', function (t) {
			var e = ut(t.detail.sectionId)
			'object' == typeof e && e.onSelect(t)
		}),
		document.addEventListener('shopify:section:deselect', function (t) {
			var e = ut(t.detail.sectionId)
			'object' == typeof e && e.onDeselect(t)
		}),
		document.addEventListener('shopify:block:select', function (t) {
			var e = ut(t.detail.sectionId)
			'object' == typeof e && e.onBlockSelect(t)
		}),
		document.addEventListener('shopify:block:deselect', function (t) {
			var e = ut(t.detail.sectionId)
			'object' == typeof e && e.onBlockDeselect(t)
		}))
	const gt = (t, e) => {
		let i, s
		return function o(...n) {
			const r = Date.now()
			;(s = clearTimeout(s)),
				!i || r - i >= e
					? (t.apply(null, n), (i = r))
					: (s = setTimeout(o.bind(null, ...n), e - (r - i)))
		}
	}
	function vt(t) {
		;(this.status = t.status || null),
			(this.headers = t.headers || null),
			(this.json = t.json || null),
			(this.body = t.body || null)
	}
	vt.prototype = Error.prototype
	const yt = '[data-collapsible-single]',
		ft = '[data-collapsible-trigger]',
		bt = '[data-collapsible-content]',
		wt = 'is-expanded',
		Et = 'aria-expanded',
		St = 'aria-controls',
		Lt = 'data-collapsible-trigger-mobile',
		kt = 'data-collapsible-transition-override',
		At = 500,
		qt = {}
	let Ct = class {
		init() {
			this.triggers.forEach((t) => {
				t.addEventListener('click', this.collapsibleToggleEvent),
					t.addEventListener('keyup', this.collapsibleToggleEvent)
			})
		}
		collapsibleToggle(t) {
			t.preventDefault()
			const e = t.target.matches(ft) ? t.target : t.target.closest(ft),
				i = e.getAttribute(St),
				s = document.getElementById(i),
				o = e.hasAttribute(Lt),
				n = e.classList.contains(wt),
				r = t.code === theme.keyboardKeys.SPACE,
				a = t.code === theme.keyboardKeys.ESCAPE,
				l = window.innerWidth < theme.sizes.small
			;(this.isTransitioning && !this.transitionOverride) ||
				((!t.code || r || a) &&
					((!n && a) ||
						(o && !l) ||
						((this.isTransitioning = !0),
						(e.disabled = !0),
						this.single &&
							this.triggers.forEach((t) => {
								const i = t.classList.contains(wt)
								if (e == t || !i) return
								const s = t.getAttribute(St),
									o = document.getElementById(s)
								requestAnimationFrame(() => {
									this.closeItem(o, t)
								})
							}),
						n
							? requestAnimationFrame(() => {
									this.closeItem(s, e)
							  })
							: requestAnimationFrame(() => {
									this.openItem(s, e)
							  }))))
		}
		openItem(t, e) {
			let i = t.querySelector(bt).offsetHeight
			this.setDropdownHeight(t, i, e, !0),
				e.classList.add(wt),
				e.setAttribute(Et, !0),
				e.dispatchEvent(
					new CustomEvent('theme:form:sticky', {
						bubbles: !0,
						detail: { element: 'accordion' },
					}),
				)
		}
		closeItem(t, e) {
			let i = t.querySelector(bt).offsetHeight
			requestAnimationFrame(() => {
				;(i = 0), this.setDropdownHeight(t, i, e, !1), e.classList.remove(wt)
			}),
				this.setDropdownHeight(t, i, e, !1),
				e.classList.remove(wt),
				e.setAttribute(Et, !1)
		}
		setDropdownHeight(t, e, i, s) {
			;(t.style.height = `${e}px`),
				t.setAttribute(Et, s),
				t.classList.toggle(wt, s),
				this.resetHeightTimer && clearTimeout(this.resetHeightTimer),
				0 == e &&
					(this.resetHeightTimer = setTimeout(() => {
						t.style.height = ''
					}, At)),
				s
					? (this.resetHeightTimer = setTimeout(() => {
							;(t.style.height = 'auto'), (this.isTransitioning = !1)
					  }, At))
					: (this.isTransitioning = !1),
				setTimeout(() => {
					i.disabled = !1
				}, At)
		}
		onUnload() {
			this.triggers.forEach((t) => {
				t.removeEventListener('click', this.collapsibleToggleEvent),
					t.removeEventListener('keyup', this.collapsibleToggleEvent)
			})
		}
		constructor(t) {
			;(this.container = t),
				(this.single = this.container.querySelector(yt)),
				(this.triggers = this.container.querySelectorAll(ft)),
				(this.resetHeightTimer = 0),
				(this.isTransitioning = !1),
				(this.transitionOverride = this.container.hasAttribute(kt)),
				(this.collapsibleToggleEvent = (t) =>
					gt(this.collapsibleToggle(t), 1250)),
				this.init()
		}
	}
	const Tt = {
			onLoad() {
				qt[this.id] = new Ct(this.container)
			},
			onUnload() {
				qt[this.id].onUnload()
			},
		},
		Pt = '[data-quantity-holder]',
		Ft = '[data-quantity-field]',
		It = '[data-quantity-button]',
		xt = '[data-quantity-minus]',
		Ht = '[data-quantity-plus]',
		Dt = 'read-only',
		Mt = 'is-disabled'
	let Ot = class {
		init() {
			;(this.quantity = this.holder.querySelector(Pt)),
				this.quantity &&
					((this.field = this.quantity.querySelector(Ft)),
					(this.buttons = this.quantity.querySelectorAll(It)),
					(this.increaseButton = this.quantity.querySelector(Ht)),
					(this.quantityValue = Number(this.field.value || 0)),
					(this.cartItemID = this.field.getAttribute('data-id')),
					(this.maxValue =
						Number(this.field.getAttribute('max')) > 0
							? Number(this.field.getAttribute('max'))
							: null),
					(this.minValue =
						Number(this.field.getAttribute('min')) > 0
							? Number(this.field.getAttribute('min'))
							: 0),
					(this.disableIncrease = this.disableIncrease.bind(this)),
					(this.emptyField = !1),
					(this.updateQuantity = this.updateQuantity.bind(this)),
					(this.decrease = this.decrease.bind(this)),
					(this.increase = this.increase.bind(this)),
					this.disableIncrease(),
					this.quantity.classList.contains(Dt) ||
						(this.changeValueOnClick(), this.changeValueOnInput()))
		}
		changeValueOnClick() {
			this.buttons.forEach((t) => {
				t.addEventListener('click', (t) => {
					t.preventDefault(),
						(this.quantityValue = Number(this.field.value || 0))
					const e = t.target,
						i = e.matches(xt) || e.closest(xt),
						s = e.matches(Ht) || e.closest(Ht)
					i && this.decrease(), s && this.increase(), this.updateQuantity()
				})
			})
		}
		changeValueOnInput() {
			this.field.addEventListener('input', () => {
				;(this.quantityValue = this.field.value), this.updateQuantity()
			})
		}
		updateQuantity() {
			this.maxValue < this.quantityValue &&
				null !== this.maxValue &&
				(this.quantityValue = this.maxValue),
				this.minValue > this.quantityValue &&
					(this.quantityValue = this.minValue),
				(this.field.value = this.quantityValue),
				this.disableIncrease(),
				document.dispatchEvent(new CustomEvent('theme:cart:update')),
				this.quantityUpdateCart && this.updateCart()
		}
		decrease() {
			this.quantityValue > this.minValue
				? this.quantityValue--
				: (this.quantityValue = 0)
		}
		increase() {
			this.quantityValue++
		}
		disableIncrease() {
			this.increaseButton.classList.toggle(
				Mt,
				this.quantityValue >= this.maxValue && null !== this.maxValue,
			)
		}
		updateCart() {
			if ('' === this.quantityValue) return
			const t = new CustomEvent('theme:cart:update', {
				bubbles: !0,
				detail: { id: this.cartItemID, quantity: this.quantityValue },
			})
			this.holder.dispatchEvent(t)
		}
		constructor(t, e = !1) {
			;(this.holder = t), (this.quantityUpdateCart = e)
		}
	}
	const _t = {
		state: { firstFocusable: null, lastFocusable: null, trigger: null },
		trapFocus: function (t) {
			var e = Array.from(
				t.container.querySelectorAll(
					'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])',
				),
			).filter(function (t) {
				var e = t.offsetWidth,
					i = t.offsetHeight
				return (
					0 !== e &&
					0 !== i &&
					'none' !== getComputedStyle(t).getPropertyValue('display')
				)
			})
			;(e = e.filter(function (t) {
				return !t.classList.contains('deferred-media__poster')
			})),
				(this.state.firstFocusable = e[0]),
				(this.state.lastFocusable = e[e.length - 1]),
				t.elementToFocus ||
					(t.elementToFocus = this.state.firstFocusable || t.container),
				this._setupHandlers(),
				document.addEventListener('focusin', this._onFocusInHandler),
				document.addEventListener('focusout', this._onFocusOutHandler),
				t.container.setAttribute('tabindex', '-1'),
				t.elementToFocus.focus()
		},
		removeTrapFocus: function (t) {
			const e = !document.body.classList.contains('no-outline')
			t && t.container && t.container.removeAttribute('tabindex'),
				document.removeEventListener('focusin', this._onFocusInHandler),
				this.state.trigger && e && this.state.trigger.focus()
		},
		_manageFocus: function (t) {
			t.code === theme.keyboardKeys.TAB &&
				(t.target !== this.state.lastFocusable ||
					t.shiftKey ||
					(t.preventDefault(), this.state.firstFocusable.focus()),
				t.target === this.state.firstFocusable &&
					t.shiftKey &&
					(t.preventDefault(), this.state.lastFocusable.focus()))
		},
		_onFocusOut: function () {
			document.removeEventListener('keydown', this._manageFocusHandler)
		},
		_onFocusIn: function (t) {
			;(t.target !== this.state.lastFocusable &&
				t.target !== this.state.firstFocusable) ||
				document.addEventListener('keydown', this._manageFocusHandler)
		},
		_setupHandlers: function () {
			this._onFocusInHandler ||
				(this._onFocusInHandler = this._onFocusIn.bind(this)),
				this._onFocusOutHandler ||
					(this._onFocusOutHandler = this._onFocusIn.bind(this)),
				this._manageFocusHandler ||
					(this._manageFocusHandler = this._manageFocus.bind(this))
		},
	}
	const Bt = {}
	function $t(t = {}) {
		if ((t.type || (t.type = 'json'), t.url))
			return Bt[t.url]
				? Bt[t.url]
				: (function (t, e) {
						const i = new Promise((i, s) => {
							'text' === e
								? fetch(t)
										.then((t) => t.text())
										.then((t) => {
											i(t)
										})
										.catch((t) => {
											s(t)
										})
								: (function (t, e, i) {
										let s = document.getElementsByTagName('head')[0],
											o = !1,
											n = document.createElement('script')
										;(n.src = t),
											(n.onload = n.onreadystatechange =
												function () {
													o ||
													(this.readyState &&
														'loaded' != this.readyState &&
														'complete' != this.readyState)
														? i()
														: ((o = !0), e())
												}),
											s.appendChild(n)
								  })(
										t,
										function () {
											i()
										},
										function () {
											s()
										},
								  )
						})
						return (Bt[t] = i), i
				  })(t.url, t.type)
		if (t.json)
			return Bt[t.json]
				? Promise.resolve(Bt[t.json])
				: window
						.fetch(t.json)
						.then((t) => t.json())
						.then((e) => ((Bt[t.json] = e), e))
		if (t.name) {
			const e = ''.concat(t.name, t.version)
			return Bt[e]
				? Bt[e]
				: (function (t) {
						const e = ''.concat(t.name, t.version),
							i = new Promise((e, i) => {
								try {
									window.Shopify.loadFeatures([
										{
											name: t.name,
											version: t.version,
											onLoad: (t) => {
												!(function (t, e, i) {
													i ? e(i) : t()
												})(e, i, t)
											},
										},
									])
								} catch (t) {
									i(t)
								}
							})
						return (Bt[e] = i), i
				  })(t)
		}
		return Promise.reject()
	}
	;(window.isYoutubeAPILoaded = !1), (window.isVimeoAPILoaded = !1)
	const zt = '[data-video-id]',
		Rt = 'loaded',
		Vt = 'data-enable-sound',
		Wt = 'data-enable-background',
		Nt = 'data-enable-autoplay',
		Ut = 'data-enable-loop',
		jt = 'data-video-id',
		Kt = 'data-video-type'
	const Qt = {
			videoIframe: '[data-video-id]',
			videoWrapper: '.video-wrapper',
			youtubeWrapper: '[data-youtube-wrapper]',
		},
		Gt = 'data-section-id',
		Xt = 'data-enable-sound',
		Jt = 'data-check-player-visibility',
		Yt = 'data-video-id',
		Zt = 'data-video-type',
		te = 'loaded',
		ee = []
	const ie = '[data-notification-form]',
		se = '[data-notification]',
		oe = '[data-popup-close]',
		ne = 'pswp--success',
		re = 'notification-popup-visible'
	function ae(t) {
		const i = e.data(t)
		i &&
			(i.on('dragStart', (t, e) => {
				document.ontouchmove = function (t) {
					t.preventDefault()
				}
			}),
			i.on('dragEnd', (t, e) => {
				document.ontouchmove = function (t) {
					return !0
				}
			}))
	}
	const le = 'html5',
		ce = 'youtube',
		he = 'vimeo',
		de = '[data-deferred-media]',
		ue = '[data-deferred-media-button]',
		pe = '[data-product-single-media-wrapper]',
		me = '[data-video]',
		ge = '.media--hidden',
		ve = 'media--hidden',
		ye = 'loaded',
		fe = 'data-section-id',
		be = 'data-autoplay-video',
		we = 'data-media-id'
	let Ee = class {
		init() {
			this.container.querySelectorAll(me).forEach((t) => {
				const e = t.querySelector(ue)
				e && e.addEventListener('click', this.loadContent.bind(this, t)),
					this.autoplayVideo && this.loadContent(t)
			})
		}
		loadContent(t) {
			if (t.querySelector(de).getAttribute(ye)) return
			const e = document.createElement('div')
			e.appendChild(
				t.querySelector('template').content.firstElementChild.cloneNode(!0),
			)
			const i = t.dataset.mediaId,
				s = e.querySelector('video, iframe'),
				o = this.hostFromVideoElement(s),
				n = t.querySelector(de)
			n.appendChild(s),
				n.setAttribute('loaded', !0),
				(this.players[i] = {
					mediaId: i,
					sectionId: this.id,
					container: t,
					element: s,
					host: o,
					ready: () => {
						this.createPlayer(i)
					},
				})
			const r = this.players[i]
			switch (r.host) {
				case le:
					this.loadVideo(r, le)
					break
				case he:
					window.isVimeoAPILoaded
						? this.loadVideo(r, he)
						: $t({ url: 'https://player.vimeo.com/api/player.js' }).then(() =>
								this.loadVideo(r, he),
						  )
					break
				case ce:
					window.isYoutubeAPILoaded
						? this.loadVideo(r, ce)
						: $t({ url: 'https://www.youtube.com/iframe_api' }).then(() =>
								this.loadVideo(r, ce),
						  )
			}
		}
		hostFromVideoElement(t) {
			if ('VIDEO' === t.tagName) return le
			if ('IFRAME' === t.tagName) {
				if (
					/^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(
						t.src,
					)
				)
					return ce
				if (t.src.includes('vimeo.com')) return he
			}
			return null
		}
		loadVideo(t, e) {
			t.host === e && t.ready()
		}
		createPlayer(t) {
			const e = this.players[t]
			switch (e.host) {
				case le:
					e.element.addEventListener('play', () => {
						e.container.dispatchEvent(new CustomEvent('theme:media:play'), {
							bubbles: !0,
						})
					}),
						e.element.addEventListener('pause', () => {
							e.container.dispatchEvent(new CustomEvent('theme:media:pause'), {
								bubbles: !0,
							})
						}),
						this.autoplayVideo && this.observeVideo(e, t)
					break
				case he:
					;(e.player = new Vimeo.Player(e.element)),
						e.player.play(),
						e.container.dispatchEvent(new CustomEvent('theme:media:play'), {
							bubbles: !0,
						}),
						(window.isVimeoAPILoaded = !0),
						e.player.on('play', () => {
							e.container.dispatchEvent(new CustomEvent('theme:media:play'), {
								bubbles: !0,
							})
						}),
						e.player.on('pause', () => {
							e.container.dispatchEvent(new CustomEvent('theme:media:pause'), {
								bubbles: !0,
							})
						}),
						this.autoplayVideo && this.observeVideo(e, t)
					break
				case ce:
					if (e.host == ce && e.player) return
					YT.ready(() => {
						const i = e.container.dataset.videoId
						;(e.player = new YT.Player(e.element, {
							videoId: i,
							events: {
								onReady: (t) => {
									t.target.playVideo(),
										e.container.dispatchEvent(
											new CustomEvent('theme:media:play'),
											{ bubbles: !0 },
										)
								},
								onStateChange: (t) => {
									1 == t.data &&
										e.container.dispatchEvent(
											new CustomEvent('theme:media:play'),
											{ bubbles: !0 },
										),
										2 == t.data &&
											e.container.dispatchEvent(
												new CustomEvent('theme:media:pause'),
												{ bubbles: !0 },
											),
										0 == t.data &&
											e.container.dispatchEvent(
												new CustomEvent('theme:media:pause'),
												{ bubbles: !0 },
											)
								},
							},
						})),
							(window.isYoutubeAPILoaded = !0),
							this.autoplayVideo && this.observeVideo(e, t)
					})
			}
			e.container.addEventListener('theme:media:visible', (t) =>
				this.onVisible(t),
			),
				e.container.addEventListener('theme:media:hidden', (t) =>
					this.onHidden(t),
				),
				e.container.addEventListener('xrLaunch', (t) => this.onHidden(t))
		}
		observeVideo(t) {
			new IntersectionObserver(
				(e, i) => {
					e.forEach((e) => {
						const i = 0 == e.intersectionRatio,
							s = !t.element.closest(ge)
						i ? this.pauseVideo(t) : s && this.playVideo(t)
					})
				},
				{ rootMargin: '200px', threshold: [0, 0.25, 0.75, 1] },
			).observe(t.element)
		}
		playVideo(t) {
			t.player && t.player.playVideo
				? t.player.playVideo()
				: t.element && t.element.play
				? t.element.play()
				: t.player && t.player.play && t.player.play(),
				t.container.dispatchEvent(new CustomEvent('theme:media:play'), {
					bubbles: !0,
				})
		}
		pauseVideo(t) {
			if (t.player && t.player.pauseVideo)
				'1' == t.player.playerInfo.playerState && t.player.pauseVideo()
			else if (t.player && t.player.pause) t.player.pause()
			else if (t.element && !t.element.paused) {
				var e
				null === (e = t.element) || void 0 === e || e.pause()
			}
		}
		onHidden(t) {
			if (void 0 !== t.target.dataset.mediaId) {
				const e = t.target.dataset.mediaId,
					i = this.players[e]
				this.pauseVideo(i)
			}
		}
		onVisible(t) {
			if (void 0 !== t.target.dataset.mediaId) {
				const e = t.target.dataset.mediaId,
					i = this.players[e]
				setTimeout(() => {
					this.playVideo(i)
				}, 50),
					this.pauseContainerMedia(e)
			}
		}
		pauseOtherMedia(t, e) {
			const i = `[${we}="${t}"]`,
				s = e.querySelectorAll(`${pe}:not(${i})`)
			s.length &&
				s.forEach((t) => {
					t.dispatchEvent(new CustomEvent('theme:media:hidden'), {
						bubbles: !0,
					}),
						t.classList.add(ve)
				})
		}
		constructor(t) {
			;(this.container = t),
				(this.id = this.container.getAttribute(fe)),
				(this.autoplayVideo = 'true' === this.container.getAttribute(be)),
				(this.players = {}),
				(this.pauseContainerMedia = (t, e = this.container) =>
					this.pauseOtherMedia(t, e)),
				this.init()
		}
	}
	function Se(t, e, i = [], s = !1) {
		const o = new FormData(t),
			n = new URLSearchParams(o)
		if (!e) return n.toString()
		const r = new FormData(e),
			a = new URLSearchParams(r),
			l = []
		for (const t of o.entries()) '' === t[1] && l.push(t[0])
		for (const t of r.entries()) '' === t[1] && l.push(t[0])
		for (let t = 0; t < l.length; t++) {
			const e = l[t]
			n.has(e) && n.delete(e), a.has(e) && a.delete(e)
		}
		for (const t of n.keys()) a.has(t) && a.delete(t)
		if (i.length > 0)
			for (let t = 0; t < i.length; t++) {
				const e = i[t]
				n.has(e) && n.delete(e), a.has(e) && a.delete(e)
			}
		return (
			s && (a.has('type') && a.delete('type'), n.set('type', s)),
			`${n.toString()}&${a.toString()}`
		)
	}
	const Le = '[data-custom-scrollbar]',
		ke = '[data-custom-scrollbar-items]',
		Ae = '[data-custom-scrollbar-thumb]',
		qe = '.current'
	let Ce = class {
		calculateTrack(t) {
			if (!t)
				return (
					this.scrollbar.style.setProperty('--thumb-scale', 0),
					void this.scrollbar.style.setProperty('--thumb-position', '0px')
				)
			const e = t.clientWidth / this.scrollbarThumb.parentElement.clientWidth,
				i = t.offsetLeft / this.scrollbarThumb.parentElement.clientWidth
			this.scrollbar.style.setProperty('--thumb-scale', e),
				this.scrollbar.style.setProperty(
					'--thumb-position',
					this.trackWidth * i + 'px',
				)
		}
		calculateScrollbar() {
			if (this.scrollbarItems.children.length) {
				const t = [...this.scrollbarItems.children]
				;(this.trackWidth = 0),
					t.forEach((t) => {
						this.trackWidth +=
							t.getBoundingClientRect().width +
							parseInt(window.getComputedStyle(t).marginRight)
					}),
					this.scrollbar.style.setProperty(
						'--track-width',
						`${this.trackWidth}px`,
					)
			}
		}
		onScrollbarChange(t) {
			t &&
				t.detail &&
				t.detail.element &&
				this.container.contains(t.detail.element) &&
				this.calculateTrack(t.detail.element)
		}
		events() {
			document.addEventListener('theme:resize:width', this.calcScrollbarEvent),
				document.addEventListener(
					'theme:custom-scrollbar:change',
					this.onScrollbarChangeEvent,
				)
		}
		unload() {
			document.removeEventListener(
				'theme:resize:width',
				this.calcScrollbarEvent,
			),
				document.removeEventListener(
					'theme:custom-scrollbar:change',
					this.onScrollbarChangeEvent,
				)
		}
		constructor(t) {
			;(this.container = t),
				(this.scrollbarItems = t.querySelector(ke)),
				(this.scrollbar = t.querySelector(Le)),
				(this.scrollbarThumb = t.querySelector(Ae)),
				(this.trackWidth = 0),
				(this.calcScrollbarEvent = () => this.calculateScrollbar()),
				(this.onScrollbarChangeEvent = (t) => this.onScrollbarChange(t)),
				this.scrollbar &&
					this.scrollbarItems &&
					(this.events(),
					this.calculateScrollbar(),
					this.scrollbarItems.children.length &&
						this.calculateTrack(this.scrollbarItems.querySelector(qe)))
		}
	}
	const Te = '[data-tooltip]',
		Pe = '[data-tooltip-container]',
		Fe = '[data-tooltip-arrow]',
		Ie = '[data-aos]',
		xe = 'tooltip-default',
		He = 'is-animating',
		De = 'is-visible',
		Me = 'is-hiding',
		Oe = 'data-tooltip',
		_e = 'data-tooltip-container',
		Be = 'data-tooltip-stop-mouseenter',
		$e = {}
	let ze = class {
		init() {
			if (!document.querySelector(Pe)) {
				const t = `<div class="${this.rootClass}__inner"><div class="${this.rootClass}__arrow" data-tooltip-arrow></div><div class="${this.rootClass}__text"></div></div>`,
					e = document.createElement('div')
				;(e.className = `${this.rootClass} ${this.isAnimatingClass}`),
					e.setAttribute(_e, ''),
					(e.innerHTML = t),
					document.body.appendChild(e)
			}
			this.tooltip.addEventListener('mouseenter', this.addPinMouseEvent),
				this.tooltip.addEventListener('mouseleave', this.removePinMouseEvent),
				this.tooltip.addEventListener('theme:tooltip:init', this.addPinEvent),
				document.addEventListener('theme:tooltip:close', this.removePinEvent)
			const t = document.querySelector(Pe)
			theme.settings.animations &&
				this.animatedContainer &&
				this.animatedContainer.addEventListener('transitionend', (e) => {
					'transform' === e.propertyName && t.classList.remove(He)
				})
		}
		addPin(t = !1) {
			const e = document.querySelector(Pe),
				i = e.querySelector(Fe)
			if (e && ((t && !this.tooltip.hasAttribute(Be)) || !t)) {
				const t = e.querySelector(`.${this.rootClass}__inner`)
				e.querySelector(`.${this.rootClass}__text`).textContent = this.label
				const s = t.offsetWidth,
					o = this.tooltip.getBoundingClientRect(),
					n = o.top,
					r = o.width,
					a = n + o.height + window.scrollY
				let l = o.left - s / 2 + r / 2,
					c = '50%'
				const h = l + s - window.innerWidth
				h > 0 && (l -= h),
					l < 0 && ((c = `calc(50% + ${l}px)`), (l = 0)),
					(i.style.left = c),
					(e.style.transform = `translate(${l}px, ${a}px)`),
					e.classList.remove(Me),
					e.classList.add(De),
					document.addEventListener('theme:scroll', this.removePinEvent)
			}
		}
		removePin(t, e = !1, i = !1) {
			const s = document.querySelector(Pe),
				o = s.classList.contains(De)
			s &&
				((e && !this.tooltip.hasAttribute(Be)) || !e) &&
				(o &&
					(i || t.detail.hideTransition) &&
					(s.classList.add(Me),
					this.hideTransitionTimeout &&
						clearTimeout(this.hideTransitionTimeout),
					(this.hideTransitionTimeout = setTimeout(() => {
						s.classList.remove(Me)
					}, this.transitionSpeed))),
				s.classList.remove(De),
				(s.style.transform = 'translate(100%, 0)'),
				document.removeEventListener('theme:scroll', this.removePinEvent))
		}
		unload() {
			this.tooltip.removeEventListener('mouseenter', this.addPinMouseEvent),
				this.tooltip.removeEventListener(
					'mouseleave',
					this.removePinMouseEvent,
				),
				this.tooltip.removeEventListener(
					'theme:tooltip:init',
					this.addPinEvent,
				),
				document.removeEventListener(
					'theme:tooltip:close',
					this.removePinEvent,
				),
				document.removeEventListener('theme:scroll', this.removePinEvent)
		}
		constructor(t) {
			;(this.tooltip = t),
				this.tooltip.hasAttribute(Oe) &&
					((this.rootClass = xe),
					(this.isAnimatingClass = He),
					(this.label = this.tooltip.getAttribute(Oe)),
					(this.transitionSpeed = 200),
					(this.hideTransitionTimeout = 0),
					(this.animatedContainer = this.tooltip.closest(Ie)),
					(this.addPinEvent = () => this.addPin()),
					(this.addPinMouseEvent = () => this.addPin(!0)),
					(this.removePinEvent = (t) => gt(this.removePin(t), 50)),
					(this.removePinMouseEvent = (t) => this.removePin(t, !0, !0)),
					this.init())
		}
	}
	const Re = {
			onLoad() {
				$e[this.id] = []
				this.container.querySelectorAll(Te).forEach((t) => {
					$e[this.id].push(new ze(t))
				})
			},
			onUnload() {
				$e[this.id].forEach((t) => {
					'function' == typeof t.unload && t.unload()
				})
			},
		},
		Ve = '[data-range-slider]',
		We = '[data-range-left]',
		Ne = '[data-range-right]',
		Ue = '[data-range-line]',
		je = '[data-range-holder]',
		Ke = 'data-se-min',
		Qe = 'data-se-max',
		Ge = 'data-se-min-value',
		Xe = 'data-se-max-value',
		Je = 'data-se-step',
		Ye = 'data-range-filter-update',
		Ze = '[data-field-price-min]',
		ti = '[data-field-price-max]',
		ei = 'is-initialized'
	function ii(t) {
		return t.replace(/http(s)?:/, '')
	}
	function si() {
		this.entries = []
	}
	function oi(t, e) {
		ni(t)
		var i = (function (t, e) {
			ni(t),
				(function (t) {
					if (!Array.isArray(t)) throw new TypeError(t + ' is not an array.')
					if (0 === t.length) throw new Error(t + ' is empty.')
					if (!t[0].hasOwnProperty('name'))
						throw new Error(t[0] + 'does not contain name key.')
					if ('string' != typeof t[0].name)
						throw new TypeError(
							'Invalid value type passed for name of option ' +
								t[0].name +
								'. Value should be string.',
						)
				})(e)
			var i = []
			return (
				e.forEach(function (e) {
					for (var s = 0; s < t.options.length; s++) {
						if (
							(t.options[s].name || t.options[s]).toLowerCase() ===
							e.name.toLowerCase()
						) {
							i[s] = e.value
							break
						}
					}
				}),
				i
			)
		})(t, e)
		return (function (t, e) {
			ni(t),
				(function (t) {
					if (Array.isArray(t) && 'object' == typeof t[0])
						throw new Error(t + 'is not a valid array of options.')
				})(e)
			var i = t.variants.filter(function (t) {
				return e.every(function (e, i) {
					return t.options[i] === e
				})
			})
			return i[0] || null
		})(t, i)
	}
	function ni(t) {
		if ('object' != typeof t) throw new TypeError(t + ' is not an object.')
		if (0 === Object.keys(t).length && t.constructor === Object)
			throw new Error(t + ' is empty.')
	}
	;(si.prototype.add = function (t, e, i) {
		this.entries.push({ element: t, event: e, fn: i }), t.addEventListener(e, i)
	}),
		(si.prototype.removeAll = function () {
			this.entries = this.entries.filter(function (t) {
				return t.element.removeEventListener(t.event, t.fn), !1
			})
		})
	var ri = '[name="id"]',
		ai = '[name="selling_plan"]',
		li = '[name^="options"]',
		ci = '[name="quantity"]',
		hi = '[name^="properties"]'
	const di = { color: 'ash' },
		ui = '[data-swatch]',
		pi = '[data-product-block]',
		mi = '[data-product-image-secondary]',
		gi = '[data-product-image-hover]',
		vi = '[data-button-quick-view]',
		yi = '[data-grid-image]',
		fi = '[data-grid-link]',
		bi = '[data-load-hovers]',
		wi = '[data-swatches-more]',
		Ei = '[data-section-type]',
		Si = '[data-swatches-container]',
		Li = '[data-swatches-label]',
		ki = '[data-swatches-button]',
		Ai = '[data-option-position]',
		qi = '[data-slider]',
		Ci = 'product__media--featured-visible',
		Ti = 'product__media__hover-img--visible',
		Pi = 'swatch__link--no-image',
		Fi = 'no-outline',
		Ii = 'is-visible',
		xi = 'selector-wrapper--large',
		Hi = 'data-swatch',
		Di = 'data-swatch-handle',
		Mi = 'data-swatch-label',
		Oi = 'data-swatch-image',
		_i = 'data-swatch-image-id',
		Bi = 'data-swatch-variant',
		$i = 'data-swatch-index',
		zi = 'data-variant-id',
		Ri = 'data-loaded',
		Vi = 'data-fetched-image',
		Wi = 'data-fetched-image-index',
		Ni = 'data-grid-image-default',
		Ui = 'data-grid-image-target',
		ji = 'data-grid-image-target-default'
	let Ki = {}
	const Qi = {}
	let Gi = class {
			init() {
				this.setStyles(),
					this.variant &&
						this.outer &&
						(this.handleHovers(), this.handleClicks()),
					!this.image && this.swatchLink && this.swatchLink.classList.add(Pi)
			}
			setStyles() {
				this.colorMatch &&
					this.colorMatch.hex &&
					this.element.style.setProperty('--swatch', `${this.colorMatch.hex}`),
					this.colorMatch &&
						this.colorMatch.path &&
						this.element.style.setProperty(
							'background-image',
							`url(${this.colorMatch.path})`,
						)
			}
			handleHovers() {
				this.swatchLink.addEventListener('mouseenter', () => {
					var t
					if (((this.imageReplace = null), this.imageId)) {
						if (
							!this.outer.querySelector(`[${Ui}="${this.imageId}"]`) &&
							((this.gridImage = this.outer.querySelector(yi)),
							this.image && this.gridImage)
						) {
							const t = window.devicePixelRatio || 1,
								e = this.gridImage.offsetWidth * t,
								i = 180 * Math.ceil(e / 180)
							if (
								(this.gridImage.hasAttribute(ji)
									? this.gridImage.getAttribute(ji)
									: '') === this.imageId &&
								this.gridImage.hasAttribute(Ni)
							)
								return void (this.imageReplace =
									this.gridImage.getAttribute(Ni))
							if (this.element.hasAttribute(Vi))
								this.imageReplace = this.element.getAttribute(Vi)
							else {
								const t = (function (t, e) {
									if (null === e) return t
									if (
										(null == t && (t = window.theme.assets.noImage),
										'master' === e)
									)
										return ii(t)
									const i = t.match(
										/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?$/i,
									)
									if (i) {
										const s = t.split(i[0]),
											o = i[0]
										return ii(`${s[0]}_${e}${o}`)
									}
									return null
								})(this.image, `${i}x`)
								window
									.fetch(t)
									.then((t) => t.blob())
									.then((t) => {
										const e = URL.createObjectURL(t)
										;(this.imageReplace = `url("${e}")`),
											this.element.setAttribute(Vi, this.imageReplace),
											this.element.hasAttribute($i) &&
												this.outer.hasAttribute(Wi) &&
												parseInt(this.element.getAttribute($i)) ===
													parseInt(this.outer.getAttribute(Wi)) &&
												(this.replaceImages(), this.outer.removeAttribute(Wi))
									})
									.catch((t) => {
										console.log(`Error: ${t}`)
									})
							}
						}
					}
					if (
						((this.loadHovers = this.outer.querySelector(bi)),
						this.loadHovers &&
							!(null === (t = this.loadHovers) || void 0 === t
								? void 0
								: t.hasAttribute(Ri)))
					) {
						const t = document.createElement('div')
						t.appendChild(
							this.loadHovers
								.querySelector('template')
								.content.firstElementChild.cloneNode(!0),
						),
							this.loadHovers.appendChild(t),
							this.loadHovers.setAttribute(Ri, !0)
					}
				})
			}
			handleClicks() {
				this.swatchLink.addEventListener('click', (t) => {
					!document.body.classList.contains(Fi) ||
						(t.preventDefault(), this.updateImagesAndLinksOnEvent())
				}),
					this.swatchLink.addEventListener('keyup', (t) => {
						const e = !document.body.classList.contains(Fi)
						;(t.code !== theme.keyboardKeys.ENTER &&
							t.code !== theme.keyboardKeys.NUMPADENTER) ||
							e ||
							(t.preventDefault(),
							this.swatchLink.dispatchEvent(
								new Event('mouseenter', { bubbles: !0 }),
							),
							this.updateImagesAndLinksOnEvent())
					})
			}
			updateImagesAndLinksOnEvent() {
				this.updateLinks(), this.replaceImages()
			}
			updateLinks() {
				;(this.linkElements = this.outer.querySelectorAll(fi)),
					(this.quickView = this.outer.querySelector(vi)),
					this.linkElements.length &&
						this.linkElements.forEach((t) => {
							const e =
								((i = t.getAttribute('href')),
								(s = this.variant),
								/variant=/.test(i)
									? i.replace(/(variant=)[^&]+/, '$1' + s)
									: /\?/.test(i)
									? i.concat('&variant=').concat(s)
									: i.concat('?variant=').concat(s))
							var i, s
							t.setAttribute('href', e)
						}),
					this.quickView &&
						'quick_buy' === theme.settings.quickBuy &&
						this.quickView.setAttribute(zi, this.variant)
			}
			replaceImages() {
				if (
					((this.imageSecondary = this.outer.querySelector(mi)),
					this.outer.removeAttribute(Wi),
					!this.imageReplace &&
						this.element.hasAttribute($i) &&
						this.outer.setAttribute(
							Wi,
							parseInt(this.element.getAttribute($i)),
						),
					this.imageReplace && this.gridImage && this.imageId)
				) {
					this.gridImage.setAttribute(Ui, this.imageId),
						this.gridImage.hasAttribute(Ni) ||
							this.gridImage.setAttribute(
								Ni,
								window.getComputedStyle(this.gridImage).backgroundImage,
							)
					const t = () => {
						requestAnimationFrame(() => {
							this.gridImage.style.setProperty(
								'background-image',
								this.imageReplace,
							),
								requestAnimationFrame(() => {
									this.imageSecondary.classList.remove(Ci)
								})
						}),
							this.imageSecondary.removeEventListener('animationend', t)
					}
					requestAnimationFrame(() => {
						this.imageSecondary.classList.add(Ci),
							this.imageSecondary.style.setProperty(
								'background-image',
								this.imageReplace,
							)
					}),
						this.imageSecondary.addEventListener('animationend', t)
				}
				'image' === theme.settings.productGridHover &&
					(this.hoverImages = this.outer.querySelectorAll(gi)),
					this.hoverImages.length > 1 &&
						this.hoverImages.forEach((t) => {
							t.classList.remove(Ti),
								t.getAttribute(zi) === this.variant
									? t.classList.add(Ti)
									: this.hoverImages[0].classList.add(Ti)
						})
			}
			constructor(t) {
				;(this.element = t),
					(this.swatchLink = this.element.nextElementSibling),
					(this.colorString = t.getAttribute(Hi)),
					(this.image = this.element.getAttribute(Oi)),
					(this.imageId = this.element.getAttribute(_i)),
					(this.variant = this.element.getAttribute(Bi)),
					(this.outer = this.element.closest(pi)),
					(this.gridImage = null),
					(this.imageDefault = null),
					(this.hoverImages = []),
					(this.loadHovers = null)
				const e = new (class {
					getColor() {
						return this.match
					}
					init() {
						return $t({ json: theme.assets.swatches })
							.then((t) => this.matchColors(t, this.settings.color))
							.catch((t) => {
								console.log('failed to load swatch colors script'),
									console.log(t)
							})
					}
					matchColors(t, e) {
						let i = '#E5E5E5',
							s = null
						const o = theme.assets.base || '/',
							n = e.toLowerCase().replace(/\s/g, ''),
							r = t.colors
						if (r) {
							let t = null
							if (
								r.filter((e, i) => {
									if (
										Object.keys(e)
											.toString()
											.toLowerCase()
											.replace(/\s/g, '') === n
									)
										return (t = i), e
								}).length &&
								null !== t
							) {
								const e = Object.values(r[t])[0]
								;(i = e),
									(e.includes('.jpg') ||
										e.includes('.jpeg') ||
										e.includes('.png') ||
										e.includes('.svg')) &&
										((s = `${o}${e}`), (i = '#888888'))
							}
						}
						return { color: this.settings.color, path: s, hex: i }
					}
					constructor(t = {}) {
						;(this.settings = { ...di, ...t }), (this.match = this.init())
					}
				})({ color: this.colorString })
				e.getColor().then((t) => {
					;(this.colorMatch = t), this.init()
				})
			}
		},
		Xi = class extends HTMLElement {
			init() {
				;(this.swatchElements = this.querySelectorAll(ui)),
					this.swatchElements.forEach((t) => {
						new Gi(t)
					}),
					this.handleShowMore()
			}
			handleShowMore() {
				;(this.initialHeight = this.offsetHeight),
					(this.expandedHeight = this.initialHeight)
				const t = this.closest(Ei),
					e = this.querySelector(wi)
				e &&
					(null == e ||
						e.addEventListener('click', () => {
							this.classList.add(Ii)
						}),
					null == t ||
						t.addEventListener('touchstart', (t) => {
							this.contains(t.target) ||
								(this.classList.remove(Ii),
								this.dispatchEvent(new Event('mouseleave', { bubbles: !0 })))
						}),
					this.addEventListener('mouseenter', () => {
						const t = (e) => {
							this.expandedHeight = this.offsetHeight
							const i = e.target.closest(qi)
							this.expandedHeight > this.initialHeight &&
								i &&
								requestAnimationFrame(() =>
									i.dispatchEvent(
										new CustomEvent('theme:slider:resize', { bubbles: !1 }),
									),
								),
								this.removeEventListener('animationstart', t)
						}
						this.addEventListener('animationstart', t)
					}),
					this.addEventListener('mouseleave', () => {
						const t = (e) => {
							const i = e.target.closest(qi)
							this.expandedHeight > this.initialHeight &&
								i &&
								requestAnimationFrame(() =>
									i.dispatchEvent(
										new CustomEvent('theme:slider:resize', { bubbles: !1 }),
									),
								),
								this.removeEventListener('animationstart', t)
						}
						this.addEventListener('animationstart', t)
					}))
			}
			constructor() {
				super(),
					(this.handle = this.getAttribute(Di)),
					(this.label = this.getAttribute(Mi).trim().toLowerCase()),
					(function (t) {
						const e = `${theme.routes.root}products/${t}.js`
						return window
							.fetch(e)
							.then((t) => t.json())
							.catch((t) => {
								console.error(t)
							})
					})(this.handle).then((t) => {
						;(this.product = t),
							(this.colorOption = t.options.find(
								(t) => t.name.toLowerCase() === this.label || null,
							)),
							this.colorOption &&
								((this.swatches = this.colorOption.values), this.init())
					})
			}
		},
		Ji = class {
			checkSwatchesHeight(t) {
				const e = t.querySelector(Li),
					i = t.querySelector(ki),
					s = parseInt(
						window.getComputedStyle(t).getPropertyValue('padding-top'),
					),
					o = parseInt(
						window.getComputedStyle(e).getPropertyValue('margin-bottom'),
					),
					n = parseInt(
						window.getComputedStyle(i).getPropertyValue('margin-bottom'),
					),
					r = t.closest(Ai)
				r.classList.remove(xi),
					t.offsetHeight - s >
						e.offsetHeight + o + 2 * i.offsetHeight + 2 * n &&
						(t.style.setProperty(
							'--swatches-max-height',
							`${t.offsetHeight}px`,
						),
						r.classList.add(xi))
			}
			onUnload() {
				this.swatchesContainers.forEach((t) => {
					document.removeEventListener(
						'theme:resize:width',
						this.checkSwatchesHeightOnResize,
					)
				})
			}
			constructor(t) {
				;(this.container = t),
					(this.swatchesContainers = this.container.querySelectorAll(Si)),
					this.swatchesContainers.forEach((t) => {
						;(this.checkSwatchesHeightOnResize = () =>
							this.checkSwatchesHeight(t)),
							this.checkSwatchesHeight(t),
							document.addEventListener(
								'theme:resize:width',
								this.checkSwatchesHeightOnResize,
							)
					})
			}
		}
	const Yi = (t) => {
			Ki = []
			t.querySelectorAll(ui).forEach((t) => {
				Ki.push(new Gi(t))
			})
		},
		Zi = {
			onLoad() {
				Yi(this.container)
			},
		},
		ts = {
			onLoad() {
				Qi[this.id] = new Ji(this.container)
			},
			onUnload() {
				Qi[this.id].onUnload()
			},
		},
		es = '[data-slider]',
		is = '[data-product-media-container]',
		ss = '[data-product-media-slideshow]',
		os = '[data-product-media-slideshow-slide]',
		ns = '[data-product-slideshow-progress]',
		rs = '.flickity-button',
		as = '[data-product]',
		ls = '[data-popup-close]',
		cs = 'fill',
		hs = 'js-quick-view-visible',
		ds = {}
	let us = class {
		productGridSlideshow() {
			const t = this.container.querySelectorAll(ss),
				i = this.container.querySelectorAll(is)
			t.length &&
				t.forEach((t) => {
					const i = t.closest(is),
						s = i.querySelector(ns),
						o = t.querySelectorAll(os).length,
						n = 2200,
						r = !this.sliders.length
					let a = new e.data(t),
						l = 0,
						c = os
					!a.isActive &&
						o > 1 &&
						((a = new e(t, {
							draggable: r,
							cellSelector: c,
							contain: !0,
							wrapAround: !0,
							imagesLoaded: !0,
							lazyLoad: !0,
							pageDots: !1,
							prevNextButtons: !1,
							adaptiveHeight: !1,
							pauseAutoPlayOnHover: !1,
							selectedAttraction: 0.2,
							friction: 1,
							on: {
								ready: () => {
									this.container.style.setProperty('--autoplay-speed', '2200ms')
								},
								change: () => {
									l && clearTimeout(l),
										s.classList.remove(cs),
										requestAnimationFrame(() => {
											s.classList.add(cs)
										}),
										(l = setTimeout(() => {
											s.classList.remove(cs)
										}, n))
								},
								dragEnd: () => {
									a.playPlayer()
								},
							},
						})),
						window.theme.touch ||
							(i.addEventListener('mouseenter', () => {
								s.classList.add(cs),
									l && clearTimeout(l),
									(l = setTimeout(() => {
										s.classList.remove(cs)
									}, n)),
									(a.options.autoPlay = n),
									a.playPlayer()
							}),
							i.addEventListener('mouseleave', () => {
								a.stopPlayer(), l && clearTimeout(l), s.classList.remove(cs)
							})))
				}),
				i.length &&
					i.forEach((t) => {
						t.addEventListener('click', (t) => {
							t.target.matches(rs) && t.preventDefault()
						})
					})
		}
		popupClose() {
			const t = document.querySelector(as)
			if (t) {
				t.querySelector(ls).dispatchEvent(new Event('click'))
			}
		}
		onBlockSelect() {
			this.body.classList.contains(hs) && this.popupClose()
		}
		onDeselect() {
			this.body.classList.contains(hs) && this.popupClose()
		}
		onUnload() {
			this.body.classList.contains(hs) && this.popupClose()
		}
		constructor(t) {
			;(this.container = t),
				(this.body = document.body),
				(this.sliders = this.container.querySelectorAll(es)),
				'slideshow' !== theme.settings.productGridHover ||
					window.theme.touch ||
					this.productGridSlideshow(),
				new Il(this.container)
		}
	}
	const ps = {
			onLoad() {
				ds[this.id] = new us(this.container)
			},
			onBlockSelect() {
				ds[this.id].onBlockSelect()
			},
			onDeselect() {
				ds[this.id].onDeselect()
			},
			onUnload() {
				ds[this.id].onUnload()
			},
		},
		ms = '#AjaxinateLoop',
		gs = '#AjaxinatePagination',
		vs = 'data-ajaxinate-id',
		ys = 'is-loaded'
	let fs = {},
		bs = class {
			init() {
				this.loadMoreFix(),
					(this.ajaxinateContainer = this.container.querySelectorAll(ms)),
					this.ajaxinateContainer.forEach((t) => {
						const e = `${ms}[${vs}="${t.dataset.ajaxinateId}"]`,
							i = `${gs}[${vs}="${t.dataset.ajaxinateId}"]`
						if (t.children.length > 0) {
							const o = new s({ container: e, pagination: i, method: 'scroll' })
							t.classList.add(ys), this.endlessScroll.push(o)
						}
					})
			}
			update(t) {
				this.ajaxinateContainer = this.container.querySelectorAll(ms)
				const e = (e) => e.settings.container === t,
					i = this.endlessScroll.find(e)
				if (i) {
					const t = this.endlessScroll.findIndex(e)
					this.endlessScroll.splice(t, 1),
						(i.settings.method = 'scroll'),
						i.destroy()
				}
				const o = [...this.ajaxinateContainer].find(
					(e) => `${ms}[${vs}="${e.dataset.ajaxinateId}"]` === t,
				)
				if (!o) return
				const n = `${ms}[${vs}="${o.dataset.ajaxinateId}"]`,
					r = `${gs}[${vs}="${o.dataset.ajaxinateId}"]`
				if (!(o.children.length > 0)) return
				const a = new s({ container: n, pagination: r, method: 'scroll' })
				o.classList.add(ys), this.endlessScroll.push(a)
			}
			loadMoreFix() {
				s.prototype.loadMore = function () {
					;(this.request = new XMLHttpRequest()),
						(this.request.onreadystatechange = function () {
							if (!this.request.responseXML) return
							if (
								4 === !this.request.readyState ||
								200 === !this.request.status
							)
								return
							const t = this.request.responseXML.querySelector(
									this.settings.container,
								),
								e = this.request.responseXML.querySelector(
									this.settings.pagination,
								)
							this.containerElement.insertAdjacentHTML(
								'beforeend',
								t.innerHTML,
							),
								null == e
									? this.removePaginationElement()
									: ((this.paginationElement.innerHTML = e.innerHTML),
									  this.settings.callback &&
											'function' == typeof this.settings.callback &&
											this.settings.callback(this.request.responseXML),
									  this.initialize())
						}.bind(this)),
						this.request.open('GET', this.nextPageUrl, !0),
						(this.request.responseType = 'document'),
						this.request.send()
				}
			}
			unload() {
				this.endlessScroll.length > 0 &&
					(this.endlessScroll.forEach((t) => {
						;(t.settings.method = 'scroll'), t.destroy()
					}),
					this.ajaxinateContainer.forEach((t) => t.classList.remove(ys)))
			}
			constructor(t) {
				;(this.container = t),
					(this.endlessScroll = []),
					theme.settings.enableInfinityScroll && this.init()
			}
		}
	const ws = {
			onLoad() {
				fs = new bs(this.container)
			},
			onUnload: function () {
				'function' == typeof fs.unload && fs.unload()
			},
		},
		Es = 300,
		Ss = '[data-toggle-filters]',
		Ls = '[data-close-filters]',
		ks = '[data-open-filters]',
		As = '[data-collection-wrapper]',
		qs = '[data-collapsible-trigger]',
		Cs = '[data-sort-toggle]',
		Ts = '[data-collection-sort-options]',
		Ps = '[data-input-sort]',
		Fs = '[data-collection-filters]',
		Is = '[data-collection-filters-list]',
		xs = '[data-collection-sticky-bar]',
		Hs = '[data-collection-filter]',
		Ds = '[data-collection-filter-tag]',
		Ms = '[data-collection-filter-tag-button]',
		Os = '[data-collection-filters-form]',
		_s = '[data-filter-reset-button]',
		Bs = '[data-filter-tag-reset-button]',
		$s = '[data-section-type="popups"]',
		zs = '[data-collection-products]',
		Rs = '[data-products-count]',
		Vs = '[data-field-price-min]',
		Ws = '[data-field-price-max]',
		Ns = '[data-se-min-value]',
		Us = '[data-se-max-value]',
		js = 'data-se-min-value',
		Ks = 'data-se-max-value',
		Qs = 'data-se-min',
		Gs = 'data-se-max',
		Xs = '[data-tooltip]',
		Js = '[data-show-more]',
		Ys = '[data-show-more-actions]',
		Zs = '[data-show-more-container]',
		to = '[data-show-more-trigger]',
		eo = '[data-search-performed]',
		io = '[data-search-form]',
		so = '[data-custom-scrollbar]',
		oo = 'is-active',
		no = 'is-expanded',
		ro = 'is-loading',
		ao = 'popup--visible',
		lo = 'collection__filters--visible',
		co = 'collection__sort__option-wrapper--visible',
		ho = 'data-filter-active',
		uo = 'data-prevent-scroll-lock',
		po = 'data-filters-default-state',
		mo = 'tabindex',
		go = 'aria-expanded',
		vo = 'data-current-type',
		yo = {}
	let fo = class {
		initFacetedFilters() {
			'tag' != this.filterMode &&
				'group' != this.filterMode &&
				this.enableFilters &&
				(this.rangeSlider = new (class {
					init() {
						if (
							((this.slider = this.container.querySelector(Ve)), !this.slider)
						)
							return
						;(this.resizeFilters = n(this.reset.bind(this), 50)),
							(this.onMoveEvent = (t) => this.onMove(t)),
							(this.onStopEvent = (t) => this.onStop(t)),
							(this.onStartEvent = (t) => this.onStart(t)),
							(this.startX = 0),
							(this.x = 0),
							(this.touchLeft = this.slider.querySelector(We)),
							(this.touchRight = this.slider.querySelector(Ne)),
							(this.lineSpan = this.slider.querySelector(Ue)),
							(this.min = parseFloat(this.slider.getAttribute(Ke))),
							(this.max = parseFloat(this.slider.getAttribute(Qe))),
							(this.step = 0),
							(this.normalizeFact = 20)
						let t = this.min
						this.slider.hasAttribute(Ge) &&
							(t = parseFloat(this.slider.getAttribute(Ge)))
						let e = this.max
						this.slider.hasAttribute(Xe) &&
							(e = parseFloat(this.slider.getAttribute(Xe))),
							t < this.min && (t = this.min),
							e > this.max && (e = this.max),
							t > e && (t = e),
							this.slider.getAttribute(Je) &&
								(this.step = Math.abs(
									parseFloat(this.slider.getAttribute(Je)),
								)),
							this.reset(),
							window.addEventListener('theme:resize', this.resizeFilters),
							(this.maxX =
								this.slider.offsetWidth - this.touchRight.offsetWidth),
							(this.selectedTouch = null),
							(this.initialValue =
								this.lineSpan.offsetWidth - this.normalizeFact),
							this.setMinValue(t),
							this.setMaxValue(e),
							this.touchLeft.addEventListener('mousedown', this.onStartEvent),
							this.touchRight.addEventListener('mousedown', this.onStartEvent),
							this.touchLeft.addEventListener('touchstart', this.onStartEvent, {
								passive: !0,
							}),
							this.touchRight.addEventListener(
								'touchstart',
								this.onStartEvent,
								{ passive: !0 },
							),
							this.slider.classList.add(ei)
					}
					reset() {
						;(this.touchLeft.style.left = '0px'),
							(this.touchRight.style.left =
								this.slider.offsetWidth - this.touchLeft.offsetWidth + 'px'),
							(this.lineSpan.style.marginLeft = '0px'),
							(this.lineSpan.style.width =
								this.slider.offsetWidth - this.touchLeft.offsetWidth + 'px'),
							(this.startX = 0),
							(this.x = 0),
							(this.maxX =
								this.slider.offsetWidth - this.touchRight.offsetWidth),
							(this.initialValue =
								this.lineSpan.offsetWidth - this.normalizeFact)
					}
					setMinValue(t) {
						const e = (t - this.min) / (this.max - this.min)
						;(this.touchLeft.style.left =
							Math.ceil(
								e *
									(this.slider.offsetWidth -
										(this.touchLeft.offsetWidth + this.normalizeFact)),
							) + 'px'),
							(this.lineSpan.style.marginLeft =
								this.touchLeft.offsetLeft + 'px'),
							(this.lineSpan.style.width =
								this.touchRight.offsetLeft - this.touchLeft.offsetLeft + 'px'),
							this.slider.setAttribute(Ge, t)
					}
					setMaxValue(t) {
						const e = (t - this.min) / (this.max - this.min)
						;(this.touchRight.style.left =
							Math.ceil(
								e *
									(this.slider.offsetWidth -
										(this.touchLeft.offsetWidth + this.normalizeFact)) +
									this.normalizeFact,
							) + 'px'),
							(this.lineSpan.style.marginLeft =
								this.touchLeft.offsetLeft + 'px'),
							(this.lineSpan.style.width =
								this.touchRight.offsetLeft - this.touchLeft.offsetLeft + 'px'),
							this.slider.setAttribute(Xe, t)
					}
					onStart(t) {
						t.preventDefault()
						let e = t
						t.touches && (e = t.touches[0]),
							t.currentTarget === this.touchLeft
								? (this.x = this.touchLeft.offsetLeft)
								: t.currentTarget === this.touchRight &&
								  (this.x = this.touchRight.offsetLeft),
							(this.startX = e.pageX - this.x),
							(this.selectedTouch = t.currentTarget),
							document.addEventListener('mousemove', this.onMoveEvent),
							document.addEventListener('mouseup', this.onStopEvent),
							document.addEventListener('touchmove', this.onMoveEvent, {
								passive: !0,
							}),
							document.addEventListener('touchend', this.onStopEvent, {
								passive: !0,
							})
					}
					onMove(t) {
						let e = t
						t.touches && (e = t.touches[0]),
							(this.x = e.pageX - this.startX),
							this.selectedTouch === this.touchLeft
								? (this.x >
								  this.touchRight.offsetLeft -
										this.selectedTouch.offsetWidth +
										10
										? (this.x =
												this.touchRight.offsetLeft -
												this.selectedTouch.offsetWidth +
												10)
										: this.x < 0 && (this.x = 0),
								  (this.selectedTouch.style.left = this.x + 'px'))
								: this.selectedTouch === this.touchRight &&
								  (this.x <
								  this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10
										? (this.x =
												this.touchLeft.offsetLeft +
												this.touchLeft.offsetWidth -
												10)
										: this.x > this.maxX && (this.x = this.maxX),
								  (this.selectedTouch.style.left = this.x + 'px')),
							(this.lineSpan.style.marginLeft =
								this.touchLeft.offsetLeft + 'px'),
							(this.lineSpan.style.width =
								this.touchRight.offsetLeft - this.touchLeft.offsetLeft + 'px'),
							this.calculateValue(),
							this.slider.getAttribute('on-change') &&
								new Function('min, max', this.slider.getAttribute('on-change'))(
									this.slider.getAttribute(Ge),
									this.slider.getAttribute(Xe),
								),
							this.onChange(
								this.slider.getAttribute(Ge),
								this.slider.getAttribute(Xe),
							)
					}
					onStop(t) {
						document.removeEventListener('mousemove', this.onMoveEvent),
							document.removeEventListener('mouseup', this.onStopEvent),
							document.removeEventListener('touchmove', this.onMoveEvent, {
								passive: !0,
							}),
							document.removeEventListener('touchend', this.onStopEvent, {
								passive: !0,
							}),
							(this.selectedTouch = null),
							this.calculateValue(),
							this.onChanged(
								this.slider.getAttribute(Ge),
								this.slider.getAttribute(Xe),
							)
					}
					onChange(t, e) {
						const i = this.slider.closest(je)
						if (i) {
							const s = i.querySelector(Ze),
								o = i.querySelector(ti)
							s && o && ((s.value = parseInt(t)), (o.value = parseInt(e)))
						}
					}
					onChanged(t, e) {
						this.slider.hasAttribute(Ye) &&
							this.slider.dispatchEvent(
								new CustomEvent('theme:filter:range-update', { bubbles: !0 }),
							)
					}
					calculateValue() {
						const t =
							(this.lineSpan.offsetWidth - this.normalizeFact) /
							this.initialValue
						let e = this.lineSpan.offsetLeft / this.initialValue,
							i = e + t
						if (
							((e = e * (this.max - this.min) + this.min),
							(i = i * (this.max - this.min) + this.min),
							0 !== this.step)
						) {
							let t = Math.floor(e / this.step)
							;(e = this.step * t),
								(t = Math.floor(i / this.step)),
								(i = this.step * t)
						}
						this.selectedTouch === this.touchLeft &&
							this.slider.setAttribute(Ge, e),
							this.selectedTouch === this.touchRight &&
								this.slider.setAttribute(Xe, i)
					}
					unload() {
						document.removeEventListener(
							'theme:filters:init',
							this.initListener,
						),
							window.removeEventListener('theme:resize', this.resizeFilters)
					}
					constructor(t) {
						;(this.container = t),
							this.init(),
							(this.initListener = () => this.init()),
							document.addEventListener('theme:filters:init', this.initListener)
					}
				})(this.container))
		}
		initTooltips() {
			var t, e
			;((this.tooltips = this.container.querySelectorAll(Xs)),
			window.innerWidth < theme.sizes.small) &&
				(this.tooltips =
					null === (e = this.productGrid) || void 0 === e
						? void 0
						: e.querySelectorAll(Xs))
			null === (t = this.tooltips) ||
				void 0 === t ||
				t.forEach((t) => {
					new ze(t)
				})
		}
		updateRange() {
			const t = this.filtersForm.querySelector(Ns),
				e = this.filtersForm.querySelector(Us),
				i = this.filtersForm.querySelector(Vs),
				s = this.filtersForm.querySelector(Ws)
			if (t.hasAttribute(js) && e.hasAttribute(Ks)) {
				const o = parseFloat(i.placeholder, 10),
					n = parseFloat(s.placeholder, 10),
					r = parseFloat(t.getAttribute(js), 10),
					a = parseFloat(e.getAttribute(Ks), 10)
				;(o === r && n === a) ||
					((i.value = parseInt(r)),
					(s.value = parseInt(a)),
					this.filtersForm.dispatchEvent(new Event('input', { bubbles: !0 })))
			}
		}
		onSubmitHandler(t) {
			t.preventDefault()
			const e = new FormData(this.filtersForm),
				i = new URLSearchParams(e),
				s = []
			let o = ''
			this.isSearchPage &&
				((this.searchForm = this.container.querySelector(io)),
				(this.currentType = this.container.getAttribute(vo)))
			const n = this.filtersForm.querySelector(Ns),
				r = this.filtersForm.querySelector(Us),
				a = this.filtersForm.querySelector(Vs),
				l = this.filtersForm.querySelector(Ws)
			if (n && r && a && l && n.hasAttribute(Qs) && r.hasAttribute(Gs)) {
				const t = parseFloat(n.getAttribute(Qs), 10),
					e = parseFloat(r.getAttribute(Gs), 10),
					o = a.value ? parseFloat(a.value, 10) : t,
					c = l.value ? parseFloat(l.value, 10) : e
				o <= t &&
					c >= e &&
					(s.push('filter.v.price.gte'),
					s.push('filter.v.price.lte'),
					i.delete('filter.v.price.gte'),
					i.delete('filter.v.price.lte'))
			}
			if (((o = i.toString()), this.isSearchPage)) {
				o = Se(this.searchForm, this.filtersForm, s)
				let t = ''
				'all' === this.currentType && (t = '&type=product'),
					o.indexOf('&type=product') > -1 && (t = ''),
					(o += t)
			}
			this.renderSection(o, t)
		}
		onHistoryChange(t) {
			var e
			if (!this.filters) return
			let i =
				(null === (e = t.state) || void 0 === e ? void 0 : e.searchParams) || ''
			if (this.isSearchPage) {
				t.state || (i = window.location.search)
				if (!(i.indexOf('type=product') > -1)) return
			}
			this.renderSection(i, null, !1)
		}
		renderSection(t, e, i = !0) {
			this.startLoading()
			const s = `${window.location.pathname}?section_id=${this.sectionId}&${t}`,
				o = (t) => t.url === s
			this.filterData.some(o)
				? this.renderSectionFromCache(o, e)
				: this.renderSectionFromFetch(s, e),
				i && this.updateURLHash(t)
		}
		renderSectionFromFetch(t) {
			fetch(t)
				.then((t) => t.text())
				.then((e) => {
					const i = e
					;(this.filterData = [...this.filterData, { html: i, url: t }]),
						(this.inputSort = this.container.querySelectorAll(Ps)),
						this.renderFilters(i),
						this.bindFilterButtonsEvents(),
						this.hideFiltersOnMobile(),
						this.renderProductGrid(i),
						this.updateProductsCount(i),
						this.finishLoading(),
						this.mobileFiltersScrollLock(),
						this.handleSearchPageActiveTab()
				})
		}
		renderSectionFromCache(t, e) {
			const i = this.filterData.find(t).html
			this.renderFilters(i, e),
				this.hideFiltersOnMobile(),
				this.renderProductGrid(i),
				this.updateProductsCount(i),
				this.finishLoading(),
				this.mobileFiltersScrollLock(),
				this.handleSearchPageActiveTab()
		}
		handleSearchPageActiveTab() {
			this.isSearchPage &&
				((this.scrollable = this.container.querySelector(so)),
				this.scrollable &&
					!this.customScrollbar &&
					(this.customScrollbar = new Ce(this.container)))
		}
		renderProductGrid(t) {
			const e = new DOMParser()
				.parseFromString(t, 'text/html')
				.querySelector(zs)
			e &&
				((this.productGrid.innerHTML = e.innerHTML),
				this.initProductGridEvents(theme.settings.enableInfinityScroll),
				this.filterShowMore())
		}
		updateProductsCount(t) {
			const e = new DOMParser()
				.parseFromString(t, 'text/html')
				.querySelector(Rs)
			e && (this.productsCount.innerHTML = e.innerHTML)
		}
		renderFilters(t) {
			const e = new DOMParser()
				.parseFromString(t, 'text/html')
				.querySelector(Fs)
			e &&
				((this.filters.innerHTML = e.innerHTML),
				(this.filtersForm = document.querySelector(Os)),
				this.bindFilterButtonsEvents(),
				this.bindToggleButtonsEvents(),
				Yi(this.container),
				(this.collapsible = new Ct(this.container)),
				document.dispatchEvent(
					new CustomEvent('theme:filters:init', { bubbles: !0 }),
				))
		}
		updateURLHash(t) {
			history.pushState(
				{ searchParams: t },
				'',
				`${window.location.pathname}${t && '?'.concat(t)}`,
			)
		}
		bindFilterButtonsEvents() {
			this.inputSort.length > 0 &&
				this.inputSort.forEach((t) => {
					t.addEventListener('change', this.updateCollectionFormSortEvent)
				}),
				this.filtersForm &&
					(this.filtersForm.addEventListener(
						'input',
						this.debouncedSubmitEvent.bind(this),
					),
					this.filtersForm.addEventListener(
						'theme:filter:range-update',
						this.updateRangeEvent,
					)),
				this.collectionSortOptions &&
					this.collectionSortOptions.addEventListener(
						'keyup',
						this.onTabHandlerEvent,
					),
				'tag' != this.filterMode &&
					'group' != this.filterMode &&
					this.enableFilters &&
					this.container.querySelectorAll(_s).forEach((t) => {
						t.addEventListener('click', this.onFilterResetClick, { once: !0 })
					})
		}
		onFilterResetClick(t) {
			t.preventDefault(),
				this.renderSection(
					new URL(t.currentTarget.href).searchParams.toString(),
				)
		}
		bindToggleButtonsEvents() {
			var t
			this.container.querySelectorAll(Ss).forEach((t) => {
				t.addEventListener('click', this.onFilterToggleClick)
			}),
				this.container.querySelectorAll(Ls).forEach((t) => {
					t.addEventListener('click', this.hideFiltersDrawer)
				}),
				this.container.querySelectorAll(ks).forEach((t) => {
					t.addEventListener('click', this.showFiltersDrawer)
				}),
				null === (t = this.container.querySelector(As)) ||
					void 0 === t ||
					t.addEventListener('keyup', this.onKeyUpHandler)
		}
		onTabHandler(t) {
			if (
				t.code === theme.keyboardKeys.SPACE ||
				t.code === theme.keyboardKeys.ENTER ||
				t.code === theme.keyboardKeys.NUMPADENTER
			) {
				const e = t.target.previousElementSibling.value
				this.filtersForm.querySelectorAll(Ps).forEach((t) => {
					t.checked && (t.checked = !1), t.value === e && (t.checked = !0)
				}),
					this.filtersForm.dispatchEvent(new Event('input', { bubbles: !0 })),
					t.target.dispatchEvent(new Event('click', { bubbles: !0 }))
			}
		}
		onKeyUpHandler(t) {
			t.code === theme.keyboardKeys.ESCAPE && this.hideFiltersDrawer()
		}
		onFilterToggleClick(t) {
			t.preventDefault(), b()
			this.filters.classList.contains(lo)
				? this.hideFiltersDrawer()
				: this.showFiltersDrawer()
		}
		sortDropdownToggle() {
			this.collectionSortOptions &&
				this.collectionSortOptions.classList.toggle(co)
		}
		bodyClick(t) {
			if (!this.collectionSortOptions) return
			const e = this.sortToggle.contains(t.target)
			this.collectionSortOptions.classList.contains(co) &&
				!e &&
				this.sortDropdownToggle()
		}
		updateCollectionFormSort(t) {
			const e = t.target,
				i = e.value,
				s = e.closest(Ts)
			this.container.querySelectorAll(Ps).forEach((t) => {
				t.value === i && (t.checked = !0)
			}),
				null !== s &&
					this.filtersForm.dispatchEvent(new Event('input', { bubbles: !0 }))
		}
		showFiltersDrawer() {
			;(this.a11y.state.trigger = document.querySelector(Ss)),
				this.a11y.trapFocus({ container: this.filters }),
				this.mobileFiltersScrollLock()
		}
		mobileFiltersScrollLock() {
			if (window.innerWidth < theme.sizes.small) {
				const t = document.querySelector(Is)
				this.filters.classList.contains(lo) || this.filters.classList.add(lo),
					document.dispatchEvent(
						new CustomEvent('theme:scroll:lock', { bubbles: !0, detail: t }),
					)
			}
		}
		hideFiltersOnMobile() {
			const t = this.container.querySelectorAll(`${qs}:not(${to})`)
			window.innerWidth < theme.sizes.small &&
				requestAnimationFrame(() => {
					t.forEach((t) => {
						const e = 'true' === t.getAttribute(ho)
						t.classList.contains(no) &&
							!e &&
							t.dispatchEvent(new Event('click'))
					})
				})
		}
		showFiltersOnDesktop() {
			const t = this.container.querySelectorAll(`${qs}:not(${to})`),
				e = this.container.getAttribute(po),
				i = 'first-open' === e,
				s = 'open' === e,
				o = 'closed' === e,
				n = this.enableSorting ? 1 : 0
			t.forEach((t, e) => {
				const r = t.classList.contains(no),
					a = 'true' === t.getAttribute(ho),
					l = a && !r && s
				;(a && !l) ||
					(((o && r) ||
						(i && !r && e === n) ||
						(i && r && e !== n) ||
						(s && !r) ||
						l) &&
						t.dispatchEvent(new Event('click')))
			})
		}
		hideFiltersDrawer() {
			let t = this.filters.classList.contains(lo),
				e = this.container.classList.contains(ro)
			t && (this.filters.classList.remove(lo), this.a11y.removeTrapFocus()),
				e ||
					document.dispatchEvent(
						new CustomEvent('theme:scroll:unlock', { bubbles: !0, detail: Es }),
					)
		}
		filtersResizeEvents() {
			window.innerWidth >= theme.sizes.small
				? (this.showFiltersOnDesktop(), this.hideFiltersDrawer())
				: this.hideFiltersOnMobile()
		}
		filterShowMore() {
			;(this.showMore = this.container.querySelectorAll(Js)),
				0 !== this.showMore.length &&
					this.showMore.forEach((t) => {
						const e = t.querySelector(qs),
							i = t.querySelector(Ys)
						if (!i) return
						const s = i.querySelector(to),
							o = i.querySelector(Zs),
							n = o.querySelectorAll(window.theme.focusable)
						'true' === o.getAttribute(go) ||
							n.forEach((t) => {
								t.setAttribute(mo, '-1')
							}),
							s.addEventListener('keyup', (t) => {
								;(t.code !== theme.keyboardKeys.SPACE &&
									t.code !== theme.keyboardKeys.ENTER &&
									t.code !== theme.keyboardKeys.NUMPADENTER) ||
									this.updateShowMoreFocusableElements(t, n)
							}),
							s.addEventListener('click', (t) => {
								this.updateShowMoreFocusableElements(t, n)
							}),
							e.addEventListener('keyup', (t) => {
								;(t.code !== theme.keyboardKeys.SPACE &&
									t.code !== theme.keyboardKeys.ENTER &&
									t.code !== theme.keyboardKeys.NUMPADENTER) ||
									this.updateCollapsedContainerFocusableElements(e, s, n)
							}),
							e.addEventListener('click', () => {
								this.updateCollapsedContainerFocusableElements(e, s, n)
							})
					})
		}
		updateCollapsedContainerFocusableElements(t, e, i) {
			requestAnimationFrame(() => {
				const s = 'true' === t.getAttribute(go),
					o = 'true' === e.getAttribute(go)
				i.forEach((t) => {
					!s && o && t.setAttribute(mo, '-1'), s && o && t.removeAttribute(mo)
				})
			})
		}
		updateShowMoreFocusableElements(t, e) {
			requestAnimationFrame(() => {
				requestAnimationFrame(() => {
					const i = 'true' === t.target.getAttribute(go)
					e.forEach((t, e) => {
						if (i) return t.removeAttribute(mo), void (0 === e && t.focus())
						t.setAttribute(mo, '-1')
					})
				})
			})
		}
		initTagFilters() {
			;('tag' != this.filterMode && 'group' != this.filterMode) ||
				!this.enableFilters ||
				((this.tags = this.container.dataset.tags.split('+').filter((t) => t)),
				this.bindFilterTagButtonsEvents(),
				this.bindSortChangeEvent())
		}
		renderTagFiltersProducts(t) {
			this.startLoading(),
				'object' == typeof this.endlessCollection &&
					this.endlessCollection.unload(),
				fetch(t)
					.then((t) => t.text())
					.then((e) => {
						const i = e,
							s = new DOMParser().parseFromString(i, 'text/html'),
							o = s.querySelector(zs).innerHTML,
							n = s.querySelector(Fs).innerHTML
						;(this.productGrid.innerHTML = o),
							(this.filters.innerHTML = n),
							(this.inputSort = this.container.querySelectorAll(Ps)),
							(this.filtersForm = document.querySelector(Os)),
							(this.filterData = [...this.filterData, { html: i, url: t }]),
							(this.alreadyClicked = !1),
							this.bindFilterTagButtonsEvents(),
							this.bindFilterButtonsEvents(),
							this.bindSortChangeEvent(),
							this.bindToggleButtonsEvents(),
							this.initProductGridEvents(theme.settings.enableInfinityScroll),
							this.updateProductsCount(i),
							this.mobileFiltersScrollLock(),
							this.hideFiltersOnMobile(),
							Yi(this.container),
							(this.collapsible = new Ct(this.container)),
							this.filterShowMore(),
							history.replaceState &&
								window.history.pushState({ path: t }, '', t)
					})
					.catch((t) => {
						this.finishLoading(), console.log(`Error: ${t}`)
					})
		}
		bindFilterTagButtonsEvents() {
			this.container.querySelectorAll(Ms).forEach((t) => {
				t.addEventListener('click', this.onFilterTagButtonClick.bind(this))
			}),
				this.container.querySelectorAll(Bs).forEach((t) => {
					t.addEventListener('click', this.onFilterTagClearClick)
				}),
				this.container.querySelectorAll(_s).forEach((t) => {
					t.addEventListener('click', this.onFilterTagResetClick)
				})
		}
		bindSortChangeEvent() {
			this.container.querySelectorAll(Ps).forEach((t) => {
				t.addEventListener('input', this.debouncedSortEvent.bind(this))
			})
		}
		onFilterTagButtonClick(t) {
			if ((t.preventDefault(), this.alreadyClicked)) return
			this.alreadyClicked = !0
			const e = t.currentTarget,
				i = e.dataset.tag
			if (e.parentNode.classList.contains(oo)) {
				let t = this.tags.indexOf(i)
				e.parentNode.classList.remove(oo), t > -1 && this.tags.splice(t, 1)
			} else e.parentNode.classList.add(oo), this.tags.push(i)
			let s =
				this.collectionHandle +
				'/' +
				this.tags.join('+') +
				'?sort_by=' +
				this.getSortValue()
			this.container.querySelector(Hs).classList.remove(no),
				this.container.querySelector(Hs).setAttribute(go, !1),
				this.container.setAttribute('data-tags', '[' + this.tags + ']'),
				this.renderTagFiltersProducts(s)
		}
		onFilterTagClearClick(t) {
			if ((t.preventDefault(), this.alreadyClicked)) return
			this.alreadyClicked = !0
			const e = t.currentTarget.dataset.tag,
				i = this.tags.indexOf(e)
			i > -1 && this.tags.splice(i, 1)
			const s =
				this.collectionHandle +
				'/' +
				this.tags.join('+') +
				'?sort_by=' +
				this.getSortValue()
			this.container.setAttribute('data-tags', '[' + this.tags + ']'),
				this.renderTagFiltersProducts(s)
		}
		onSortChange() {
			let t =
				this.collectionHandle +
				'/' +
				this.tags.join('+') +
				'?sort_by=' +
				this.getSortValue()
			this.renderTagFiltersProducts(t)
		}
		getSortValue() {
			let t = ''
			return (
				this.inputSort.forEach((e) => {
					e.checked && (t = e.value)
				}),
				t
			)
		}
		onFilterTagResetClick(t) {
			if ((null == t || t.preventDefault(), this.alreadyClicked)) return
			;(this.alreadyClicked = !0),
				this.container.querySelectorAll(Ds).forEach((t) => {
					t.classList.remove(oo)
				}),
				this.container.querySelectorAll(Hs).forEach((t) => {
					t.classList.remove(no), t.setAttribute(go, !1)
				}),
				(this.tags = []),
				this.container.setAttribute('data-tags', '')
			let e = this.collectionHandle + '/?sort_by=' + this.getSortValue()
			this.renderTagFiltersProducts(e)
		}
		getProductsOffsetTop() {
			return (
				this.productGrid.getBoundingClientRect().top -
				document.body.getBoundingClientRect().top -
				this.filtersStickyBar.offsetHeight
			)
		}
		getStickyBarOffsetTop() {
			return (
				this.filtersStickyBar.getBoundingClientRect().top -
				document.body.getBoundingClientRect().top
			)
		}
		initProductGridEvents(t) {
			if (t)
				return this.initInfinityScroll(), void this.initProductGridEvents(!1)
			;(this.productGridEvents = new us(this.container)),
				this.initTooltips(),
				setTimeout(() => {
					this.finishLoading()
				}, 1.5 * Es)
		}
		initInfinityScroll() {
			if (this.isSearchPage) {
				if (!this.enableFilters) return
				document.dispatchEvent(
					new CustomEvent('theme:tab:ajaxinate', {
						bubbles: !0,
						detail: 'product',
					}),
				)
			} else
				'object' == typeof this.endlessCollection &&
					this.endlessCollection.unload(),
					(this.endlessCollection = new bs(this.container)),
					0 !== this.endlessCollection.endlessScroll.length &&
						(this.endlessCollection.endlessScroll[0].settings.callback = () =>
							this.initProductGridEvents(!1))
		}
		startLoading() {
			this.container.classList.add(ro),
				window.innerWidth >= theme.sizes.small &&
					document.dispatchEvent(
						new CustomEvent('theme:scroll:lock', { bubbles: !0 }),
					)
			let t = this.getProductsOffsetTop()
			window.scrollTo({ top: t, left: 0, behavior: 'smooth' })
		}
		finishLoading() {
			const t = document.querySelectorAll(`${$s} .${ao}`),
				e = t.length > 0
			if ((this.container.classList.remove(ro), e)) {
				let e = 0
				;[...t].forEach((t) => {
					t.hasAttribute(uo) && (e += 1)
				}),
					e === t.length &&
						document.dispatchEvent(
							new CustomEvent('theme:scroll:unlock', {
								bubbles: !0,
								detail: Es,
							}),
						)
			} else
				window.innerWidth >= theme.sizes.small &&
					document.dispatchEvent(
						new CustomEvent('theme:scroll:unlock', { bubbles: !0, detail: Es }),
					)
		}
		onDeselect() {
			this.productGridEvents && this.productGridEvents.onDeselect()
		}
		onUnload() {
			'object' == typeof this.endlessCollection &&
				this.endlessCollection.unload(),
				this.productGridEvents && this.productGridEvents.onUnload(),
				this.collapsible && this.collapsible.onUnload(),
				this.rangeSlider && this.rangeSlider.unload(),
				this.filters &&
					document.removeEventListener('theme:resize:width', this.resizeEvent),
				document.removeEventListener('click', this.bodyClickEvent),
				this.groupTagFilters.length > 0 && this.onFilterTagResetClick(),
				this.finishLoading()
		}
		constructor(t) {
			var e
			;(this.container = t),
				(this.sectionId = t.dataset.sectionId),
				(this.enableFilters = 'true' === t.dataset.enableFilters),
				(this.enableSorting = 'true' === t.dataset.enableSorting),
				(this.filterMode = t.dataset.filterMode),
				(this.collectionHandle = this.container.dataset.collection),
				(this.isSearchPage = null != t.closest(eo)),
				(this.productGrid = this.container.querySelector(zs)),
				(this.productsCount = this.container.querySelector(Rs)),
				(this.groupTagFilters = this.container.querySelectorAll(Hs)),
				(this.filters = this.container.querySelector(Fs)),
				(this.filterTriggers = this.container.querySelectorAll(qs)),
				(this.filtersStickyBar = this.container.querySelector(xs)),
				(this.filtersForm = this.container.querySelector(Os)),
				(this.inputSort = this.container.querySelectorAll(Ps)),
				(this.sortToggle = this.container.querySelector(Cs)),
				(this.collectionSortOptions = this.container.querySelector(Ts)),
				(this.a11y = _t),
				(this.filterData = []),
				(this.rangeSlider = null),
				(this.sortDropdownEvent = () => this.sortDropdownToggle()),
				(this.onTabHandlerEvent = (t) => this.onTabHandler(t)),
				(this.updateCollectionFormSortEvent = (t) =>
					this.updateCollectionFormSort(t)),
				(this.bodyClickEvent = (t) => this.bodyClick(t)),
				(this.onFilterResetClick = this.onFilterResetClick.bind(this)),
				(this.onFilterTagResetClick = this.onFilterTagResetClick.bind(this)),
				(this.onFilterTagClearClick = this.onFilterTagClearClick.bind(this)),
				(this.onFilterToggleClick = this.onFilterToggleClick.bind(this)),
				(this.onKeyUpHandler = this.onKeyUpHandler.bind(this)),
				(this.updateRangeEvent = this.updateRange.bind(this)),
				(this.debouncedSubmitEvent = n((t) => {
					this.onSubmitHandler(t)
				}, 500)),
				(this.debouncedSortEvent = n((t) => {
					this.onSortChange(t)
				}, 500)),
				(this.productGridEvents = {}),
				this.filters &&
					((this.hideFiltersDrawer = this.hideFiltersDrawer.bind(this)),
					(this.showFiltersDrawer = this.showFiltersDrawer.bind(this)),
					(this.resizeEvent = n(() => {
						this.filtersResizeEvents()
					}, 500)),
					this.filtersResizeEvents(),
					document.addEventListener('theme:resize:width', this.resizeEvent)),
				this.initTagFilters(),
				this.initFacetedFilters(),
				this.bindToggleButtonsEvents(),
				this.bindFilterButtonsEvents(),
				this.initProductGridEvents(theme.settings.enableInfinityScroll),
				Yi(this.container),
				(this.collapsible = new Ct(this.container)),
				b(),
				window.addEventListener('popstate', this.onHistoryChange.bind(this)),
				null === (e = this.sortToggle) ||
					void 0 === e ||
					e.addEventListener('click', this.sortDropdownEvent),
				document.addEventListener('click', this.bodyClickEvent),
				this.filterShowMore()
		}
	}
	const bo = {
			onLoad() {
				yo[this.id] = new fo(this.container)
			},
			onDeselect() {
				yo[this.id].onDeselect()
			},
			onUnload() {
				yo[this.id].onUnload()
			},
		},
		wo = '[data-tabs-link]',
		Eo = '[data-tab]',
		So = '[data-tab-ref]',
		Lo = '[data-custom-scrollbar]',
		ko = '[data-custom-scrollbar-holder]',
		Ao = '[data-slider]',
		qo = '[data-tabs-contents]',
		Co = '[data-search-form]',
		To = '[data-all-types-container]',
		Po = '[data-collection-filters-form]',
		Fo = '[data-current-page]',
		Io = '[data-tooltip]',
		xo = '[data-collection-products]',
		Ho = '#AjaxinateLoop',
		Do = 'current',
		Mo = 'hide',
		Oo = 'alt',
		_o = 'aos-animate',
		Bo = 'aos-init',
		$o = 'is-loaded',
		zo = 'data-tabs-link',
		Ro = 'data-tab',
		Vo = 'data-tab-ref',
		Wo = 'data-start-index',
		No = 'data-search-performed',
		Uo = 'data-type',
		jo = 'data-current-type',
		Ko = 'data-all-types',
		Qo = 'data-current-page',
		Go = 'data-ajaxinate-id',
		Xo = {}
	let Jo = class {
		assignSearchPageArguments() {
			this.isSearchPage &&
				((this.searchForm = this.container.querySelector(Co)),
				(this.searchFormData = new FormData(this.searchForm)),
				(this.searchTerm = encodeURIComponent(this.searchFormData.get('q'))),
				(this.currentType = this.container.getAttribute(jo)),
				(this.sectionId = this.container.dataset.sectionId),
				(this.searchForAllTypes = 'true' === this.container.getAttribute(Ko)),
				(this.fetchURL = ''),
				(this.searchParams = ''),
				(this.cachedResults = {}),
				this.handleTabsHistory(),
				this.infiniteScrollListener(),
				this.initInfinityScroll(this.currentType))
		}
		init() {
			const t = this.container.querySelectorAll(wo),
				e = this.container.querySelector(
					`[${zo}="${
						this.container.hasAttribute(Wo)
							? this.container.getAttribute(Wo)
							: 0
					}"]`,
				),
				i = this.container.querySelector(
					`[${Ro}="${
						this.container.hasAttribute(Wo)
							? this.container.getAttribute(Wo)
							: 0
					}"]`,
				)
			null == i || i.classList.add(Do),
				null == e || e.classList.add(Do),
				this.checkVisibleTabsLinks(),
				t.forEach((t) => {
					this.handleTabsNavListeners(t)
				})
		}
		handleTabsHistory() {
			window.addEventListener('popstate', this.onHistoryChange.bind(this)),
				(this.openTabFromHistoryEvent = (t) => this.openTabFromHistory(t)),
				this.tabsLink.forEach((t) => {
					t.addEventListener(
						'theme:tab:open-from-history',
						this.openTabFromHistoryEvent,
					)
				})
		}
		handleTabsNavListeners(t) {
			const e = t.getAttribute(zo),
				i = this.container.querySelector(`[${Ro}="${e}"]`)
			i &&
				(t.addEventListener('click', (e) => {
					this.isSearchPage && this.handleURLSearchParams(e, !0),
						this.tabChange(t, i)
				}),
				t.addEventListener('keyup', (e) => {
					;(e.code !== theme.keyboardKeys.SPACE &&
						e.code !== theme.keyboardKeys.ENTER &&
						e.code !== theme.keyboardKeys.NUMPADENTER) ||
						(this.isSearchPage && this.handleURLSearchParams(e, !0),
						this.tabChange(t, i))
				}))
		}
		openTabFromHistory(t) {
			const e = t.target,
				i = this.container.querySelector(t.detail.element).getAttribute(zo),
				s = this.container.querySelector(`[${Ro}="${i}"]`)
			s && (this.handleURLSearchParams(t, !1), this.tabChange(e, s))
		}
		handleURLSearchParams(t, e = !0) {
			const i = t.target.matches(wo) ? t.target : t.target.closest(wo),
				s = i.getAttribute(Uo),
				o = i.getAttribute(zo),
				n = this.container.querySelector(`[${Ro}="${o}"]`).querySelector(Fo),
				r = document.querySelector(Po)
			let a = n ? `&page=${n.getAttribute(Qo)}` : ''
			if (
				((this.searchParams = Se(this.searchForm, r, [], s)), 'product' === s)
			) {
				const t = this.searchParams.replace('&type=product', '')
				this.searchParams = `${t}&type=product`
			} else this.searchParams = `q=${this.searchTerm}&type=${s}`
			theme.settings.enableInfinityScroll ||
				'' === a ||
				(this.searchParams += a),
				(this.fetchURL = `${theme.routes.searchUrl}?${this.searchParams}&section_id=${this.sectionId}`),
				e &&
					history.pushState(
						{ searchParams: this.searchParams },
						'',
						`${window.location.pathname}${
							this.searchParams && '?'.concat(this.searchParams)
						}`,
					)
		}
		tabChangeFetchContent(t, e) {
			const i = t.getAttribute(Uo),
				s = t.getAttribute(zo),
				o = this.container.querySelector(`[${Ro}="${s}"]`),
				n = this.currentType === i
			if (this.cachedResults[s] || n)
				return (
					'product' !== i ||
						this.searchFilters ||
						(this.searchFilters = new fo(this.container)),
					void requestAnimationFrame(() => {
						this.handleActiveTabClasses(t, e),
							this.scrollToCurrentTabLink(t),
							this.triggerTabAnimations(e),
							this.checkVisibleTabsLinks(),
							this.updateAjaxify(e, i)
					})
				)
			fetch(this.fetchURL)
				.then((t) => {
					if (!t.ok) {
						throw new Error(t.status)
					}
					return t.text()
				})
				.then((n) => {
					const r = new DOMParser()
						.parseFromString(n, 'text/html')
						.querySelector(`[${Ro}="${s}"]`).innerHTML
					var a
					this.searchForAllTypes &&
						(null === (a = this.container.querySelector(To)) ||
							void 0 === a ||
							a.remove())
					;(this.cachedResults[s] = r),
						(o.innerHTML = r),
						'product' !== i ||
							this.searchFilters ||
							(this.searchFilters = new fo(this.container)),
						requestAnimationFrame(() => {
							this.handleActiveTabClasses(t, e),
								this.scrollToCurrentTabLink(t),
								this.triggerTabAnimations(e),
								this.checkVisibleTabsLinks(),
								this.initInfinityScroll(i)
						})
				})
				.catch((t) => {
					throw t
				})
		}
		onHistoryChange(t) {
			var e
			const i =
					(null === (e = t.state) || void 0 === e ? void 0 : e.searchParams) ||
					window.location.search,
				s = i.indexOf('type=product') > -1,
				o = i.indexOf('type=article') > -1,
				n = i.indexOf('type=page') > -1,
				r = s || o || n,
				a = this.container.querySelector(`${wo}[${Uo}="product"]`),
				l = this.container.querySelector(`${wo}[${Uo}="article"]`),
				c = this.container.querySelector(`${wo}[${Uo}="page"]`)
			r
				? (s &&
						(null == a ||
							a.dispatchEvent(
								new CustomEvent('theme:tab:open-from-history', {
									bubbles: !0,
									detail: { element: `[${Uo}="product"]` },
								}),
							)),
				  o &&
						(null == l ||
							l.dispatchEvent(
								new CustomEvent('theme:tab:open-from-history', {
									bubbles: !0,
									detail: { element: `[${Uo}="article"]` },
								}),
							)),
				  n &&
						(null == c ||
							c.dispatchEvent(
								new CustomEvent('theme:tab:open-from-history', {
									bubbles: !0,
									detail: { element: `[${Uo}="page"]` },
								}),
							)))
				: (window.location = i)
		}
		initCustomScrollbar() {
			this.scrollable &&
				!this.customScrollbar &&
				(this.customScrollbar = new Ce(this.container))
		}
		infiniteScrollListener() {
			theme.settings.enableInfinityScroll &&
				((this.ajaxifyFromFiltersEvent = (t) => this.ajaxifyFromFilters(t)),
				document.addEventListener(
					'theme:tab:ajaxinate',
					this.ajaxifyFromFiltersEvent,
				))
		}
		ajaxifyFromFilters(t) {
			this.initInfinityScroll(t.detail)
		}
		initInfinityScroll(t) {
			if (!theme.settings.enableInfinityScroll) return
			if (0 === this.container.querySelectorAll(Ho).length) return
			const e = this.container.querySelector(`${Eo}.${Do}`),
				i = null == e ? void 0 : e.querySelector(Ho),
				s = null == i ? void 0 : i.classList.contains($o)
			e
				? (!i &&
						this.endlessCollection &&
						this.updateAjaxinateInstancesSettings(t),
				  i && !s && this.initAjaxyfy(t))
				: this.initAjaxyfy(t)
		}
		updateAjaxinateInstancesSettings(t) {
			setTimeout(() => {
				if (0 === this.endlessCollection.endlessScroll.length) return
				;[...this.endlessCollection.endlessScroll].forEach((t) => {
					const e = t.containerElement,
						i = [...this.tab].find((t) => t.classList.contains(Do))
					!(null !== e.closest(`${Eo}.${Do}`)) &&
						i &&
						(t.settings.method = 'click')
				})
				const e = () => this.initProductGridEvents()
				if ('product' === t || 'all' === t) {
					const t = (t) =>
							t.settings.container.indexOf('resultsProducts') > -1 ||
							t.settings.container.indexOf('allTypes') > -1,
						i = [...this.endlessCollection.endlessScroll].find(t)
					if (!i) return
					i.settings.callback = e
				}
			})
		}
		initAjaxyfy(t) {
			if ('object' != typeof this.endlessCollection)
				return (
					(this.endlessCollection = new bs(this.container)),
					void this.updateAjaxinateInstancesSettings(t)
				)
			this.endlessCollection.endlessScroll.length > 0 &&
				(this.endlessCollection.unload(),
				(this.endlessCollection = new bs(this.container)),
				this.updateAjaxinateInstancesSettings(t))
		}
		updateAjaxify(t, e) {
			var i
			if (
				0 ===
				(null === (i = this.endlessCollection) || void 0 === i
					? void 0
					: i.endlessScroll.length)
			)
				return
			const s = t.querySelector(Ho),
				o = `${Ho}[${Go}="${null == s ? void 0 : s.dataset.ajaxinateId}"]`
			s &&
				(this.endlessCollection.update(o),
				this.updateAjaxinateInstancesSettings(e))
		}
		initProductGridEvents() {
			;(this.productGridEvents = new us(this.container)), this.initTooltips()
		}
		initTooltips() {
			var t, e
			;((this.tooltips = this.container.querySelectorAll(Io)),
			(this.productGrid = this.container.querySelector(xo)),
			window.innerWidth < theme.sizes.small) &&
				(this.tooltips =
					null === (e = this.productGrid) || void 0 === e
						? void 0
						: e.querySelectorAll(Io))
			null === (t = this.tooltips) ||
				void 0 === t ||
				t.forEach((t) => {
					new ze(t)
				})
		}
		tabChange(t, e) {
			t.classList.contains(Do) ||
				(this.isSearchPage
					? this.tabChangeFetchContent(t, e)
					: (this.handleActiveTabClasses(t, e),
					  this.scrollToCurrentTabLink(t),
					  this.triggerTabAnimations(e),
					  this.handleTabSliders(e),
					  this.checkVisibleTabsLinks()))
		}
		handleActiveTabClasses(t, e) {
			var i
			const s = this.container.querySelector(`${Eo}.${Do}`),
				o = this.container.querySelector(`${wo}.${Do}`)
			null == s || s.classList.remove(Do),
				null == o || o.classList.remove(Do),
				t.classList.add(Do),
				e.classList.add(Do),
				t.classList.contains(Mo) && e.classList.add(Mo),
				null === (i = this.tabRef) ||
					void 0 === i ||
					i.forEach((t) => {
						const i = t.classList.contains(Do),
							s = t.getAttribute(Vo) === e.getAttribute(Ro)
						t.classList.toggle(Do, !i && s)
					})
		}
		scrollToCurrentTabLink(t) {
			const e = t.closest(ko) ? t.closest(ko) : t.parentElement,
				i = parseInt(
					window.getComputedStyle(e).getPropertyValue('padding-left'),
				)
			e.scrollTo({
				top: 0,
				left: t.offsetLeft - e.offsetWidth / 2 + t.offsetWidth / 2 + i,
				behavior: 'smooth',
			}),
				t.dispatchEvent(
					new CustomEvent('theme:custom-scrollbar:change', {
						bubbles: !0,
						detail: { element: t },
					}),
				)
		}
		triggerTabAnimations(t) {
			'false' != theme.settings.animations &&
				(this.tabsContents.querySelectorAll(`.${Bo}`).forEach((t) => {
					t.classList.remove(_o)
				}),
				this.animateElementsTimer && clearTimeout(this.animateElementsTimer),
				(this.animateElementsTimer = setTimeout(() => {
					t.querySelectorAll(`.${Bo}`).forEach((t) => {
						t.classList.add(_o)
					})
				}, 150)))
		}
		handleTabSliders(t) {
			const e = t.querySelector(Ao)
			e && e.dispatchEvent(new CustomEvent('theme:tab:change', { bubbles: !1 }))
		}
		checkVisibleTabsLinks() {
			const t = this.container.querySelectorAll(wo),
				e = this.container.querySelectorAll(`${wo}.${Mo}`)
			t.length - e.length < 2
				? this.container.classList.add(Oo)
				: this.container.classList.remove(Oo)
		}
		onBlockSelect(t) {
			const e = t.target
			e &&
				(e.dispatchEvent(new Event('click')),
				e.parentNode.scrollTo({
					top: 0,
					left: e.offsetLeft - e.clientWidth,
					behavior: 'smooth',
				}))
		}
		onUnload() {
			this.customScrollbar && this.customScrollbar.unload(),
				this.isSearchPage &&
					theme.settings.enableInfinityScroll &&
					document.removeEventListener(
						'theme:tab:ajaxinate',
						this.ajaxifyFromFiltersEvent,
					)
		}
		constructor(t) {
			;(this.container = t),
				(this.tabsContents = t.querySelector(qo)),
				(this.animateElementsTimer = null),
				(this.isSearchPage = null != t.closest(`[${No}="true"]`)),
				this.container &&
					((this.scrollable = this.container.querySelector(Lo)),
					(this.tabRef = this.container.querySelectorAll(So)),
					(this.tabsLink = this.container.querySelectorAll(wo)),
					(this.tab = this.container.querySelectorAll(Eo)),
					this.assignSearchPageArguments(),
					this.init(),
					this.initCustomScrollbar())
		}
	}
	const Yo = {
			onLoad() {
				Xo[this.id] = new Jo(this.container)
			},
			onBlockSelect(t) {
				Xo[this.id].onBlockSelect(t)
			},
			onUnload() {
				Xo[this.id].onUnload()
			},
		},
		Zo = '[data-drawer]',
		tn = '[data-drawer-toggle]',
		en = '[data-scroll]',
		sn = '[data-quick-view-item]',
		on = 'is-open',
		nn = 'js-drawer-open',
		rn = 'cv-h',
		an = 'site-header',
		ln = 'aria-expanded',
		cn = 'aria-controls'
	let hn = {},
		dn = class {
			initListeners() {
				this.drawerToggleButtons.forEach((t) => {
					t.addEventListener('click', this.drawerToggleEvent)
				}),
					this.drawers.forEach((t) => {
						t.addEventListener('keyup', this.keyPressCloseEvent),
							(this.collapsible = new Ct(t)),
							(this.tabs = new Jo(t))
					}),
					document.addEventListener('click', this.drawerCloseEvent),
					document.addEventListener(
						'theme:drawer:closing',
						this.drawerCloseEvent,
					)
			}
			toggle(t) {
				t.preventDefault()
				const e = document.querySelector(`#${t.target.getAttribute(cn)}`)
				if (!e) return
				e.classList.contains(on) ? this.close() : this.open(t)
			}
			open(t) {
				const e = t.target,
					i = document.querySelector(`#${t.target.getAttribute(cn)}`)
				if (!i) return
				const s = i.querySelector(en) || i
				document.dispatchEvent(
					new CustomEvent('theme:scroll:lock', { bubbles: !0, detail: s }),
				),
					document.dispatchEvent(new CustomEvent('theme:drawer:open'), {
						bubbles: !0,
					}),
					document.body.classList.add(nn),
					i.classList.add(on),
					i.classList.remove(rn),
					e.setAttribute(ln, !0),
					setTimeout(() => {
						;(this.a11y.state.trigger = e),
							this.a11y.trapFocus({ container: i })
					})
			}
			close() {
				if (!document.body.classList.contains(nn)) return
				const t = document.querySelector(`${Zo}.${on}`)
				this.drawerToggleButtons.forEach((t) => {
					t.setAttribute(ln, !1)
				}),
					this.a11y.removeTrapFocus({ container: t }),
					t.classList.remove(on)
				const e = (i) => {
					i.target === t &&
						(requestAnimationFrame(() => {
							t.classList.add(rn),
								document.dispatchEvent(new CustomEvent('theme:drawer:close'), {
									bubbles: !0,
								}),
								document.dispatchEvent(
									new CustomEvent('theme:scroll:unlock', { bubbles: !0 }),
								)
						}),
						t.removeEventListener('transitionend', e))
				}
				t.addEventListener('transitionend', e),
					document.body.classList.remove(nn)
			}
			onUnload() {
				this.close(),
					this.drawerToggleButtons.forEach((t) => {
						t.removeEventListener('click', this.drawerToggleEvent)
					}),
					this.drawers.forEach((t) => {
						t.removeEventListener('keyup', this.keyPressCloseEvent)
					}),
					document.removeEventListener('click', this.drawerCloseEvent),
					document.removeEventListener(
						'theme:drawer:closing',
						this.drawerCloseEvent,
					),
					this.collapsible && this.collapsible.onUnload(),
					this.tabs && this.tabs.onUnload()
			}
			constructor(t) {
				;(this.container = t),
					(this.drawers = this.container.querySelectorAll(Zo)),
					(this.drawerToggleButtons = this.container.querySelectorAll(tn)),
					(this.a11y = _t),
					(this.drawerToggleEvent = gt((t) => {
						this.toggle(t)
					}, 150)),
					(this.keyPressCloseEvent = gt((t) => {
						t.code === theme.keyboardKeys.ESCAPE && this.close(t)
					}, 150)),
					(this.drawerCloseEvent = (t) => {
						const e = document.querySelector(`${Zo}.${on}`)
						let i = !1
						if (!e) return
						'click' === t.type && (i = t.target.matches(tn))
						const s = !!e && e.contains(t.target),
							o = e.closest(sn),
							n = !!o && o.contains(t.target)
						i || s || n || this.close()
					}),
					this.initListeners()
			}
		}
	const un = {
			onLoad() {
				this.container.classList.contains(an) &&
					(this.container = this.container.parentNode),
					(hn[this.id] = new dn(this.container))
			},
			onUnload() {
				hn[this.id].onUnload()
			},
		},
		pn = (t, e = !1, i = 'block') => {
			t && (e ? t.style.removeProperty('display') : (t.style.display = i))
		},
		mn = (t) => {
			t && (t.style.display = 'none')
		},
		gn = '[data-header-sticky]',
		vn = '[data-header-height]',
		yn = '[data-store-availability-list]',
		fn = {
			close: '.js-modal-close',
			open: '.js-modal-open-store-availability-modal',
			openClass: 'modal--is-active',
			openBodyClass: 'modal--is-visible',
			closeModalOnClick: !1,
			scrollIntoView: !1,
		}
	const bn = 'body',
		wn = '[data-store-availability-modal]',
		En = '[data-store-availability-modal-open]',
		Sn = '[data-store-availability-modal-close]',
		Ln = '[data-store-availability-modal-product__title]',
		kn = 'store-availabilities-modal--active'
	const An = '[data-product-form]',
		qn = '[data-option-position]',
		Cn = '[name^="options"], [data-popout-option]',
		Tn = 'sold-out',
		Pn = 'unavailable',
		Fn = 'data-option-position',
		In = 'data-value'
	const xn = 1,
		Hn = 'data-notification-popup',
		Dn = {
			history: !1,
			focus: !1,
			mainClass: 'pswp--notification pswp--not-close-btn',
			closeOnVerticalDrag: !1,
		}
	let Mn = class {
		init() {
			const t = [{ html: this.notificationPopupHtml }]
			;(this.a11y.state.trigger = this.button), new ul(t, Dn, xn)
		}
		constructor(t) {
			;(this.button = t),
				(this.a11y = _t),
				(this.notificationPopupHtml = this.button.getAttribute(Hn)),
				'' !== this.notificationPopupHtml.trim() && this.init()
		}
	}
	const On = '[data-product]',
		_n = '[data-product-form]',
		Bn = '[data-add-to-cart]',
		$n = '[data-add-to-cart-text]',
		zn = '[data-buy-it-now]',
		Rn = '[data-compare-price]',
		Vn = '[data-form-wrapper]',
		Wn = '[data-site-header]',
		Nn = '[data-product-select]',
		Un = '_preorder',
		jn = '[data-price-wrapper]',
		Kn = '[data-price-off]',
		Qn = '[data-price-off-type]',
		Gn = '[data-price-off-amount]',
		Xn = '[data-product-slide]',
		Jn = '[data-product-image]',
		Yn = '[data-product-single-media-slider]',
		Zn = '[data-product-json]',
		tr = '[data-product-price]',
		er = '[data-product-unit-price]',
		ir = '[data-product-base]',
		sr = '[data-product-unit]',
		or = '[data-subscription-watch-price]',
		nr = '[data-subscription-selectors]',
		rr = '[data-toggles-group]',
		ar = 'data-group-toggle',
		lr = '[data-plan-description]',
		cr = '[data-remaining-count]',
		hr = '[data-remaining-wrapper]',
		dr = '[data-product-remaining-json]',
		ur = '[data-store-availability-container]',
		pr = '[data-upsell-btn]',
		mr = '.shopify-section',
		gr = '[data-quick-view-item]',
		vr = '[data-notification-button-text]',
		yr = '[data-swatches-container]',
		fr = '[data-swatches-more]',
		br = '[data-option-position]',
		wr = 'hidden',
		Er = 'variant--soldout',
		Sr = 'variant--unavailabe',
		Lr = 'product__price--sale',
		kr = 'product__price--hidden',
		Ar = 'count-is-low',
		qr = 'count-is-in',
		Cr = 'count-is-out',
		Tr = 'count-is-unavailable',
		Pr = 'selector-wrapper--visible',
		Fr = 'data-image-id',
		Ir = 'data-tall-layout',
		xr = 'data-enable-history-state',
		Hr = 'data-notification-popup',
		Dr = 'data-swatch-variant'
	let Mr = class {
		init() {
			let t = null
			const e = this.container.querySelector(Zn)
			e && (t = e.innerHTML),
				t
					? ((this.productJSON = JSON.parse(t)),
					  this.linkForm(),
					  (this.sellout = new (class {
							init() {
								this.update()
							}
							update() {
								this.getCurrentState(),
									this.optionElements.forEach((t) => {
										const e = t.value || t.getAttribute(In),
											i = t.closest(qn)
										if (!i) return
										const s = i.getAttribute(Fn),
											o = parseInt(s, 10) - 1
										let n = [...this.selections]
										n[o] = e
										const r = this.productJSON.variants.find((t) => {
											let e = !0
											for (let i = 0; i < n.length; i++)
												t.options[i] !== n[i] && (e = !1)
											return e
										})
										t.parentElement.classList.remove(Tn, Pn),
											void 0 === r
												? t.parentElement.classList.add(Pn)
												: !1 === (null == r ? void 0 : r.available) &&
												  t.parentElement.classList.add(Tn)
									})
							}
							getCurrentState() {
								for (var t of ((this.formData = new FormData(this.form)),
								(this.selections = []),
								this.formData.entries()))
									t[0].includes('options[') && this.selections.push(t[1])
							}
							constructor(t, e) {
								;(this.container = t),
									(this.productJSON = e),
									(this.form = this.container.querySelector(An)),
									(this.formData = new FormData(this.form)),
									(this.optionElements = this.container.querySelectorAll(Cn)),
									this.productJSON && this.form && this.init()
							}
					  })(this.container, this.productJSON)))
					: console.error('Missing product JSON')
		}
		destroy() {
			this.productForm.destroy()
		}
		linkForm() {
			this.productForm = new (class {
				destroy() {
					this._listeners.removeAll()
				}
				options() {
					return this._serializeInputValues(this.optionInputs, function (t) {
						return (t.name = /(?:^(options\[))(.*?)(?:\])/.exec(t.name)[2]), t
					})
				}
				variant() {
					const t = this.options()
					return t.length ? oi(this.product, t) : this.product.variants[0]
				}
				plan(t) {
					let e = { allocation: null, group: null, detail: null }
					const i = new FormData(this.form).get('selling_plan')
					return (
						i &&
							t &&
							(e.allocation = t.selling_plan_allocations.find(function (t) {
								return t.selling_plan_id.toString() === i.toString()
							})),
						e.allocation &&
							(e.group = this.product.selling_plan_groups.find(function (t) {
								return (
									t.id.toString() ===
									e.allocation.selling_plan_group_id.toString()
								)
							})),
						e.group &&
							(e.detail = e.group.selling_plans.find(function (t) {
								return t.id.toString() === i.toString()
							})),
						e && e.allocation && e.detail && e.allocation ? e : null
					)
				}
				properties() {
					return this._serializeInputValues(this.propertyInputs, function (t) {
						return (
							(t.name = /(?:^(properties\[))(.*?)(?:\])/.exec(t.name)[2]), t
						)
					})
				}
				quantity() {
					return this.quantityInputs[0]
						? Number.parseInt(this.quantityInputs[0].value, 10)
						: 1
				}
				getFormState() {
					const t = this.variant()
					return {
						options: this.options(),
						variant: t,
						properties: this.properties(),
						quantity: this.quantity(),
						plan: this.plan(t),
					}
				}
				_setIdInputValue(t) {
					t && t.id
						? (this.variantElement.value = t.id.toString())
						: (this.variantElement.value = ''),
						this.variantElement.dispatchEvent(new Event('change'))
				}
				_onSubmit(t, e) {
					;(e.dataset = this.getFormState()),
						t.onFormSubmit && t.onFormSubmit(e)
				}
				_onOptionChange(t) {
					this._setIdInputValue(t.dataset.variant)
				}
				_onFormEvent(t) {
					return void 0 === t
						? Function.prototype.bind()
						: function (e) {
								;(e.dataset = this.getFormState()),
									this._setIdInputValue(e.dataset.variant),
									t(e)
						  }.bind(this)
				}
				_initInputs(t, e) {
					return Array.prototype.slice
						.call(this.element.querySelectorAll(t))
						.map(
							function (t) {
								return this._listeners.add(t, 'change', this._onFormEvent(e)), t
							}.bind(this),
						)
				}
				_serializeInputValues(t, e) {
					return t.reduce(function (t, i) {
						return (
							(i.checked || ('radio' !== i.type && 'checkbox' !== i.type)) &&
								t.push(e({ name: i.name, value: i.value })),
							t
						)
					}, [])
				}
				_validateProductObject(t) {
					if ('object' != typeof t)
						throw new TypeError(t + ' is not an object.')
					if (void 0 === t.variants[0].options)
						throw new TypeError(
							'Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route',
						)
					return t
				}
				constructor(t, e, i) {
					;(this.element = t),
						(this.form =
							'FORM' == this.element.tagName
								? this.element
								: this.element.querySelector('form')),
						(this.product = this._validateProductObject(e)),
						(this.variantElement = this.element.querySelector(ri)),
						(i = i || {}),
						(this._listeners = new si()),
						this._listeners.add(
							this.element,
							'submit',
							this._onSubmit.bind(this, i),
						),
						(this.optionInputs = this._initInputs(li, i.onOptionChange)),
						(this.planInputs = this._initInputs(ai, i.onPlanChange)),
						(this.quantityInputs = this._initInputs(ci, i.onQuantityChange)),
						(this.propertyInputs = this._initInputs(hi, i.onPropertyChange))
				}
			})(this.productForm, this.productJSON, {
				onOptionChange: this.onOptionChange.bind(this),
				onPlanChange: this.onPlanChange.bind(this),
			})
			const t = this.productForm.getFormState()
			if (
				(this.pushState(t, !0),
				this.subsToggleListeners(),
				this.swatchesContainer)
			) {
				this.observeSwatch(t)
				const e = this.swatchesContainer.closest(br),
					i = e.querySelector(fr)
				null == i ||
					i.addEventListener('click', (t) => {
						t.preventDefault(),
							e.classList.contains(Pr)
								? e.classList.remove(Pr)
								: e.classList.add(Pr)
					})
			}
		}
		onOptionChange(t) {
			this.pushState(t.dataset), this.updateProductImage(t)
		}
		onPlanChange(t) {
			this.subPrices && this.pushState(t.dataset)
		}
		pushState(t, e = !1) {
			var i
			;(this.productState = this.setProductState(t)),
				this.updateAddToCartState(t),
				this.updateProductPrices(t),
				this.updateSaleText(t),
				this.updateSubscriptionText(t),
				this.fireHookEvent(t),
				this.updateRemaining(t),
				null === (i = this.sellout) || void 0 === i || i.update(t),
				this.enableHistoryState && !e && this.updateHistoryState(t),
				this.storeAvailability &&
					(t.variant
						? this.storeAvailability.updateContent(
								t.variant.id,
								this.productForm.product.title,
						  )
						: this.storeAvailability.clearContent())
		}
		updateAddToCartState(t) {
			const e = t.variant,
				i = this.container.querySelectorAll(jn),
				s = this.container.querySelectorAll(Bn),
				o = this.container.querySelectorAll($n),
				n = this.container.querySelectorAll(Vn),
				r = this.container.querySelector(zn)
			let a = theme.strings.add_to_cart
			this.productJSON.tags.includes(Un) && (a = theme.strings.preorder),
				null == i ||
					i.forEach((t) => {
						t.classList.toggle(kr, !e)
					}),
				null == s ||
					s.forEach((t) => {
						var i
						if (t.matches(pr)) return
						if (((t.disabled = !0), null == r || r.classList.add(wr), !e))
							return
						if (
							((t.disabled = !1),
							e.available && (null == r || r.classList.remove(wr)),
							!t.hasAttribute(Hr))
						)
							return
						const s = t.id.replace('AddToCart', 'NotificationForm'),
							o = this.sessionStorage.getItem('notification_form_id')
						let n = !1,
							a = e.id,
							l = e.title
						if (o) {
							const t = o.substring(0, o.lastIndexOf('--')),
								e = o.split('--').slice(-1)[0]
							;(n = s === t),
								n &&
									((this.latestVariantId = a),
									(this.latestVariantTitle = l),
									(a = Number(e)),
									this.productJSON.variants.forEach((t) => {
										t.id === a && (l = t.title)
									}))
						}
						let c = t.getAttribute(Hr)
						const h =
							null ===
								(i = new DOMParser()
									.parseFromString(c, 'text/html')
									.querySelector(vr)) || void 0 === i
								? void 0
								: i.innerHTML
						if ('' != this.latestVariantId && '' != this.latestVariantTitle) {
							var d
							;(c = c.replaceAll(this.latestVariantId, a)),
								(c = c.replaceAll(this.latestVariantTitle, l))
							const t =
								null ===
									(d = new DOMParser()
										.parseFromString(c, 'text/html')
										.querySelector(vr)) || void 0 === d
									? void 0
									: d.innerHTML
							c = c.replace(t, h)
						}
						t.setAttribute(Hr, c),
							n && (this.scrollToForm(this.product.closest(mr)), new Mn(t)),
							(this.latestVariantId = a),
							(this.latestVariantTitle = l)
					}),
				null == o ||
					o.forEach((t) => {
						if (e) {
							if (e.available) t.innerHTML = a
							else if (
								((t.innerHTML = theme.strings.sold_out),
								t.parentNode.hasAttribute(Hr))
							) {
								if (t.closest(gr)) return
								t.innerHTML = `${theme.strings.sold_out} - ${theme.strings.newsletter_product_availability}`
							}
						} else t.innerHTML = theme.strings.unavailable
					}),
				null == n ||
					n.forEach((t) => {
						if (!e) return t.classList.add(Sr), void t.classList.remove(Er)
						const i = t.querySelector(Nn)
						if ((i && (i.value = e.id), !e.available))
							return t.classList.add(Er), void t.classList.remove(Sr)
						t.classList.remove(Er, Sr)
					})
		}
		updateHistoryState(t) {
			const e = t.variant,
				i = t.plan,
				s = window.location.href
			if (e && s.includes('/product')) {
				const t = new window.URL(s),
					o = t.searchParams
				o.set('variant', e.id),
					i && i.detail && i.detail.id && this.productState.hasPlan
						? o.set('selling_plan', i.detail.id)
						: o.delete('selling_plan'),
					(t.search = o.toString())
				const n = t.toString()
				window.history.replaceState({ path: n }, '', n)
			}
		}
		updateRemaining(t) {
			const e = t.variant,
				i = [qr, Cr, Tr, Ar]
			if (e && this.remainingWrapper && this.remainingJSON) {
				const t = this.remainingJSON[e.id]
				;('out' === t || t < 1) &&
					(this.remainingWrapper.classList.remove(...i),
					this.remainingWrapper.classList.add(Cr)),
					('in' === t || t >= this.remainingMaxInt) &&
						(this.remainingWrapper.classList.remove(...i),
						this.remainingWrapper.classList.add(qr)),
					('low' === t || (t > 0 && t < this.remainingMaxInt)) &&
						(this.remainingWrapper.classList.remove(...i),
						this.remainingWrapper.classList.add(Ar),
						this.remainingCount && (this.remainingCount.innerHTML = t))
			} else
				!e &&
					this.remainingWrapper &&
					(this.remainingWrapper.classList.remove(...i),
					this.remainingWrapper.classList.add(Tr))
		}
		getBaseUnit(t) {
			return 1 === t.unit_price_measurement.reference_value
				? t.unit_price_measurement.reference_unit
				: t.unit_price_measurement.reference_value +
						t.unit_price_measurement.reference_unit
		}
		subsToggleListeners() {
			this.container.querySelectorAll(rr).forEach((t) => {
				t.addEventListener(
					'change',
					function (t) {
						const e = t.target.value.toString(),
							i = this.container.querySelector(`[${ar}="${e}"]`),
							s = this.container.querySelectorAll(`[${ar}]`)
						if (i) {
							i.classList.remove(wr)
							const t = i.querySelector('[name="selling_plan"]')
							;(t.checked = !0), t.dispatchEvent(new Event('change'))
						}
						s.forEach((t) => {
							if (t !== i) {
								t.classList.add(wr)
								t.querySelectorAll('[name="selling_plan"]').forEach((t) => {
									;(t.checked = !1), t.dispatchEvent(new Event('change'))
								})
							}
						})
					}.bind(this),
				)
			})
		}
		updateSaleText(t) {
			this.productState.planSale
				? this.updateSaleTextSubscription(t)
				: this.productState.onSale
				? this.updateSaleTextStandard(t)
				: this.priceOffWrap && this.priceOffWrap.classList.add(wr)
		}
		updateSaleTextStandard(t) {
			if (!this.priceOffType) return
			this.priceOffType.innerHTML =
				window.theme.strings.sale_badge_text || 'sale'
			const e = t.variant
			if (
				window.theme.settings.savingBadgeType &&
				'percentage' === window.theme.settings.savingBadgeType
			) {
				const t = (e.compare_at_price - e.price) / e.compare_at_price,
					i = Math.floor(100 * t)
				this.priceOffAmount.innerHTML = `${i}%`
			} else {
				const t = e.compare_at_price - e.price
				this.priceOffAmount.innerHTML = i.formatMoney(t, theme.moneyFormat)
			}
			this.priceOffWrap.classList.remove(wr)
		}
		updateSaleTextSubscription(t) {
			const e = t.variant,
				s = this.productForm.product.selling_plan_groups.find(
					(t) => t.id === e.selling_plan_allocations[0].selling_plan_group_id,
				),
				o = t.plan
					? t.plan.detail.price_adjustments[0]
					: s.selling_plans[0].price_adjustments[0],
				n = o.value || 0,
				r =
					'percentage' === o.value_type
						? `${n}%`
						: i.formatMoney(e.price - n, theme.moneyFormat)
			;(this.priceOffType.innerHTML =
				window.theme.strings.subscription || 'subscripton'),
				(this.priceOffAmount.innerHTML = r),
				this.priceOffWrap.classList.remove(wr)
		}
		updateSubscriptionText(t) {
			t.plan && this.planDecription && null !== t.plan.detail.description
				? ((this.planDecription.innerHTML = t.plan.detail.description),
				  this.planDecription.classList.remove(wr))
				: this.planDecription && this.planDecription.classList.add(wr)
		}
		updateProductPrices(t) {
			const e = t.variant,
				s = t.plan
			this.container.querySelectorAll(jn).forEach((t) => {
				const o = t.querySelector(Rn),
					n = t.querySelector(tr)
				let r = '',
					a = ''
				if (
					(this.productState.available &&
						((r = e.compare_at_price), (a = e.price)),
					this.productState.hasPlan)
				) {
					a = s
						? s.allocation.price
						: e.selling_plan_allocations[0].per_delivery_price
				}
				if (this.productState.planSale) {
					const t = s
						? s.allocation.price
						: e.selling_plan_allocations[0].per_delivery_price
					;(r = s
						? s.allocation.compare_at_price
						: e.selling_plan_allocations[0].compare_at_price),
						(a = t)
				}
				o &&
					(this.productState.onSale || this.productState.planSale
						? (o.classList.remove(wr), n.classList.add(Lr))
						: (o.classList.add(wr), n.classList.remove(Lr)),
					(o.innerHTML = theme.settings.currency_code_enable
						? i.formatMoney(r, theme.moneyWithCurrencyFormat)
						: i.formatMoney(r, theme.moneyFormat))),
					(n.innerHTML =
						0 === a
							? window.theme.strings.free
							: theme.settings.currency_code_enable
							? i.formatMoney(a, theme.moneyWithCurrencyFormat)
							: i.formatMoney(a, theme.moneyFormat))
			}),
				this.hasUnitPricing && this.updateProductUnits(t)
		}
		updateProductUnits(t) {
			const e = t.variant,
				s = t.plan
			let o = null
			if (
				(e && e.unit_price && (o = e.unit_price),
				s &&
					(null == s ? void 0 : s.allocation) &&
					(null == s ? void 0 : s.allocation.unit_price) &&
					(o = s.allocation.unit_price),
				!s &&
					e.selling_plan_allocations &&
					e.selling_plan_allocations.length > 0)
			) {
				o = e.selling_plan_allocations[0].unit_price
			}
			if (o) {
				const t = this.getBaseUnit(e),
					s =
						0 === o
							? window.theme.strings.free
							: i.formatMoney(o, theme.moneyFormat)
				;(this.container.querySelector(er).innerHTML = s),
					(this.container.querySelector(ir).innerHTML = t),
					pn(this.container.querySelector(sr))
			} else mn(this.container.querySelector(sr))
		}
		fireHookEvent(t) {
			const e = t.variant
			this.container.dispatchEvent(
				new CustomEvent('theme:variant:change', {
					detail: { variant: e },
					bubbles: !0,
				}),
			)
		}
		setProductState(t) {
			const e = t.variant,
				i = t.plan,
				s = {
					available: !0,
					soldOut: !1,
					onSale: !1,
					showUnitPrice: !1,
					requiresPlan: !1,
					hasPlan: !1,
					planPerDelivery: !1,
					planSale: !1,
				}
			if (e) {
				const t = e.requires_selling_plan || !1
				e.available || (s.soldOut = !0),
					e.compare_at_price > e.price && (s.onSale = !0),
					e.unit_price && (s.showUnitPrice = !0),
					this.product &&
						this.product.requires_selling_plan &&
						(s.requiresPlan = !0),
					i &&
						this.subPrices &&
						((s.hasPlan = !0),
						i.allocation.per_delivery_price !== i.allocation.price &&
							(s.planPerDelivery = !0),
						e.price > i.allocation.price && (s.planSale = !0)),
					!i &&
						t &&
						((s.hasPlan = !0),
						e.selling_plan_allocations[0].per_delivery_price !==
							e.selling_plan_allocations[0].price && (s.planPerDelivery = !0),
						e.price > e.selling_plan_allocations[0].price && (s.planSale = !0))
			} else s.available = !1
			return s
		}
		updateProductImage(t) {
			const i = t.dataset.variant
			if (!i || !(null == i ? void 0 : i.featured_media)) return
			const s = this.container.querySelector(
					`${Jn}[${Fr}="${i.featured_media.id}"]`,
				),
				o = null == s ? void 0 : s.closest(Xn)
			if (o) {
				const t = parseInt([...o.parentElement.children].indexOf(o)),
					n = this.container.querySelector(Yn),
					r = e.data(n)
				if (r && r.isActive) {
					const t = n.querySelector(`[data-id="${i.featured_media.id}"]`)
					if (t) {
						const e = parseInt([...t.parentNode.children].indexOf(t))
						r.select(e)
					}
					return
				}
				if (this.tallLayout) {
					const e = s.getBoundingClientRect().top
					if (0 === t && e + window.scrollY > window.pageYOffset) return
					document.dispatchEvent(
						new CustomEvent('theme:tooltip:close', {
							bubbles: !1,
							detail: { hideTransition: !1 },
						}),
					),
						((t) => {
							const e =
								document.querySelector(gn) && document.querySelector(vn)
									? document.querySelector(vn).getBoundingClientRect().height
									: 0
							window.scrollTo({
								top: t + window.scrollY - e,
								left: 0,
								behavior: 'smooth',
							})
						})(e)
				}
			}
		}
		observeSwatch(t) {
			const e = this.swatchesContainer.querySelector(
				`[${Dr}*="${t.variant.id}"]`,
			)
			this.swatchesContainer.closest(br).classList.remove(Pr),
				new IntersectionObserver(
					(t, e) => {
						t.forEach((t) => {
							0 == t.intersectionRatio &&
								this.swatchesContainer.closest(br).classList.add(Pr)
						})
					},
					{ root: this.container, threshold: [0.95, 1] },
				).observe(e)
		}
		scrollToForm(t) {
			var e
			const i =
				null === (e = document.querySelector(Wn)) || void 0 === e
					? void 0
					: e.dataset.height
			visibilityHelper.isElementPartiallyVisible(t) ||
				visibilityHelper.isElementTotallyVisible(t) ||
				setTimeout(() => {
					const e = t.getBoundingClientRect().top - i
					window.scrollTo({ top: e, left: 0, behavior: 'smooth' })
				}, 400)
		}
		constructor(t) {
			if (
				((this.container = t),
				(this.product = this.container.querySelector(On)),
				(this.productForm = this.container.querySelector(_n)),
				(this.tallLayout = 'true' === this.container.getAttribute(Ir)),
				!this.product || !this.productForm)
			) {
				return void new Ot(this.container).init()
			}
			;(this.storeAvailabilityContainer = this.container.querySelector(ur)),
				(this.enableHistoryState = 'true' === this.container.getAttribute(xr)),
				(this.hasUnitPricing = this.container.querySelector(sr)),
				(this.subSelectors = this.container.querySelector(nr)),
				(this.subPrices = this.container.querySelector(or)),
				(this.priceOffWrap = this.container.querySelector(Kn)),
				(this.priceOffAmount = this.container.querySelector(Gn)),
				(this.priceOffType = this.container.querySelector(Qn)),
				(this.planDecription = this.container.querySelector(lr)),
				(this.swatchesContainer = this.container.querySelector(yr)),
				(this.latestVariantId = ''),
				(this.latestVariantTitle = ''),
				(this.sellout = null),
				(this.sessionStorage = window.sessionStorage),
				(this.remainingWrapper = this.container.querySelector(hr)),
				this.remainingWrapper &&
					((this.remainingMaxInt = parseInt(
						this.remainingWrapper.dataset.remainingMax,
						10,
					)),
					(this.remainingCount = this.container.querySelector(cr)),
					(this.remainingJSONWrapper = this.container.querySelector(dr)),
					(this.remainingJSON = null),
					this.remainingJSONWrapper &&
						'' !== this.remainingJSONWrapper.innerHTML &&
						(this.remainingJSON = JSON.parse(
							this.remainingJSONWrapper.innerHTML,
						))),
				this.storeAvailabilityContainer &&
					(this.storeAvailability = new (class {
						updateContent(t, e) {
							this._fetchStoreAvailabilities(t, e)
						}
						clearContent() {
							this.container.innerHTML = ''
						}
						_initModal() {
							return new (class {
								init() {
									this.openElement.addEventListener(
										'click',
										this.open.bind(this),
									),
										this.modal
											.querySelector(this.config.close)
											.addEventListener('click', this.closeModal.bind(this))
								}
								open(t) {
									let e = !1
									if (
										(t ? t.preventDefault() : (e = !0), this.modalIsOpen && !e)
									)
										return void this.closeModal()
									this.modal.classList.add(this.config.openClass),
										this.nodes.parents.forEach((t) => {
											t.classList.add(this.config.openBodyClass)
										}),
										(this.modalIsOpen = !0)
									const i = document.querySelector(yn)
									document.dispatchEvent(
										new CustomEvent('theme:scroll:lock', {
											bubbles: !0,
											detail: i,
										}),
									),
										this.config.scrollIntoView && this.scrollIntoView(),
										this.bindEvents(),
										this.a11y.trapFocus({ container: this.modal })
								}
								closeModal() {
									if (this.modalIsOpen) {
										document.activeElement.blur(),
											this.modal.classList.remove(this.config.openClass)
										var t = this
										this.nodes.parents.forEach(function (e) {
											e.classList.remove(t.config.openBodyClass)
										}),
											(this.modalIsOpen = !1),
											this.openElement.focus(),
											this.unbindEvents(),
											this.a11y.removeTrapFocus({ container: this.modal }),
											document.dispatchEvent(
												new CustomEvent('theme:scroll:unlock', {
													bubbles: !0,
													detail: 400,
												}),
											)
									}
								}
								bindEvents() {
									;(this.keyupHandler = this.keyupHandler.bind(this)),
										(this.clickHandler = this.clickHandler.bind(this)),
										document.body.addEventListener('keyup', this.keyupHandler),
										document.body.addEventListener('click', this.clickHandler)
								}
								unbindEvents() {
									document.body.removeEventListener('keyup', this.keyupHandler),
										document.body.removeEventListener(
											'click',
											this.clickHandler,
										)
								}
								keyupHandler(t) {
									t.code === theme.keyboardKeys.ESCAPE && this.closeModal()
								}
								clickHandler(t) {
									!this.config.closeModalOnClick ||
										this.modal.contains(t.target) ||
										t.target.matches(this.config.open) ||
										this.closeModal()
								}
								scrollIntoView() {
									this.focusOnOpen.scrollIntoView({ behavior: 'smooth' })
								}
								constructor(t, e) {
									if (((this.modal = document.getElementById(t)), !this.modal))
										return !1
									;(this.nodes = {
										parents: [document.querySelector('html'), document.body],
									}),
										(this.config = Object.assign(fn, e)),
										(this.modalIsOpen = !1),
										(this.focusOnOpen = this.config.focusOnOpen
											? document.getElementById(this.config.focusOnOpen)
											: this.modal),
										(this.openElement = document.querySelector(
											this.config.open,
										)),
										(this.a11y = _t),
										this.init()
								}
							})('StoreAvailabilityModal', {
								close: Sn,
								open: En,
								closeModalOnClick: !0,
								openClass: kn,
								scrollIntoView: !1,
							})
						}
						_fetchStoreAvailabilities(t, e) {
							const i = '/variants/' + t + '/?section_id=store-availability'
							this.clearContent()
							const s = this
							fetch(i)
								.then(function (t) {
									return t.text()
								})
								.then(function (t) {
									const i = document.querySelector(bn)
									let o = i.querySelector(wn)
									o && o.remove(),
										(s.container.innerHTML = t),
										(s.container.innerHTML =
											s.container.firstElementChild.innerHTML),
										'' !== s.container.firstElementChild.innerHTML.trim()
											? s.container.querySelector(En) &&
											  ((s.modal = s._initModal()),
											  s._updateProductTitle(e),
											  (o = s.container.querySelector(wn)),
											  o && i.appendChild(o))
											: s.clearContent()
								})
						}
						_updateProductTitle(t) {
							this.container.querySelector(Ln).textContent = t
						}
						constructor(t) {
							this.container = t
						}
					})(this.storeAvailabilityContainer))
			new Ot(this.container).init(), this.init()
		}
	}
	const Or = {
			onLoad() {
				this.section = new Mr(this.container)
			},
		},
		_r = 'form',
		Br = '[data-popout]',
		$r = '[data-popout-list]',
		zr = '[data-popout-toggle]',
		Rr = '[data-popout-input]',
		Vr = '[data-popout-option]',
		Wr = '[data-popout-text]',
		Nr = '[aria-current]',
		Ur = '[data-product-image]',
		jr = '[data-product-grid-item]',
		Kr = 'select-popout__list--visible',
		Qr = 'select-popout--alt',
		Gr = '--current',
		Xr = 'is-visible',
		Jr = 'aria-current',
		Yr = 'aria-expanded',
		Zr = 'data-value',
		ta = 'data-popout-prevent',
		ea = 'data-quantity-field',
		ia = 'data-quick-view-item'
	let sa = {},
		oa = class {
			unload() {
				this.popoutOptions.length &&
					this.popoutOptions.forEach((t) => {
						t.removeEventListener(
							'theme:popout:click',
							this.popupOptionsClickEvent,
						),
							t.removeEventListener('click', this._connectOptionsDispatchEvent)
					}),
					this.popoutToggle.removeEventListener(
						'click',
						this.popupToggleClickEvent,
					),
					this.popoutToggle.removeEventListener(
						'focusout',
						this.popupToggleFocusoutEvent,
					),
					this.popoutList.removeEventListener(
						'focusout',
						this.popupListFocusoutEvent,
					),
					this.popout.removeEventListener('keyup', this.popoutKeyupEvent),
					document.removeEventListener('theme:cart:update', this.updatePopout),
					document.body.removeEventListener('click', this.bodyClick)
			}
			popupToggleClick(t) {
				const e = 'true' === t.currentTarget.getAttribute(Yr)
				if (this.popoutList.closest(jr)) {
					const t = this.popoutList.closest(jr).querySelector(Ur)
					t && t.classList.toggle(Xr, !e)
				}
				t.currentTarget.setAttribute(Yr, !e),
					this.popoutList.classList.toggle(Kr)
			}
			popupToggleFocusout(t) {
				if (!t.relatedTarget) return
				const e = this.popout.contains(t.relatedTarget),
					i = t.relatedTarget.hasAttribute(ia)
				e || i || this._hideList()
			}
			popupListFocusout(t) {
				const e = t.currentTarget.contains(t.relatedTarget)
				this.popoutList.classList.contains(Kr) && !e && this._hideList()
			}
			popupOptionsClick(t) {
				if ('#' === t.target.closest(Vr).attributes.href.value) {
					t.preventDefault()
					let e = ''
					if (
						(t.currentTarget.getAttribute(Zr) &&
							(e = t.currentTarget.getAttribute(Zr)),
						(this.popoutInput.value = e),
						this.popoutPrevent)
					) {
						this.popoutInput.dispatchEvent(new Event('change')),
							!t.detail.preventTrigger &&
								this.popoutInput.hasAttribute(ea) &&
								this.popoutInput.dispatchEvent(new Event('input'))
						const i = this.popoutList.querySelector(`[class*="${Gr}"]`)
						let s = Gr
						if (i && i.classList.length)
							for (const t of i.classList)
								if (t.includes(Gr)) {
									s = t
									break
								}
						const o = this.popoutList.querySelector(`.${s}`)
						o &&
							(o.classList.remove(`${s}`),
							t.currentTarget.parentElement.classList.add(`${s}`))
						const n = this.popoutList.querySelector(Nr)
						n &&
							(n.removeAttribute(Jr), t.currentTarget.setAttribute(Jr, 'true')),
							'' !== e && (this.popoutText.textContent = e),
							this.popupToggleFocusout(t),
							this.popupListFocusout(t)
					} else this._submitForm(e)
				}
			}
			updatePopout() {
				const t = this.popoutList.querySelector(
					`[${Zr}="${this.popoutInput.value}"]`,
				)
				t
					? (t.dispatchEvent(
							new CustomEvent('theme:popout:click', {
								cancelable: !0,
								bubbles: !0,
								detail: { preventTrigger: !0 },
							}),
					  ),
					  t.parentElement.nextSibling || this.popout.classList.add(Qr))
					: this.popout.classList.add(Qr)
			}
			popoutKeyup(t) {
				t.code === theme.keyboardKeys.ESCAPE &&
					(this._hideList(), this.popoutToggle.focus())
			}
			bodyClick(t) {
				const e = this.popout.contains(t.target)
				this.popoutList.classList.contains(Kr) && !e && this._hideList()
			}
			_connectToggle() {
				this.popoutToggle.addEventListener('click', this.popupToggleClickEvent)
			}
			_connectOptions() {
				this.popoutOptions.length &&
					this.popoutOptions.forEach((t) => {
						t.addEventListener(
							'theme:popout:click',
							this.popupOptionsClickEvent,
						),
							t.addEventListener('click', this._connectOptionsDispatchEvent)
					})
			}
			_connectOptionsDispatch(t) {
				const e = new CustomEvent('theme:popout:click', {
					cancelable: !0,
					bubbles: !0,
					detail: { preventTrigger: !1 },
				})
				t.target.dispatchEvent(e) || t.preventDefault()
			}
			_onFocusOut() {
				this.popoutToggle.addEventListener(
					'focusout',
					this.popupToggleFocusoutEvent,
				),
					this.popoutList.addEventListener(
						'focusout',
						this.popupListFocusoutEvent,
					),
					this.popout.addEventListener('keyup', this.popoutKeyupEvent),
					document.body.addEventListener('click', this.bodyClick)
			}
			_submitForm() {
				const t = this.popout.closest(_r)
				t && t.submit()
			}
			_hideList() {
				this.popoutList.classList.remove(Kr),
					this.popoutToggle.setAttribute(Yr, !1)
			}
			constructor(t) {
				;(this.popout = t),
					(this.popoutList = this.popout.querySelector($r)),
					(this.popoutToggle = this.popout.querySelector(zr)),
					(this.popoutText = this.popout.querySelector(Wr)),
					(this.popoutInput = this.popout.querySelector(Rr)),
					(this.popoutOptions = this.popout.querySelectorAll(Vr)),
					(this.popoutPrevent = 'true' === this.popout.getAttribute(ta)),
					(this.popupToggleFocusoutEvent = (t) => this.popupToggleFocusout(t)),
					(this.popupListFocusoutEvent = (t) => this.popupListFocusout(t)),
					(this.popupToggleClickEvent = (t) => this.popupToggleClick(t)),
					(this.popoutKeyupEvent = (t) => this.popoutKeyup(t)),
					(this.popupOptionsClickEvent = (t) => this.popupOptionsClick(t)),
					(this._connectOptionsDispatchEvent = (t) =>
						this._connectOptionsDispatch(t)),
					(this.bodyClick = this.bodyClick.bind(this)),
					(this.updatePopout = this.updatePopout.bind(this)),
					this._connectOptions(),
					this._connectToggle(),
					this._onFocusOut(),
					this.popoutInput &&
						this.popoutInput.hasAttribute(ea) &&
						document.addEventListener('theme:cart:update', this.updatePopout)
			}
		}
	const na = {
			onLoad() {
				sa[this.id] = []
				this.container.querySelectorAll(Br).forEach((t) => {
					sa[this.id].push(new oa(t))
				})
			},
			onUnload() {
				sa[this.id].forEach((t) => {
					'function' == typeof t.unload && t.unload()
				})
			},
		},
		ra = '[data-add-to-cart]',
		aa = '[data-deferred-media]',
		la = '[data-deferred-media-button]',
		ca = '[data-popup-close]',
		ha = '[data-popout]',
		da = '[data-quick-view-inner]',
		ua = '[data-quick-view-item-holder]',
		pa = '[data-product]',
		ma = '[data-product-form]',
		ga = '[data-product-single-media-slider]',
		va = '[data-product-single-media-wrapper]',
		ya = '[data-model]',
		fa = '[data-product-json]',
		ba = '[data-quick-view-foot-inner]',
		wa = '[data-shop-the-look-thumb]',
		Ea = '[data-tooltip]',
		Sa = '[data-drawer-toggle]',
		La = 'has-media-active',
		ka = 'is-active',
		Aa = 'is-loading',
		qa = 'media--hidden',
		Ca = 'no-outline',
		Ta = 'notification-popup-visible',
		Pa = 'popup-quick-view--animate-in',
		Fa = 'popup-quick-view--animate-out',
		Ia = 'popup-quick-view--animated',
		xa = 'popup-quick-view',
		Ha = 'js-quick-view-visible',
		Da = 'js-quick-view-from-cart',
		Ma = 'js-drawer-open',
		Oa = 'id',
		_a = 'data-media-id',
		Ba = 'data-section-id',
		$a = 'loaded',
		za = 'tabindex',
		Ra = 'data-quick-view-onboarding',
		Va = 'data-hotspot',
		Wa = 'data-hotspot-ref',
		Na = 'AddToCartForm--',
		Ua = 'AddToCart--'
	const ja = 400,
		Ka = '.pswp',
		Qa = '.pswp__custom-close',
		Ga = 'iframe, video',
		Xa = '.pswp__custom-iframe',
		Ja = '.pswp__thumbs',
		Ya = '.pswp__button, .pswp__caption-close',
		Za = 'is-current',
		tl = 'pswp--custom-loader',
		el = 'pswp--custom-opening',
		il = 'pswp__loader',
		sl = 'pswp--open',
		ol = 'pswp__button--close',
		nl = 'pswp--notification',
		rl = 'popup-quick-view',
		al = 'js-drawer-open-cart',
		ll = 'popup-quick-view--animate-out',
		cl = 'data-pswp-option-classes',
		hl = 'data-video-type',
		dl = `<div class="${il}"><div class="loader loader--image"><div class="loader__image"></div></div></div>`
	let ul = class {
		init() {
			document.dispatchEvent(
				new CustomEvent('theme:scroll:lock', { bubbles: !0 }),
			),
				this.pswpElement.classList.add(el),
				this.initLoader(),
				$t({ url: window.theme.assets.photoswipe })
					.then(() => this.loadPopup())
					.catch((t) => console.error(t))
		}
		initLoader() {
			if (
				this.pswpElement.classList.contains(tl) &&
				'' !== this.options &&
				this.options.mainClass
			) {
				this.pswpElement.setAttribute(cl, this.options.mainClass)
				let t = document.createElement('div')
				;(t.innerHTML = dl), (t = t.firstChild), this.pswpElement.appendChild(t)
			} else this.pswpElement.setAttribute(cl, '')
		}
		loadPopup() {
			const t = window.themePhotoswipe.PhotoSwipe.default,
				e = window.themePhotoswipe.PhotoSwipeUI.default
			this.pswpElement.classList.contains(tl) &&
				this.pswpElement.classList.remove(tl),
				this.pswpElement.classList.remove(el),
				(this.popup = new t(this.pswpElement, e, this.items, this.options)),
				this.popup.listen('afterInit', this.dispatchPopupInitEventCallback),
				this.popup.listen('imageLoadComplete', this.setCurrentThumbCallback),
				this.popup.listen('beforeChange', this.setCurrentThumbCallback),
				this.popup.listen('close', this.onCloseCallback),
				this.popup.init(),
				this.initPopupCallback()
		}
		initPopupCallback() {
			this.isVideo && this.hideUnusedButtons(),
				this.initVideo(),
				this.thumbsActions(),
				this.a11y.trapFocus({ container: this.pswpElement }),
				this.pswpElement.classList.contains(rl) &&
					new (class {
						initTooltips() {
							;(this.tooltips = this.pswpElement.querySelectorAll(Ea)),
								this.tooltips.forEach((t) => {
									new ze(t)
								})
						}
						initPopouts() {
							var t
							;(this.popoutElements = this.pswpElement.querySelectorAll(ha)),
								(this.popouts = {}),
								null === (t = this.popoutElements) ||
									void 0 === t ||
									t.forEach((t, e) => {
										this.popouts[e] = new oa(t)
									})
						}
						handleDraggable(t, e) {
							t && ((t.options.draggable = Boolean(e)), t.updateDraggable())
						}
						initItems(t, e) {
							this.addFormSuffix(t),
								this.initProductSlider(t, e),
								this.initProductVideo(t),
								this.initProductModel(t),
								this.initShopifyXrLaunch(t),
								Yi(t),
								this.pswpElement.querySelectorAll(Sa).length && new dn(t),
								W(t)
							const i = new Mr(t.parentNode)
							this.productForms.push(i),
								Shopify.PaymentButton && Shopify.PaymentButton.init(),
								t.classList.remove(Aa)
						}
						init() {
							document.addEventListener(
								'submit',
								this.prevent3dModelSubmitEvent,
							),
								this.popupCloseButtons.forEach((t) => {
									t.addEventListener('keyup', (t) => {
										;(t.code !== theme.keyboardKeys.ENTER &&
											t.code !== theme.keyboardKeys.NUMPADENTER &&
											t.code !== theme.keyboardKeys.SPACE) ||
											this.closePopup(t)
									}),
										t.addEventListener('click', (t) => {
											this.closePopup(t)
										})
								}),
								this.pswpElement.addEventListener(
									'click',
									this.outerCloseEvent,
								),
								document.dispatchEvent(
									new CustomEvent('theme:popup:open', { bubbles: !0 }),
								),
								this.popup.listen('preventDragEvent', (t, e, i) => {
									i.prevent = !1
								}),
								this.pswpElement.addEventListener('mousedown', () => {
									this.popup.framework.unbind(
										window,
										'pointermove pointerup pointercancel',
										this.popup,
									)
								}),
								this.popup.listen('initialZoomInEnd', () => {
									document.body.classList.add(Ha),
										this.a11y.trapFocus({ container: this.quickViewInner })
								}),
								this.pswpElement.addEventListener(
									'animationend',
									this.closeOnAnimationEndEvent,
								),
								this.popup.listen('destroy', () => {
									this.flkty.length > 0 &&
										requestAnimationFrame(() => {
											this.flkty.forEach((t) => t.pausePlayer())
										}),
										document.body.classList.remove(Ha),
										document.removeEventListener(
											'keyup',
											this.closeOnEscapeEvent,
										),
										document.addEventListener('keyup', this.closeOnEscapeEvent),
										this.pswpElement.removeEventListener(
											'click',
											this.outerCloseEvent,
										),
										this.pswpElement.removeEventListener(
											'animationend',
											this.closeOnAnimationEndEvent,
										),
										document.removeEventListener(
											'submit',
											this.prevent3dModelSubmitEvent,
										),
										this.deferredMedias.forEach((t) => {
											t.removeAttribute($a)
										})
								}),
								document.addEventListener('keyup', this.closeOnEscapeEvent),
								document.addEventListener('theme:cart:added', () => {
									this.pswpElement.classList.contains(xa) &&
										this.pswpElement.classList.add(Fa)
								}),
								this.animateInQuickview(),
								this.initShopTheLookListeners()
						}
						initShopTheLookListeners() {
							var t
							null === (t = this.buttonsShopTheLookThumb) ||
								void 0 === t ||
								t.forEach((t) => {
									t.addEventListener('click', (t) => {
										t.preventDefault()
										const e = t.target.matches(wa)
												? t.target
												: t.target.closest(wa),
											i = this.pswpElement.querySelector(
												`[${Va}="${e.getAttribute(Wa)}"]`,
											)
										!e.classList.contains(ka) &&
											i &&
											(this.flkty.length > 0 &&
												requestAnimationFrame(() => {
													this.flkty.forEach((t) => {
														t.resize()
														const e = this.quickViewInner.querySelectorAll(va)
														e.length &&
															e.forEach((t) => {
																t.dispatchEvent(
																	new CustomEvent('theme:media:hidden'),
																	{ bubbles: !0 },
																),
																	t.classList.add(qa)
															})
													})
												}),
											i.classList.add(ka),
											this.quickViewItemHolders.forEach((t) => {
												t !== i && t.classList.remove(ka)
											}))
									})
								})
						}
						prevent3dModelSubmit(t) {
							t.submitter.closest(aa) &&
								t.submitter.closest(ma) &&
								t.preventDefault()
						}
						closeQuickviewOnMobile() {
							window.innerWidth < window.theme.sizes.large &&
								document.body.classList.contains(Ha) &&
								this.popup.close()
						}
						animateInQuickview() {
							this.pswpElement.classList.add(Pa),
								this.quickViewFoot.addEventListener('animationend', (t) => {
									this.handleAnimatedState(t)
								}),
								this.pswpElement.addEventListener('animationend', (t) => {
									this.handleAnimatedState(t, !0)
								})
						}
						handleAnimatedState(t, e = !1) {
							if ('quickViewAnimateInUp' == t.animationName) {
								if (e && window.innerWidth >= window.theme.sizes.small) return
								this.pswpElement.classList.add(Ia),
									this.pswpElement.classList.remove(Pa),
									document.body.classList.remove(Da),
									j(this.pswpElement)
							}
						}
						closePopup(t) {
							null == t || t.preventDefault(),
								document.body.classList.contains(Ma) &&
									document.dispatchEvent(
										new CustomEvent('theme:drawer:closing', { bubbles: !0 }),
									),
								this.pswpElement.classList.add(Fa),
								this.productForms.length > 0 &&
									this.productForms.forEach((t) => {
										t.destroy()
									}),
								this.swatchesContainer.onUnload()
						}
						closeOnAnimationEnd(t) {
							;('quickViewAnimateOutRight' != t.animationName &&
								'quickViewAnimateOutDown' != t.animationName) ||
								(this.popup.template.classList.remove(Fa, Ia),
								this.popup.close())
						}
						closeOnEscape(t) {
							const e = document.body.classList.contains(Ha),
								i = document.body.classList.contains(Ta)
							t.code === theme.keyboardKeys.ESCAPE &&
								e &&
								!i &&
								this.closePopup(t)
						}
						initProductSlider(t, i) {
							const s = t.querySelector(ga),
								o = t.querySelectorAll(va)
							if (o.length > 1) {
								const n = new e(s, {
									wrapAround: !0,
									cellAlign: 'left',
									pageDots: !1,
									prevNextButtons: !0,
									adaptiveHeight: !1,
									pauseAutoPlayOnHover: !1,
									selectedAttraction: 0.2,
									friction: 1,
									autoPlay: !1,
									on: {
										ready: () => {
											s.setAttribute(za, '-1'),
												requestAnimationFrame(() => {
													n.resize()
												})
										},
										settle: () => {
											const e = n.selectedElement,
												i = e.getAttribute(_a)
											e.setAttribute(za, '0'),
												n.cells.forEach((t) => {
													t.element !== e && t.element.setAttribute(za, '-1')
												}),
												this.switchMedia(t, i)
										},
									},
								})
								this.flkty.push(n),
									o.length &&
										o.forEach((t) => {
											t.addEventListener('theme:media:play', () => {
												this.handleDraggable(this.flkty[i], !1),
													t.closest(ga).classList.add(La)
											}),
												t.addEventListener('theme:media:pause', () => {
													this.handleDraggable(this.flkty[i], !0),
														t.closest(ga).classList.remove(La)
												})
										}),
									ae(s)
							}
						}
						switchMedia(t, e) {
							const i = this.quickViewInner.querySelectorAll(va),
								s = t.querySelector(`${va}[${_a}="${e}"]`),
								o = !document.body.classList.contains(Ca)
							i.length &&
								i.forEach((t) => {
									t.dispatchEvent(new CustomEvent('theme:media:hidden'), {
										bubbles: !0,
									}),
										t.classList.add(qa)
								}),
								o && s.focus(),
								s.closest(ga).classList.remove(La),
								s.classList.remove(qa),
								s.dispatchEvent(new CustomEvent('theme:media:visible'), {
									bubbles: !0,
								})
							const n = s.querySelector(aa)
							n &&
								'true' !== n.getAttribute($a) &&
								s.querySelector(la).dispatchEvent(new Event('click'))
						}
						initProductVideo(t) {
							const e = new Ee(t)
							this.videos.push(e)
						}
						initProductModel(t) {
							const e = t.getAttribute(Ba),
								i = t.querySelectorAll(ya)
							i.length &&
								i.forEach((t) => {
									theme.ProductModel.init(t, e)
								})
						}
						initShopifyXrLaunch(t) {
							document.addEventListener('shopify_xr_launch', () => {
								t.querySelector(`${ya}:not(.${qa})`).dispatchEvent(
									new CustomEvent('xrLaunch'),
								)
							})
						}
						addFormSuffix(t) {
							const e = `${t.getAttribute(Ba)}-${
									JSON.parse(t.querySelector(fa).innerHTML).handle
								}`,
								i = t.querySelector(ma),
								s = t.querySelector(ra)
							i.setAttribute(Oa, Na + e), s.setAttribute(Oa, Ua + e)
						}
						constructor(t, e) {
							;(this.popup = t),
								(this.pswpElement = e),
								(this.quickViewFoot = this.pswpElement.querySelector(ba)),
								(this.quickViewInner = this.pswpElement.querySelector(da)),
								(this.product = this.pswpElement.querySelectorAll(pa)),
								(this.flkty = []),
								(this.videos = []),
								(this.productForms = []),
								(this.deferredMedias = this.pswpElement.querySelectorAll(aa)),
								(this.buttonsShopTheLookThumb =
									this.pswpElement.querySelectorAll(wa)),
								(this.quickViewItemHolders =
									this.pswpElement.querySelectorAll(ua)),
								(this.popupCloseButtons =
									this.quickViewInner.querySelectorAll(ca)),
								(this.a11y = _t),
								(this.prevent3dModelSubmitEvent = (t) =>
									this.prevent3dModelSubmit(t)),
								(this.closeOnAnimationEndEvent = (t) =>
									this.closeOnAnimationEnd(t)),
								(this.closeOnEscapeEvent = (t) => this.closeOnEscape(t)),
								(this.outerCloseEvent = (t) => {
									if (!this.quickViewInner.contains(t.target)) {
										const e = this.quickViewInner.nextElementSibling
										if (e && e.contains(t.target)) return
										this.closePopup(t)
									}
								}),
								this.product.forEach((t, e) => {
									t.hasAttribute(Ra) || this.initItems(t, e)
								}),
								this.init(),
								this.initTooltips(),
								this.initPopouts(),
								(this.swatchesContainer = new Ji(this.pswpElement))
						}
					})(this.popup, this.pswpElement),
				this.pswpElement.classList.contains(nl) &&
					new (class {
						init() {
							this.popup.listen('preventDragEvent', (t, e, i) => {
								i.prevent = !1
							})
							const t =
								-1 !== window.location.search.indexOf('?customer_posted=true')
							this.notificationForm = this.pswpElement.querySelector(ie)
							const e = this.pswpElement.querySelector(oe)
							document.body.classList.add(re),
								this.pswpElement.addEventListener('mousedown', () => {
									this.popup.framework.unbind(
										window,
										'pointermove pointerup pointercancel',
										this.popup,
									)
								}),
								t && this.pswpElement.classList.add(ne),
								this.notificationForm.addEventListener('submit', (t) =>
									this.notificationSubmitEvent(t),
								),
								this.pswpElement.addEventListener(
									'click',
									this.outerCloseEvent,
								),
								e.addEventListener('click', () => {
									this.popup.close()
								}),
								this.popup.listen('destroy', () => {
									this.notificationRemoveStorage(),
										this.pswpElement.removeEventListener(
											'click',
											this.outerCloseEvent,
										),
										document.body.classList.remove(re)
								})
						}
						notificationSubmitEvent(t) {
							this.notificationStopSubmit &&
								(t.preventDefault(),
								this.notificationRemoveStorage(),
								this.notificationWriteStorage(),
								(this.notificationStopSubmit = !1),
								this.notificationForm.submit())
						}
						notificationWriteStorage() {
							void 0 !== this.sessionStorage &&
								this.sessionStorage.setItem(
									'notification_form_id',
									this.notificationForm.id,
								)
						}
						notificationRemoveStorage() {
							this.sessionStorage.removeItem('notification_form_id')
						}
						constructor(t, e) {
							;(this.popup = t),
								(this.pswpElement = e),
								(this.notificationForm = null),
								(this.notificationStopSubmit = !0),
								(this.sessionStorage = window.sessionStorage)
							const i = this.pswpElement.querySelector(se)
							;(this.outerCloseEvent = (t) => {
								i.contains(t.target) || this.popup.close()
							}),
								this.init()
						}
					})(this.popup, this.pswpElement),
				(this.closePopup = () => {
					this.pswpElement.classList.contains(rl)
						? this.pswpElement.classList.add(ll)
						: this.popup.close()
				}),
				this.closeBtn &&
					this.closeBtn.addEventListener('click', this.closePopup),
				document.addEventListener('theme:cart:added', this.closePopup)
		}
		dispatchPopupInitEvent() {
			this.triggerBtn &&
				this.triggerBtn.dispatchEvent(
					new CustomEvent('theme:popup:init', { bubbles: !0 }),
				)
		}
		initVideo() {
			const t = this.pswpElement.querySelector(Xa)
			if (t) {
				const e = t.getAttribute(hl)
				;(this.isVideo = !0),
					'youtube' == e
						? new (class {
								init() {
									window.isYoutubeAPILoaded
										? this.loadYoutubePlayer()
										: $t({ url: 'https://www.youtube.com/iframe_api' }).then(
												() => this.loadYoutubePlayer(),
										  )
								}
								loadYoutubePlayer() {
									const t = {
										height: '720',
										width: '1280',
										playerVars: this.videoOptionsVars,
										events: {
											onReady: (t) => {
												const e = t.target.getIframe(),
													i = e.id,
													s =
														'true' ===
														document.querySelector(`#${i}`).getAttribute(Xt)
												e.setAttribute('tabindex', '-1'),
													s ? t.target.unMute() : t.target.mute(),
													t.target.playVideo(),
													this.checkPlayerVisibilityFlag &&
														(this.checkPlayerVisibility(i),
														window.addEventListener(
															'scroll',
															gt(() => {
																this.checkPlayerVisibility(i)
															}, 150),
														))
											},
											onStateChange: (t) => {
												0 == t.data && t.target.playVideo(),
													1 == t.data &&
														t.target.getIframe().parentElement.classList.add(te)
											},
										},
									}
									;(t.videoId = this.videoID),
										this.videoID.length &&
											YT.ready(() => {
												ee[this.playerID] = new YT.Player(this.playerID, t)
											}),
										(window.isYoutubeAPILoaded = !0)
								}
								checkPlayerVisibility(t) {
									let e
									if ('string' == typeof t) e = t
									else {
										if (null == t.data) return
										e = t.data.id
									}
									const i = document.getElementById(e + '-container')
									if (!i) return
									const s = ee[e],
										o = i.getBoundingClientRect()
									let n =
										visibilityHelper.isElementPartiallyVisible(i) ||
										visibilityHelper.isElementTotallyVisible(i)
									o.top < 0 && i.clientHeight + o.top >= 0 && (n = !0),
										n && s && 'function' == typeof s.playVideo
											? s.playVideo()
											: !n &&
											  s &&
											  'function' == typeof s.pauseVideo &&
											  s.pauseVideo()
								}
								onUnload() {
									const t = 'youtube-' + this.container.getAttribute(Gt)
									ee[t] && ee[t].destroy()
								}
								constructor(t) {
									;(this.container = t),
										(this.player = this.container.querySelector(
											Qt.videoIframe,
										)),
										this.player &&
											((this.videoOptionsVars = {}),
											(this.videoID = this.player.getAttribute(Yt)),
											(this.videoType = this.player.getAttribute(Zt)),
											'youtube' == this.videoType &&
												((this.checkPlayerVisibilityFlag =
													'true' === this.player.getAttribute(Jt)),
												(this.playerID = this.player.querySelector(
													Qt.youtubeWrapper,
												)
													? this.player.querySelector(Qt.youtubeWrapper).id
													: this.player.id),
												this.player.hasAttribute(Qt.dataHideOptions) &&
													(this.videoOptionsVars = {
														cc_load_policy: 0,
														iv_load_policy: 3,
														modestbranding: 1,
														playsinline: 1,
														autohide: 0,
														controls: 0,
														branding: 0,
														showinfo: 0,
														rel: 0,
														fs: 0,
														wmode: 'opaque',
													}),
												this.init(),
												this.container.addEventListener(
													'touchstart',
													function (t) {
														if (
															t.target.matches(Qt.videoWrapper) ||
															t.target.closest(Qt.videoWrapper)
														) {
															const e = t.target.querySelector(
																Qt.videoIframe,
															).id
															ee[e].playVideo()
														}
													},
													{ passive: !0 },
												)))
								}
						  })(t.parentElement)
						: 'vimeo' == e &&
						  new (class {
								init() {
									this.loadVimeoPlayer()
								}
								loadVimeoPlayer() {
									const t = 'https://vimeo.com/' + this.videoID
									let e = ''
									const i = this.player,
										s = {
											url: t,
											background: this.enableBackground,
											muted: this.disableSound,
											autoplay: this.enableAutoplay,
											loop: this.enableLoop,
										}
									for (let t in s)
										e +=
											encodeURIComponent(t) +
											'=' +
											encodeURIComponent(s[t]) +
											'&'
									fetch(`https://vimeo.com/api/oembed.json?${e}`)
										.then((t) => t.json())
										.then(function (t) {
											;(i.innerHTML = t.html),
												setTimeout(function () {
													i.parentElement.classList.add(Rt)
												}, 1e3)
										})
										.catch(function () {
											console.log('error')
										})
								}
								constructor(t) {
									;(this.container = t),
										(this.player = this.container.querySelector(zt)),
										this.player &&
											((this.videoID = this.player.getAttribute(jt)),
											(this.videoType = this.player.getAttribute(Kt)),
											(this.enableBackground =
												'true' === this.player.getAttribute(Wt)),
											(this.disableSound =
												'false' === this.player.getAttribute(Vt)),
											(this.enableAutoplay =
												'false' !== this.player.getAttribute(Nt)),
											(this.enableLoop =
												'false' !== this.player.getAttribute(Ut)),
											'vimeo' == this.videoType && this.init())
								}
						  })(t.parentElement)
			}
		}
		thumbsActions() {
			this.popupThumbsContainer &&
				this.popupThumbsContainer.firstChild &&
				(this.popupThumbsContainer.addEventListener('wheel', (t) =>
					this.stopDisabledScroll(t),
				),
				this.popupThumbsContainer.addEventListener('mousewheel', (t) =>
					this.stopDisabledScroll(t),
				),
				this.popupThumbsContainer.addEventListener('DOMMouseScroll', (t) =>
					this.stopDisabledScroll(t),
				),
				(this.popupThumbs = this.pswpElement.querySelectorAll(`${Ja} > *`)),
				this.popupThumbs.forEach((t, e) => {
					t.addEventListener('click', (i) => {
						i.preventDefault(),
							t.parentElement.querySelector(`.${Za}`).classList.remove(Za),
							t.classList.add(Za),
							this.popup.goTo(e)
					})
				}))
		}
		hideUnusedButtons() {
			this.pswpElement.querySelectorAll(Ya).forEach((t) => {
				t.classList.contains(ol) || (t.style.display = 'none')
			})
		}
		stopDisabledScroll(t) {
			t.stopPropagation()
		}
		onClose() {
			const t = this.pswpElement.querySelector(Ga)
			if (
				(t && t.parentNode.removeChild(t),
				this.popupThumbsContainer && this.popupThumbsContainer.firstChild)
			)
				for (; this.popupThumbsContainer.firstChild; )
					this.popupThumbsContainer.removeChild(
						this.popupThumbsContainer.firstChild,
					)
			this.pswpElement.setAttribute(cl, '')
			const e = this.pswpElement.querySelector(`.${il}`)
			e && this.pswpElement.removeChild(e),
				document.body.classList.contains(al) || this.a11y.removeTrapFocus(),
				document.removeEventListener('theme:cart:added', this.closePopup),
				setTimeout(() => {
					const t = this.recentlyOpenedPopupsCount(),
						e = document.body.classList.contains(al)
					0 !== t ||
						e ||
						document.dispatchEvent(
							new CustomEvent('theme:scroll:unlock', { bubbles: !0 }),
						)
				}, ja)
		}
		recentlyOpenedPopupsCount() {
			let t = 0
			return (
				this.pswpElements.forEach((e) => {
					e.classList.contains(sl) && (t += 1)
				}),
				t
			)
		}
		setCurrentThumb() {
			if (this.popupThumbsContainer && this.popupThumbsContainer.firstChild)
				return
			const t = this.pswpElement.querySelector(`${Ja} > .${Za}`)
			if ((t && t.classList.remove(Za), !this.popupThumbs)) return
			const e = this.popupThumbs[this.popup.getCurrentIndex()]
			e.classList.add(Za), this.scrollThumbs(e)
		}
		scrollThumbs(t) {
			const e =
					this.popupThumbsContainer.scrollLeft +
					this.popupThumbsContainer.offsetWidth,
				i = t.offsetLeft
			if (e <= i + t.offsetWidth || e > i) {
				const e = parseInt(window.getComputedStyle(t).marginLeft)
				this.popupThumbsContainer.scrollTo({
					top: 0,
					left: i - e,
					behavior: 'smooth',
				})
			}
		}
		constructor(t, e = '', i = 0, s = null) {
			;(this.items = t),
				(this.triggerBtn = s),
				(this.pswpElements = document.querySelectorAll(Ka)),
				(this.pswpElement = this.pswpElements[i]),
				(this.popup = null),
				(this.popupThumbs = null),
				(this.popupThumbsContainer = this.pswpElement.querySelector(Ja)),
				(this.closeBtn = this.pswpElement.querySelector(Qa))
			;(this.options =
				'' !== e ? e : { history: !1, focus: !1, mainClass: '' }),
				(this.onCloseCallback = () => this.onClose()),
				(this.dispatchPopupInitEventCallback = () =>
					this.dispatchPopupInitEvent()),
				(this.setCurrentThumbCallback = () => this.setCurrentThumb()),
				(this.a11y = _t),
				this.init()
		}
	}
	const pl = 0,
		ml = '[data-button-quick-view]',
		gl = '[data-quick-view-items-template]',
		vl = '[data-cart-drawer]',
		yl = '[data-shop-the-look-quick-view-button]',
		fl = '[data-shop-the-look-thumb]',
		bl = '[data-quick-view-item-holder]',
		wl = 'is-loading',
		El = 'is-active',
		Sl = 'js-quick-view-from-cart',
		Ll = 'popup-quick-view pswp--not-close-btn',
		kl = 'popup-quick-view popup-quick-view--shop-the-look pswp--not-close-btn',
		Al = 'data-handle',
		ql = 'data-variant-id',
		Cl = 'data-shop-the-look-quick-view',
		Tl = 'data-hotspot',
		Pl = 'data-initialized',
		Fl = {
			history: !1,
			focus: !1,
			mainClass: Ll,
			showHideOpacity: !1,
			closeOnVerticalDrag: !1,
			closeOnScroll: !1,
			modal: !1,
			escKey: !1,
		}
	let Il = class {
		popupInit(t) {
			var e, i
			const s = this.loadPhotoswipe.pswpElement.querySelector(
					`[${Tl}="${t.getAttribute(Tl)}"]`,
				),
				o = this.loadPhotoswipe.pswpElement.querySelectorAll(bl)
			s.classList.add(El),
				o.forEach((t) => {
					t !== s && t.classList.remove(El)
				}),
				this.toggleQuickViewButtonsLoadingClasses(!0),
				this.toggleQuickViewThumbsLoadingClasses(!0)
			const n = (t) => {
				'quickViewAnimateInUp' === t.animationName &&
					requestAnimationFrame(() => {
						this.toggleQuickViewThumbsLoadingClasses(!1)
					}),
					'quickViewAnimateOutDown' === t.animationName &&
						this.loadPhotoswipe.pswpElement.removeEventListener(
							'animationend',
							n,
						)
			}
			this.loadPhotoswipe.pswpElement.addEventListener('animationend', n),
				null === (e = this.loadPhotoswipe) ||
					void 0 === e ||
					null === (i = e.popup) ||
					void 0 === i ||
					i.listen('destroy', () => {
						this.toggleQuickViewButtonsLoadingClasses(!1),
							this.toggleQuickViewThumbsLoadingClasses(!1)
					})
		}
		toggleQuickViewButtonsLoadingClasses(t = !0) {
			var e, i
			t
				? null === (i = this.buttonsQuickView) ||
				  void 0 === i ||
				  i.forEach((t) => {
						t.classList.add(wl)
				  })
				: null === (e = this.buttonsQuickView) ||
				  void 0 === e ||
				  e.forEach((t) => {
						t.classList.remove(wl)
				  })
		}
		toggleQuickViewThumbsLoadingClasses(t = !0) {
			var e, i, s
			;((this.buttonsShopTheLookThumb =
				null === (e = this.loadPhotoswipe) || void 0 === e
					? void 0
					: e.pswpElement.querySelectorAll(fl)),
			t)
				? null === (s = this.buttonsShopTheLookThumb) ||
				  void 0 === s ||
				  s.forEach((t) => {
						t.classList.add(wl)
				  })
				: null === (i = this.buttonsShopTheLookThumb) ||
				  void 0 === i ||
				  i.forEach((t) => {
						t.classList.remove(wl)
				  })
		}
		initPhotoswipe(t) {
			t.preventDefault()
			const e = t.target.matches(ml) ? t.target : t.target.closest(ml),
				i = window.innerWidth < theme.sizes.small
			let s = '',
				o = !1
			if (e.hasAttribute(Cl)) {
				if (!i) return
				o = !0
			}
			;(Fl.mainClass = Ll),
				e.classList.add(wl),
				e.closest(vl) && document.body.classList.add(Sl),
				(this.a11y.state.trigger = e),
				e.hasAttribute(ql) && (s = `&variant=${e.getAttribute(ql)}`)
			const n = `${theme.routes.root}products/${e.getAttribute(
				Al,
			)}?section_id=api-quickview${s}`
			if (o) {
				;(Fl.mainClass = kl),
					this.buttonsQuickView.forEach((t) => {
						t.classList.add(wl)
					})
				const t = new XMLSerializer(),
					i = this.container
						.querySelector(gl)
						.content.firstElementChild.cloneNode(!0),
					s = t.serializeToString(i)
				this.loadPhotoswipeWithTemplate(s, e)
			} else this.loadPhotoswipeFromFetch(n, e)
		}
		loadPhotoswipeWithTemplate(t, e) {
			const i = [{ html: t }]
			this.loadPhotoswipe = new ul(i, Fl, pl, e)
		}
		loadPhotoswipeFromFetch(t, e) {
			fetch(t)
				.then((t) => t.text())
				.then((t) => {
					const i = [{ html: t }]
					this.loadPhotoswipe = new ul(i, Fl, pl, e)
				})
				.catch((t) => console.log('error: ', t))
		}
		constructor(t) {
			var e, i
			;(this.container = t),
				(this.a11y = _t),
				(this.buttonsQuickView = this.container.querySelectorAll(ml)),
				(this.buttonsShopTheLookQuickView =
					this.container.querySelectorAll(yl)),
				(this.popupInitCallback = (t) => this.popupInit(t)),
				null === (e = this.buttonsQuickView) ||
					void 0 === e ||
					e.forEach((t) => {
						t.hasAttribute(Pl) ||
							(t.addEventListener('click', (t) => this.initPhotoswipe(t)),
							t.addEventListener('theme:popup:init', () => {
								t.classList.remove(wl),
									t.hasAttribute(Cl) && this.popupInitCallback(t)
							}),
							t.setAttribute(Pl, ''))
					}),
				null === (i = this.buttonsShopTheLookQuickView) ||
					void 0 === i ||
					i.forEach((t) => {
						t.addEventListener('click', () => {
							var t
							null === (t = this.buttonsQuickView[0]) ||
								void 0 === t ||
								t.dispatchEvent(new Event('click'))
						})
					})
		}
	}
	const xl = {
			cartDrawerEnabled: 'drawer' === window.theme.settings.cartType,
			timers: { addProductTimeout: 1e3 },
			animations: { data: 'data-aos', method: 'fade-up' },
		},
		Hl = {
			outerSection: '[data-section-id]',
			aos: '[data-aos]',
			additionalCheckoutButtons: '[data-additional-checkout-button]',
			apiContent: '[data-api-content]',
			apiLineItems: '[data-api-line-items]',
			apiUpsellItems: '[data-api-upsell-items]',
			apiCartPrice: '[data-api-cart-price]',
			buttonAddToCart: '[data-add-to-cart]',
			upsellButtonByHandle: '[data-handle]',
			cartCloseError: '[data-cart-error-close]',
			cartDrawer: '[data-cart-drawer]',
			cartDrawerTemplate: '[data-cart-drawer-template]',
			cartDrawerToggle: '[data-cart-drawer-toggle]',
			cartDrawerBody: '[data-cart-drawer-body]',
			cartErrors: '[data-cart-errors]',
			cartForm: '[data-cart-form]',
			cartTermsCheckbox: '[data-cart-acceptance-checkbox]',
			cartCheckoutButtonWrapper: '[data-cart-checkout-buttons]',
			cartCheckoutButton: '[data-cart-checkout-button]',
			cartItemRemove: '[data-item-remove]',
			cartItemsQty: '[data-cart-items-qty]',
			cartTotal: '[data-cart-total]',
			cartTotalPrice: '[data-cart-total-price]',
			cartMessage: '[data-cart-message]',
			cartMessageDefault: '[data-message-default]',
			cartPage: '[data-cart-page]',
			cartProgress: '[data-cart-message-progress]',
			emptyMessage: '[data-empty-message]',
			buttonHolder: '[data-foot-holder]',
			item: '[data-cart-item]',
			itemsHolder: '[data-items-holder]',
			itemsWrapper: '[data-items-wrapper]',
			formCloseError: '[data-close-error]',
			formErrorsContainer: '[data-cart-errors-container]',
			upsellHolder: '[data-upsell-holder]',
			errorMessage: '[data-error-message]',
			termsErrorMessage: '[data-terms-error-message]',
			pairProductsHolder: '[data-pair-products-holder]',
			pairProducts: '[data-pair-products]',
			priceHolder: '[data-cart-price-holder]',
			leftToSpend: '[data-left-to-spend]',
			quickBuyForm: '[data-quickbuy-form]',
			qtyInput: '[data-quantity-field]',
			productMediaContainer: '[data-product-media-container]',
			formWrapper: '[data-form-wrapper]',
			productForm: '[data-product-form]',
			popupQuickView: '.popup-quick-view',
			popupClose: '[data-popup-close]',
			error: '[data-error]',
			quickViewOnboarding: '[data-quick-view-onboarding]',
			flickityEnabled: '.flickity-enabled',
		},
		Dl = 'hidden',
		Ml = 'is-hidden',
		Ol = 'js-drawer-open-cart',
		_l = 'is-open',
		Bl = 'is-visible',
		$l = 'is-expanded',
		zl = 'is-loading',
		Rl = 'is-disabled',
		Vl = 'is-success',
		Wl = 'cart__toggle--has-items',
		Nl = 'variant--soldout',
		Ul = 'is-removed',
		jl = 'aos-animate',
		Kl = 'is-updated',
		Ql = 'no-outline',
		Gl = 'product-grid-item__image--error',
		Xl = 'cv-h',
		Jl = 'data-limit',
		Yl = 'data-cart-message',
		Zl = 'data-cart-total',
		tc = 'aria-expanded',
		ec = 'disabled',
		ic = 'value',
		sc = 'data-id',
		oc = 'data-item',
		nc = 'data-item-index',
		rc = 'data-item-title',
		ac = 'data-atc-trigger',
		lc = 'data-notification-popup',
		cc = 'data-recipient-errors'
	let hc = {},
		dc = class {
			init() {
				var t
				;(this.cartToggleButtons = document.querySelectorAll(
					Hl.cartDrawerToggle,
				)),
					(this.cartPage = document.querySelector(Hl.cartPage)),
					(this.cartDrawer = document.querySelector(Hl.cartDrawer)),
					(this.cart = this.cartDrawer || this.cartPage),
					(this.cartCount = this.getCartItemCount()),
					this.assignArguments(),
					(this.recipientErrors =
						'true' ===
						(null === (t = this.form) || void 0 === t
							? void 0
							: t.getAttribute(cc))),
					(this.flktyUpsell = null),
					(this.form = null),
					(this.collapsible = null),
					(this.a11y = _t),
					(this.build = this.build.bind(this)),
					(this.addToCart = this.addToCart.bind(this)),
					(this.updateCart = this.updateCart.bind(this)),
					(this.openCartDrawer = this.openCartDrawer.bind(this)),
					(this.closeCartDrawer = this.closeCartDrawer.bind(this)),
					(this.toggleCartDrawer = this.toggleCartDrawer.bind(this)),
					(this.formSubmitHandler = gt(this.formSubmitHandler.bind(this), 50)),
					(this.closeCartError = () => {
						this.cartErrorHolder.classList.remove($l)
					}),
					(this.cartDrawerCloseEvent = null),
					(this.hasItemsInCart = this.hasItemsInCart.bind(this)),
					(this.isCartPage = Boolean(this.cart && null === this.cartDrawer)),
					(this.showAnimations = Boolean(
						'true' === document.body.dataset.animations,
					)),
					(this.toggleClassesOnContainers =
						this.toggleClassesOnContainers.bind(this)),
					(this.totalItems = 0),
					(this.isCartDrawerOpen = !1),
					(this.isCartDrawerLoaded = !1),
					(this.cartDiscounts = 0),
					(this.cartDrawerEnabled = xl.cartDrawerEnabled),
					(this.cartAnimationTimer = 0),
					(this.cartUpdateFailed = !1),
					this.cartEvents(),
					this.cartAddEvent(),
					this.cartDrawerToggleEvents(),
					this.initQuantity(),
					this.buttonHolder && (this.collapsible = new Ct(this.buttonHolder)),
					this.isCartPage && this.renderPairProducts(),
					document.addEventListener('theme:popup:open', this.closeCartDrawer)
			}
			assignArguments() {
				;(this.cartDrawerBody = document.querySelector(Hl.cartDrawerBody)),
					(this.emptyMessage = document.querySelector(Hl.emptyMessage)),
					(this.buttonHolder = document.querySelector(Hl.buttonHolder)),
					(this.itemsHolder = document.querySelector(Hl.itemsHolder)),
					(this.cartItemsQty = document.querySelector(Hl.cartItemsQty)),
					(this.itemsWrapper = document.querySelector(Hl.itemsWrapper)),
					(this.items = document.querySelectorAll(Hl.item)),
					(this.cartTotal = document.querySelector(Hl.cartTotal)),
					(this.cartTotalPrice = document.querySelector(Hl.cartTotalPrice)),
					(this.cartMessage = document.querySelectorAll(Hl.cartMessage)),
					(this.cartOriginalTotal = document.querySelector(
						Hl.cartOriginalTotal,
					)),
					(this.cartErrorHolder = document.querySelector(Hl.cartErrors)),
					(this.cartCloseErrorMessage = document.querySelector(
						Hl.cartCloseError,
					)),
					(this.pairProductsHolder = document.querySelector(
						Hl.pairProductsHolder,
					)),
					(this.pairProducts = document.querySelector(Hl.pairProducts)),
					(this.priceHolder = document.querySelector(Hl.priceHolder)),
					(this.upsellHolders = document.querySelectorAll(Hl.upsellHolder)),
					(this.cartTermsCheckbox = document.querySelector(
						Hl.cartTermsCheckbox,
					)),
					(this.cartCheckoutButtonWrapper = document.querySelector(
						Hl.cartCheckoutButtonWrapper,
					)),
					(this.cartCheckoutButton = document.querySelector(
						Hl.cartCheckoutButton,
					)),
					(this.cartForm = document.querySelector(Hl.cartForm)),
					(this.cartItemCount = 0),
					(this.subtotal = window.theme.subtotal),
					(this.button = null),
					this.cartMessage.length > 0 &&
						(this.cartFreeLimitShipping =
							100 *
							Number(this.cartMessage[0].getAttribute(Jl)) *
							window.Shopify.currency.rate),
					this.updateProgress()
			}
			initQuantity() {
				var t
				;(this.items = document.querySelectorAll(Hl.item)),
					null === (t = this.items) ||
						void 0 === t ||
						t.forEach((t) => {
							new Ot(t, !0).init(), this.cartUpdateEvent(t)
						})
			}
			cartUpdateEvent(t) {
				t.addEventListener('theme:cart:update', (e) => {
					this.updateCart({ id: e.detail.id, quantity: e.detail.quantity }, t)
				})
			}
			cartEvents() {
				const t = document.querySelectorAll(Hl.cartItemRemove)
				;(this.totalItems = t.length),
					null == t ||
						t.forEach((t) => {
							const e = t.closest(Hl.item)
							t.addEventListener('click', (i) => {
								i.preventDefault(),
									t.classList.contains(Rl) ||
										this.updateCart({ id: e.getAttribute(sc), quantity: 0 }, e)
							})
						}),
					this.cartCloseErrorMessage &&
						(this.cartCloseErrorMessage.removeEventListener(
							'click',
							this.closeCartError,
						),
						this.cartCloseErrorMessage.addEventListener(
							'click',
							this.closeCartError,
						)),
					this.cartTermsCheckbox &&
						(this.cartTermsCheckbox.removeEventListener(
							'change',
							this.formSubmitHandler,
						),
						this.cartCheckoutButtonWrapper.removeEventListener(
							'click',
							this.formSubmitHandler,
						),
						this.cartForm.removeEventListener('submit', this.formSubmitHandler),
						this.cartTermsCheckbox.addEventListener(
							'change',
							this.formSubmitHandler,
						),
						this.cartCheckoutButtonWrapper.addEventListener(
							'click',
							this.formSubmitHandler,
						),
						this.cartForm.addEventListener('submit', this.formSubmitHandler))
			}
			cartAddEvent() {
				document.addEventListener('click', (t) => {
					const e = t.target,
						i = null == e ? void 0 : e.matches(Hl.buttonAddToCart),
						s = null == e ? void 0 : e.closest(Hl.buttonAddToCart)
					if (i || s) {
						var o, n, r
						t.preventDefault(),
							(this.button = i ? e : s),
							(this.form = e.closest('form')),
							(this.recipientErrors =
								'true' ===
								(null === (o = this.form) || void 0 === o
									? void 0
									: o.getAttribute(cc))),
							(this.formWrapper = this.button.closest(Hl.formWrapper))
						const a =
								null === (n = this.formWrapper) || void 0 === n
									? void 0
									: n.classList.contains(Nl),
							l = this.button.hasAttribute(ec),
							c = this.button.closest(Hl.quickViewOnboarding),
							h = this.button.hasAttribute(ac),
							d = this.button.hasAttribute(lc),
							u =
								null === (r = this.form) || void 0 === r
									? void 0
									: r.querySelector('[type="file"]')
						if (l || u || c) return
						if (a && d) return void new Mn(this.button)
						h && (this.a11y.state.trigger = this.button)
						const p = new FormData(this.form)
						this.addToCart(p),
							document.dispatchEvent(
								new CustomEvent('theme:cart:add', {
									bubbles: !0,
									detail: { selector: e },
								}),
							)
					}
				})
			}
			getCart() {
				if (this.cartDrawer && !this.isCartDrawerLoaded) {
					const t = !1
					this.renderCartDrawer(t)
				}
				fetch(theme.routes.cart_url + '?section_id=api-cart-items')
					.then(this.handleErrors)
					.then((t) => t.text())
					.then((t) => {
						const e = document.createElement('div')
						e.innerHTML = t
						const i = e.querySelector(Hl.apiContent)
						this.build(i)
					})
					.catch((t) => console.log(t))
			}
			addToCart(t) {
				this.cartDrawerEnabled &&
					this.button &&
					(this.button.classList.add(zl), this.button.setAttribute(ec, !0)),
					fetch(theme.routes.cart_add_url, {
						method: 'POST',
						headers: {
							'X-Requested-With': 'XMLHttpRequest',
							Accept: 'application/javascript',
						},
						body: t,
					})
						.then((t) => t.json())
						.then((t) => {
							if (
								((this.button.disabled = !0), this.addLoadingClass(), t.status)
							)
								return this.addToCartError(t), void this.removeLoadingClass()
							this.hideAddToCartErrorMessage(),
								this.cartDrawerEnabled
									? this.getCart()
									: (window.location = theme.routes.cart_url)
						})
						.catch((t) => console.log(t))
			}
			updateCart(t = {}, e = null) {
				let i = t.quantity
				null !== e && (i ? e.classList.add(zl) : e.classList.add(Ul)),
					this.disableCartButtons(),
					this.addLoadingClass()
				const s = this.cart.querySelector(`[${oc}="${t.id}"]`) || e,
					o = (null == s ? void 0 : s.hasAttribute(nc))
						? parseInt(s.getAttribute(nc))
						: 0,
					n = (null == s ? void 0 : s.hasAttribute(rc))
						? s.getAttribute(rc)
						: null
				if (0 === o) return
				const r = { line: o, quantity: i }
				fetch(theme.routes.cart_change_url, {
					method: 'post',
					headers: {
						'Content-Type': 'application/json',
						Accept: 'application/json',
					},
					body: JSON.stringify(r),
				})
					.then((t) => {
						if (400 === t.status) {
							const e = new Error(t.status)
							throw (
								(this.cartDrawerEnabled
									? this.getCart()
									: (window.location = theme.routes.cart_url),
								e)
							)
						}
						return t.text()
					})
					.then((t) => {
						if (JSON.parse(t).errors)
							return (
								(this.cartUpdateFailed = !0),
								this.updateErrorText(n),
								this.toggleErrorMessage(),
								this.resetLineItem(e),
								this.enableCartButtons(),
								void this.removeLoadingClass()
							)
						this.getCart()
					})
					.catch((t) => {
						console.log(t), this.enableCartButtons(), this.removeLoadingClass()
					})
			}
			resetLineItem(t) {
				const e = t.querySelector(Hl.qtyInput),
					i = e.getAttribute('value')
				;(e.value = i), t.classList.remove(zl)
			}
			disableCartButtons() {
				const t = this.cart.querySelectorAll('input'),
					e = this.cart.querySelectorAll(`button, ${Hl.cartItemRemove}`)
				t.length &&
					t.forEach((t) => {
						t.classList.add(Rl), t.blur(), (t.disabled = !0)
					}),
					e.length &&
						e.forEach((t) => {
							t.setAttribute(ec, !0)
						})
			}
			enableCartButtons() {
				const t = this.cart.querySelectorAll('input'),
					e = this.cart.querySelectorAll(`button, ${Hl.cartItemRemove}`)
				t.length &&
					t.forEach((t) => {
						t.classList.remove(Rl), (t.disabled = !1)
					}),
					e.length &&
						e.forEach((t) => {
							t.removeAttribute(ec)
						})
			}
			updateErrorText(t) {
				this.cartErrorHolder.querySelector(Hl.errorMessage).innerText = t
			}
			toggleErrorMessage() {
				if (this.cartErrorHolder) {
					if (
						(this.cartErrorHolder.classList.toggle($l, this.cartUpdateFailed),
						this.cartUpdateFailed)
					) {
						const t = this.cartErrorHolder.querySelector(Hl.cartCloseError)
						this.focusOnErrorMessage(this.cartErrorHolder, t)
					}
					this.cartUpdateFailed = !1
				}
			}
			handleErrors(t) {
				return t.ok
					? t
					: t.json().then(function (e) {
							throw new vt({
								status: t.statusText,
								headers: t.headers,
								json: e,
							})
					  })
			}
			addToCartError(t) {
				const e = this.button.closest(Hl.quickBuyForm),
					i = this.button.closest(Hl.upsellHolder),
					s = !document.body.classList.contains(Ql)
				let o = (
					this.button.closest(Hl.productForm)
						? this.button.closest(Hl.productForm)
						: this.button.closest(Hl.upsellHolder)
				).querySelector(Hl.formErrorsContainer)
				i && (o = i.querySelector(Hl.formErrorsContainer)),
					this.cartDrawerEnabled &&
						this.button &&
						null !== this.button.closest(Hl.cartDrawer) &&
						!this.button.closest(Hl.cartDrawer) &&
						this.closeCartDrawer(),
					this.button.classList.remove(zl),
					this.button.removeAttribute(ec)
				const n = e
					? ''
					: `\n      <button type="button" class="errors__button-close" data-close-error>\n        ${theme.icons.close}\n      </button>\n    `
				let r = `${t.message}: ${t.description}`
				if (
					(this.recipientErrors &&
						t.description &&
						'object' == typeof t.description &&
						(r = Object.entries(t.description)
							.map(([t, e]) => `${e}`)
							.join('<br>')),
					(o.innerHTML = `\n      <div class="errors" data-error autofocus>\n        ${r}\n        ${n}\n      </div>\n    `),
					e)
				) {
					const t = o.closest(Hl.productMediaContainer)
					t.classList.add(Gl),
						o.querySelector(Hl.error).addEventListener('animationend', () => {
							t.classList.remove(Gl),
								(o.innerHTML = ''),
								s || document.activeElement.blur()
						})
				} else
					o.classList.add(Bl),
						o.addEventListener('transitionend', () => {
							this.resizeSliders(o)
						}),
						this.handleCloseErrorMessages(o)
			}
			handleCloseErrorMessages(t) {
				const e = t.querySelector(Hl.formCloseError)
				null == e ||
					e.addEventListener('click', (e) => {
						const i = e.target
						;(i.matches(Hl.formCloseError) || i.closest(Hl.formCloseError)) &&
							(e.preventDefault(),
							t.classList.remove(Bl),
							t
								.querySelector(Hl.error)
								.addEventListener('transitionend', () => {
									;(t.innerHTML = ''), this.resizeSliders(i)
								}))
					}),
					this.focusOnErrorMessage(t, e)
			}
			focusOnErrorMessage(t, e) {
				!document.body.classList.contains(Ql) &&
					t.addEventListener('transitionend', () => {
						requestAnimationFrame(() =>
							null == e ? void 0 : e.focus({ focusVisible: !0 }),
						)
					})
			}
			hideAddToCartErrorMessage() {
				const t = this.button.closest(Hl.upsellHolder)
						? this.button.closest(Hl.upsellHolder)
						: this.button.closest(Hl.productForm),
					e = null == t ? void 0 : t.querySelector(Hl.formErrorsContainer)
				null == e || e.classList.remove(Bl)
			}
			resizeSliders(t) {
				const i = t.closest(Hl.flickityEnabled)
				if (!i) return
				const s = e.data(i)
				requestAnimationFrame(() => s.resize())
			}
			renderCartDrawer(t = !0) {
				const e = document.querySelector(Hl.cartDrawerTemplate)
				e &&
					((this.cartDrawer.innerHTML = e.innerHTML),
					this.assignArguments(),
					this.initQuantity(),
					this.cartEvents(),
					this.buttonHolder && (this.collapsible = new Ct(this.buttonHolder)),
					(this.cartDrawerToggle = this.cartDrawer.querySelector(
						Hl.cartDrawerToggle,
					)),
					this.cartDrawerToggle.addEventListener(
						'click',
						this.cartDrawerToggleClickEvent,
					),
					(this.isCartDrawerLoaded = !0),
					this.renderPairProducts(),
					document.dispatchEvent(
						new CustomEvent('theme:cart:loaded', { bubbles: !0 }),
					),
					t && this.openCartDrawer())
			}
			openCartDrawer() {
				this.isCartDrawerOpen ||
					(this.isCartDrawerLoaded
						? (document.dispatchEvent(
								new CustomEvent('theme:cart:open', { bubbles: !0 }),
						  ),
						  document.dispatchEvent(
								new CustomEvent('theme:scroll:lock', {
									bubbles: !0,
									detail: this.cartDrawer,
								}),
						  ),
						  document.dispatchEvent(
								new CustomEvent('theme:scroll:lock', {
									bubbles: !0,
									detail: this.cartDrawerBody,
								}),
						  ),
						  document.body.classList.add(Ol),
						  this.cartDrawer.classList.add(_l),
						  this.cartDrawer.classList.remove(Xl),
						  this.cartDrawer.querySelectorAll(Hl.aos).forEach((t) => {
								requestAnimationFrame(() => {
									t.classList.add(jl)
								})
						  }),
						  this.cartToggleButtons.forEach((t) => {
								t.setAttribute(tc, !0)
						  }),
						  this.a11y.trapFocus({ container: this.cartDrawer }),
						  this.observeAdditionalCheckoutButtons(),
						  (this.isCartDrawerOpen = !0))
						: this.renderCartDrawer())
			}
			closeCartDrawer() {
				if (!this.isCartDrawerOpen) return
				document.dispatchEvent(
					new CustomEvent('theme:cart:close', { bubbles: !0 }),
				),
					this.cartAnimationTimer && clearTimeout(this.cartAnimationTimer),
					(this.cartAnimationTimer = setTimeout(() => {
						this.cartDrawer.querySelectorAll(Hl.aos).forEach((t) => {
							t.classList.remove(jl)
						})
					}, 300)),
					this.cartErrorHolder.classList.remove($l),
					this.a11y.removeTrapFocus(),
					this.cartToggleButtons.forEach((t) => {
						t.setAttribute(tc, !1)
					}),
					document.body.classList.remove(Ol),
					this.cartDrawer.classList.remove(_l),
					this.itemsHolder.classList.remove(Kl)
				const t = (e) => {
					e.target === this.cartDrawer &&
						(requestAnimationFrame(() => {
							this.cartDrawer.classList.add(Xl)
						}),
						this.cartDrawer.removeEventListener('transitionend', t))
				}
				this.cartDrawer.addEventListener('transitionend', t)
				!document.body.classList.contains(Ql) ||
					requestAnimationFrame(() => {
						document.activeElement.blur()
					})
				document.dispatchEvent(
					new CustomEvent('theme:scroll:unlock', { bubbles: !0, detail: 400 }),
				),
					(this.isCartDrawerOpen = !1)
			}
			toggleCartDrawer() {
				this.isCartDrawerOpen ? this.closeCartDrawer() : this.openCartDrawer()
			}
			cartDrawerToggleEvents() {
				this.cartDrawer &&
					(this.cartDrawer.addEventListener('keyup', (t) => {
						t.code === theme.keyboardKeys.ESCAPE && this.closeCartDrawer()
					}),
					(this.cartDrawerToggleClickEvent = (t) => {
						t.preventDefault()
						const e = t.target
						'false' === e.getAttribute(tc) && (this.a11y.state.trigger = e),
							this.toggleCartDrawer()
					}),
					(this.cartDrawerCloseEvent = (t) => {
						const e = t.target.matches(Hl.cartDrawerToggle),
							i = document.querySelector(Hl.cartDrawer).contains(t.target),
							s = t.target.closest(Hl.popupQuickView)
						e || i || s || this.closeCartDrawer()
					}),
					this.cartToggleButtons.forEach((t) => {
						t.addEventListener('click', this.cartDrawerToggleClickEvent)
					}),
					document.addEventListener('mousedown', this.cartDrawerCloseEvent))
			}
			toggleClassesOnContainers() {
				const t = this
				this.emptyMessage.classList.toggle(Dl, t.hasItemsInCart()),
					this.buttonHolder.classList.toggle(Dl, !t.hasItemsInCart()),
					this.itemsHolder.classList.toggle(Dl, !t.hasItemsInCart()),
					this.cartItemsQty.classList.toggle(Dl, !t.hasItemsInCart())
			}
			build(t) {
				const e = t.querySelector(Hl.apiLineItems),
					s = t.querySelector(Hl.apiUpsellItems),
					o = Boolean(null === e && null === s),
					n = t.querySelector(Hl.apiCartPrice),
					r = t.querySelector(Hl.cartTotal)
				this.priceHolder && n && (this.priceHolder.innerHTML = n.innerHTML),
					this.emptyMessage.querySelectorAll(Hl.aos).forEach((t) => {
						t.classList.remove(jl)
					}),
					o
						? ((this.itemsHolder.innerHTML = ''),
						  this.pairProductsHolder &&
								(this.pairProductsHolder.innerHTML = ''))
						: ((this.itemsHolder.innerHTML = e.innerHTML),
						  this.pairProductsHolder &&
								(this.pairProductsHolder.innerHTML = s.innerHTML),
						  this.renderPairProducts()),
					(this.newTotalItems =
						e && e.querySelectorAll(Hl.item).length
							? e.querySelectorAll(Hl.item).length
							: 0),
					(this.subtotal =
						r && r.hasAttribute(Zl) ? parseInt(r.getAttribute(Zl)) : 0),
					(this.cartCount = this.getCartItemCount()),
					this.cartMessage.length > 0 && this.updateProgress(),
					this.cartToggleButtons.forEach((t) => {
						t.classList.remove(Wl),
							this.newTotalItems > 0 && t.classList.add(Wl)
					}),
					this.toggleErrorMessage(),
					this.updateItemsQuantity(this.cartCount),
					(this.cartTotalPrice.innerHTML =
						0 === this.subtotal
							? window.theme.strings.free
							: i.formatMoney(this.subtotal, theme.moneyWithCurrencyFormat)),
					this.totalItems !== this.newTotalItems &&
						((this.totalItems = this.newTotalItems),
						this.toggleClassesOnContainers()),
					this.isCartDrawerOpen && this.itemsHolder.classList.add(Kl),
					this.cartEvents(),
					this.initQuantity(),
					this.enableCartButtons(),
					this.resetButtonClasses(),
					this.removeLoadingClass(),
					document.dispatchEvent(
						new CustomEvent('theme:cart:added', { bubbles: !0 }),
					),
					this.cartDrawer && this.openCartDrawer()
			}
			getCartItemCount() {
				return this.cart
					? Array.from(this.cart.querySelectorAll(Hl.qtyInput)).reduce(
							(t, e) => t + parseInt(e.value),
							0,
					  )
					: 0
			}
			hasItemsInCart() {
				return this.totalItems > 0
			}
			freeShippingMessageHandle(t) {
				this.cartMessage.length > 0 &&
					document.querySelectorAll(Hl.cartMessage).forEach((e) => {
						const i =
								e.hasAttribute(Yl) && 'true' === e.getAttribute(Yl) && 0 !== t,
							s = e.querySelector(Hl.cartMessageDefault)
						e.classList.toggle(Vl, t >= this.cartFreeLimitShipping && i),
							e.classList.toggle(Ml, 0 === t),
							s.classList.toggle(Ml, t >= this.cartFreeLimitShipping)
					})
			}
			updateProgress() {
				const t = (this.subtotal / this.cartFreeLimitShipping) * 100,
					e = theme.settings.currency_code_enable
						? i.formatMoney(
								this.cartFreeLimitShipping - this.subtotal,
								theme.moneyWithCurrencyFormat,
						  )
						: i.formatMoney(
								this.cartFreeLimitShipping - this.subtotal,
								theme.moneyFormat,
						  )
				this.cartMessage.length > 0 &&
					document.querySelectorAll(Hl.cartMessage).forEach((i) => {
						const s = i.querySelectorAll(Hl.cartProgress),
							o = i.querySelector(Hl.leftToSpend)
						o && (o.innerHTML = e.replace('.00', '').replace(',00', '')),
							s.length &&
								s.forEach((e, i) => {
									e.classList.toggle(
										Ml,
										this.subtotal / this.cartFreeLimitShipping >= 1,
									),
										e.style.setProperty('--progress-width', `${t}%`),
										0 === i && e.setAttribute(ic, t)
								}),
							this.freeShippingMessageHandle(this.subtotal)
					})
			}
			renderPairProducts() {
				if (
					((this.flktyUpsell = null),
					(this.pairProductsHolder = document.querySelector(
						Hl.pairProductsHolder,
					)),
					(this.pairProducts = document.querySelector(Hl.pairProducts)),
					(this.upsellHolders = document.querySelectorAll(Hl.upsellHolder)),
					null === this.pairProductsHolder ||
						void 0 === this.pairProductsHolder)
				)
					return
				const t = this
				this.upsellHolders.length > 1
					? (this.flktyUpsell = new e(this.pairProducts, {
							wrapAround: !0,
							pageDots: !0,
							adaptiveHeight: !0,
							prevNextButtons: !1,
							on: {
								ready: function () {
									new Il(t.cart),
										this.reloadCells(),
										requestAnimationFrame(() => this.resize())
								},
							},
					  }))
					: new Il(this.cart)
			}
			updateItemsQuantity(t) {
				let e = theme.strings.cart_items_one,
					i = theme.strings.cart_items_many
				;(e = e.split('}}')[1]),
					(i = i.split('}}')[1]),
					this.cartItemsQty &&
						(this.cartItemsQty.textContent =
							1 === t ? `${t} ${e}` : `${t} ${i}`)
			}
			observeAdditionalCheckoutButtons() {
				const t = this.cart.querySelector(Hl.additionalCheckoutButtons)
				if (t) {
					const e = new MutationObserver(() => {
						this.a11y.removeTrapFocus(),
							this.a11y.trapFocus({ container: this.cart }),
							e.disconnect()
					})
					e.observe(t, { subtree: !0, childList: !0 })
				}
			}
			formSubmitHandler() {
				const t = document.querySelector(Hl.cartTermsCheckbox).checked,
					e = document.querySelector(Hl.termsErrorMessage)
				if (t)
					e.classList.remove($l), this.cartCheckoutButton.removeAttribute(ec)
				else {
					if (document.querySelector(Hl.termsErrorMessage).length > 0) return
					;(e.innerText = theme.strings.cart_acceptance_error),
						this.cartCheckoutButton.setAttribute(ec, !0),
						e.classList.add($l)
				}
			}
			resetButtonClasses() {
				const t = document.querySelectorAll(Hl.buttonAddToCart)
				t &&
					t.forEach((t) => {
						t.classList.contains(zl) &&
							(t.classList.remove(zl),
							t.classList.add(Vl),
							setTimeout(() => {
								t.removeAttribute(ec), t.classList.remove(Vl)
							}, xl.timers.addProductTimeout))
					})
			}
			addLoadingClass() {
				this.cartDrawer
					? this.cartDrawer.classList.add(zl)
					: this.itemsWrapper && this.itemsWrapper.classList.add(zl)
			}
			removeLoadingClass() {
				this.cartDrawer
					? this.cartDrawer.classList.remove(zl)
					: this.itemsWrapper && this.itemsWrapper.classList.remove(zl)
			}
			unload() {
				this.cartDrawerToggle &&
					this.cartDrawerToggle.removeEventListener(
						'click',
						this.cartDrawerToggleClickEvent,
					),
					this.cartToggleButtons.forEach((t) => {
						t.removeEventListener('click', this.cartDrawerToggleClickEvent)
					}),
					document.removeEventListener('mousedown', this.cartDrawerCloseEvent),
					null !== this.collapsible && this.collapsible.onUnload()
			}
			constructor() {
				'/password' !== window.location.pathname && this.init()
			}
		}
	ct('cart-template', {
		onLoad() {
			hc[this.id] = new dc()
		},
		onUnload() {
			'function' == typeof hc[this.id].unload && hc[this.id].unload()
		},
	})
	const uc = 'is-visible',
		pc = document.querySelector('[data-scroll-top-button]')
	pc &&
		(pc.addEventListener('click', () => {
			window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
		}),
		document.addEventListener(
			'scroll',
			gt(() => {
				pc.classList.toggle(uc, window.pageYOffset > window.innerHeight)
			}, 150),
		))
	const mc = 'details',
		gc = '[data-popdown-body]',
		vc = '[data-popdown-close]',
		yc = '[data-popdown-toggle]',
		fc = '[data-search-form-inner]',
		bc = '[data-popular-searches-link]',
		wc = '[data-site-header]',
		Ec = '[data-nav]',
		Sc = '[data-nav-items-compress]',
		Lc = '[data-nav-icons]',
		kc = '[data-mobile-menu]',
		Ac = 'predictive-search',
		qc = 'search-form',
		Cc = 'data-popdown-in-header',
		Tc = 'data-popdown-in-page',
		Pc = 'data-search-performed',
		Fc = 'search-opened',
		Ic = 'site-header--menu-opened',
		xc = 'nav--compress'
	let Hc = class extends HTMLElement {
		connectedCallback() {
			this.isPopdownInHeader &&
				(this.details.addEventListener(
					'keyup',
					(t) => 'ESCAPE' === t.code.toUpperCase() && this.close(),
				),
				this.popdownClose.addEventListener('click', () => this.close()),
				this.popdownToggle.addEventListener('click', (t) =>
					this.onPopdownToggleClick(t),
				),
				this.popdownToggle.setAttribute('role', 'button')),
				this.isPopdownInPage &&
					(this.popdownClose.addEventListener('click', () =>
						this.triggerPopdownClose(),
					),
					this.searchFormWrapper.addEventListener('focusout', () =>
						this.onFocusOut(),
					),
					this.searchFormWrapper.input.addEventListener('click', (t) =>
						this.triggerPopdownOpen(t),
					)),
				this.searchFormInner.addEventListener('transitionend', (t) => {
					t.target === this.searchFormInner &&
						this.details.hasAttribute('open') &&
						'false' == this.details.getAttribute('open') &&
						this.onClose()
				}),
				this.popularSearchesLink.forEach((t) => {
					t.addEventListener('click', (t) => {
						t.preventDefault()
						const e = t.target.textContent
						;(this.searchFormWrapper.input.value = e),
							this.searchFormWrapper.submit()
					})
				})
		}
		onPopdownToggleClick(t) {
			t.preventDefault(),
				t.target.closest(mc).hasAttribute('open') ? this.close() : this.open(t)
		}
		onBodyClick(t) {
			var e
			const i = this.contains(t.target)
			;(null === (e = this.header) || void 0 === e
				? void 0
				: e.classList.contains(Ic)) ||
				i ||
				i ||
				this.close()
		}
		onFocusOut() {
			this.predictiveSearch &&
				requestAnimationFrame(() => {
					this.searchFormWrapper.contains(document.activeElement) ||
						this.searchFormWrapper.close()
				})
		}
		triggerPopdownOpen(t) {
			const e = this.closest(`[${Pc}="false"]`),
				i = matchMedia('(pointer:coarse)').matches,
				s = window.innerWidth < theme.sizes.small,
				o = i || s,
				n = null != e
			if (this.nav && this.mobileMenu && (o || n)) {
				t.preventDefault()
				const e = this.nav.classList.contains(xc)
				let s = this.mobileMenu.querySelector(yc)
				i ||
					(s = e
						? this.nav.querySelector(`${Sc} ${yc}`)
						: this.nav.querySelector(`${Lc} ${yc}`)),
					setTimeout(() => {
						null == s || s.dispatchEvent(new Event('click', { bubbles: !0 }))
					}, 300)
			}
		}
		open(t) {
			;(this.onBodyClickEvent = (t) => this.onBodyClick(t)),
				t.target.closest(mc).setAttribute('open', ''),
				this.searchFormWrapper.input.setAttribute('aria-expanded', !0),
				document.body.classList.add(Fc),
				document.body.addEventListener('click', this.onBodyClickEvent),
				document.addEventListener(
					'theme:resize',
					this.ensureClosingOnResizeEvent,
				),
				document.dispatchEvent(
					new CustomEvent('theme:scroll:lock', { bubbles: !0 }),
				),
				(this.a11y.state.trigger = t.target),
				requestAnimationFrame(() => {
					requestAnimationFrame(() => {
						t.target.closest(mc).setAttribute('open', 'true'),
							this.a11y.trapFocus({ container: this.searchFormInner })
					})
				})
		}
		close() {
			this.a11y.removeTrapFocus(),
				this.details.setAttribute('open', 'false'),
				this.predictiveSearch && this.searchFormWrapper.close(),
				this.searchFormWrapper.handleFocusableDescendants(!0)
		}
		triggerPopdownClose() {
			this.predictiveSearch && this.searchFormWrapper.close(),
				this.searchFormWrapper.popularSearches &&
					requestAnimationFrame(() => document.activeElement.blur())
		}
		onClose() {
			this.details.removeAttribute('open'),
				document.dispatchEvent(
					new CustomEvent('theme:search:close', { bubbles: !0 }),
				),
				document.body.classList.remove(Fc),
				document.body.removeEventListener('click', this.onBodyClickEvent),
				document.removeEventListener(
					'theme:resize',
					this.ensureClosingOnResizeEvent,
				),
				document.dispatchEvent(
					new CustomEvent('theme:scroll:unlock', { bubbles: !0 }),
				)
		}
		ensureClosingOnResize() {
			null === this.offsetParent && this.onClose()
		}
		constructor() {
			var t, e, i
			super(),
				(this.isPopdownInHeader = this.hasAttribute(Cc)),
				(this.isPopdownInPage = this.hasAttribute(Tc)),
				(this.popdownBody = this.querySelector(gc)),
				(this.popdownClose = this.querySelector(vc)),
				(this.searchFormInner = this.querySelector(fc)),
				(this.popularSearchesLink = this.querySelectorAll(bc)),
				(this.searchFormWrapper = this.querySelector(qc)
					? this.querySelector(qc)
					: this.querySelector(Ac)),
				(this.predictiveSearch = this.searchFormWrapper.matches(Ac)),
				(this.header = document.querySelector(wc)),
				(this.headerSection =
					null === (t = this.header) || void 0 === t ? void 0 : t.parentNode),
				(this.nav =
					null === (e = this.header) || void 0 === e
						? void 0
						: e.querySelector(Ec)),
				(this.mobileMenu =
					null === (i = this.headerSection) || void 0 === i
						? void 0
						: i.querySelector(kc)),
				(this.a11y = _t),
				(this.ensureClosingOnResizeEvent = () => this.ensureClosingOnResize()),
				this.isPopdownInHeader &&
					((this.details = this.querySelector(mc)),
					(this.popdownToggle = this.querySelector(yc)))
		}
	}
	customElements.define('search-popdown', Hc),
		(theme.ProductModel = (function () {
			let t = {},
				e = {},
				i = {}
			const s = {
					productMediaWrapper: '[data-product-single-media-wrapper]',
					mediaGroup: '[data-product-single-media-group]',
					productXr: '[data-shopify-xr]',
					mediaId: 'data-media-id',
					model3d: 'data-shopify-model3d-id',
					modelViewer: 'model-viewer',
					modelJson: '#ModelJson-',
					deferredMedia: '[data-deferred-media]',
					deferredMediaButton: '[data-deferred-media-button]',
				},
				o = { isLoading: 'is-loading', mediaHidden: 'media--hidden' }
			function n(t, n) {
				if (t.querySelector(s.deferredMedia).getAttribute('loaded')) return
				t.classList.add(o.isLoading)
				const l = document.createElement('div')
				l.appendChild(
					t.querySelector('template').content.firstElementChild.cloneNode(!0),
				)
				const c = l.querySelector('model-viewer'),
					h = t.querySelector(s.deferredMedia)
				h.appendChild(c), h.setAttribute('loaded', !0)
				const d = t.dataset.mediaId,
					u = c.dataset.modelId,
					p = t.closest(s.mediaGroup).parentElement.querySelector(s.productXr)
				;(i[n] = { element: p, defaultId: u }),
					(e[d] = {
						modelId: u,
						mediaId: d,
						sectionId: n,
						container: t,
						element: c,
					}),
					window.ShopifyXR
						? a()
						: window.Shopify.loadFeatures([
								{ name: 'shopify-xr', version: '1.0', onLoad: r },
								{ name: 'model-viewer-ui', version: '1.0', onLoad: a },
						  ])
			}
			function r(e) {
				if (e) console.warn(e)
				else if (window.ShopifyXR) {
					for (const e in t)
						if (t.hasOwnProperty(e)) {
							const i = t[e]
							if (i.loaded) continue
							const o = document.querySelector(`${s.modelJson}${e}`)
							o &&
								(window.ShopifyXR.addModels(JSON.parse(o.innerHTML)),
								(i.loaded = !0))
						}
					window.ShopifyXR.setupXRElements()
				} else
					document.addEventListener('shopify_xr_initialized', function () {
						r()
					})
			}
			function a(t) {
				if (t) console.warn(t)
				else
					for (const t in e)
						if (e.hasOwnProperty(t)) {
							const i = e[t]
							i.modelViewerUi ||
								((i.modelViewerUi = new Shopify.ModelViewerUI(i.element)), l(i))
						}
			}
			function l(t) {
				const e = i[t.sectionId]
				t.container.addEventListener('theme:media:visible', function () {
					e.element.setAttribute(s.model3d, t.modelId),
						window.theme.touch ||
							(t.modelViewerUi.play(),
							t.container.dispatchEvent(new CustomEvent('theme:media:play'), {
								bubbles: !0,
							}))
				}),
					t.container.addEventListener('theme:media:hidden', function () {
						t.modelViewerUi.pause()
					}),
					t.container.addEventListener('xrLaunch', function () {
						t.modelViewerUi.pause()
					}),
					t.element.addEventListener('load', () => {
						e.element.setAttribute(s.model3d, t.modelId),
							t.container.classList.remove(o.isLoading),
							t.container.dispatchEvent(new CustomEvent('theme:media:play'), {
								bubbles: !0,
							})
					}),
					t.element.addEventListener(
						'shopify_model_viewer_ui_toggle_play',
						function () {
							c(t.mediaId),
								setTimeout(() => {
									t.container.dispatchEvent(
										new CustomEvent('theme:media:play'),
										{ bubbles: !0 },
									)
								}, 50)
						},
					),
					t.element.addEventListener(
						'shopify_model_viewer_ui_toggle_pause',
						function () {
							t.container.dispatchEvent(new CustomEvent('theme:media:pause'), {
								bubbles: !0,
							})
						},
					),
					c(t.mediaId)
			}
			function c(t) {
				const e = `[${s.mediaId}="${t}"]`,
					i = document.querySelectorAll(`${s.productMediaWrapper}:not(${e})`)
				i.length &&
					i.forEach((t) => {
						t.dispatchEvent(new CustomEvent('theme:media:hidden'), {
							bubbles: !0,
						}),
							t.classList.add(o.mediaHidden)
					})
			}
			return {
				init: function (e, i) {
					t[i] = { loaded: !1 }
					const o = e.querySelector(s.deferredMediaButton)
					o && o.addEventListener('click', n.bind(this, e, i))
				},
				loadContent: n,
				removeSectionModels: function (i) {
					for (const t in e)
						if (e.hasOwnProperty(t)) {
							e[t].sectionId === i && delete e[t]
						}
					delete t[i], delete theme.mediaInstances[i]
				},
			}
		})()),
		ct('collection-template', bo)
	const Dc = '.template-customers-addresses',
		Mc = '[data-form]',
		Oc = '[data-form-new]',
		_c = '[data-button-new]',
		Bc = '[data-button-edit]',
		$c = '[data-button-delete]',
		zc = '[data-button-cancel]',
		Rc = 'data-form-edit',
		Vc = 'AddressCountryNew',
		Wc = 'AddressProvinceNew',
		Nc = 'AddressProvinceContainerNew',
		Uc = '[data-country-option]',
		jc = 'AddressCountry',
		Kc = 'AddressProvince',
		Qc = 'AddressProvinceContainer',
		Gc = 'input[type="text"]:not(.optional)',
		Xc = 'data-form-id',
		Jc = 'is-hidden',
		Yc = 'validation--showup'
	const Zc = document.querySelector(Dc)
	Zc &&
		new (class {
			init() {
				if (this.addressNewForm) {
					const t = this.section,
						e = this.addressNewForm
					this.customerAddresses()
					const i = t.querySelectorAll(_c)
					i.length &&
						i.forEach((t) => {
							t.addEventListener('click', function (i) {
								i.preventDefault(), t.classList.add(Jc), e.classList.remove(Jc)
							})
						})
					const s = t.querySelectorAll(Bc)
					s.length &&
						s.forEach((e) => {
							e.addEventListener('click', function (e) {
								e.preventDefault()
								const i = this.getAttribute(Xc)
								t.querySelector(`[${Rc}="${i}"]`).classList.toggle(Jc)
							})
						})
					const o = t.querySelectorAll($c)
					o.length &&
						o.forEach((t) => {
							t.addEventListener('click', function (t) {
								t.preventDefault()
								const e = this.getAttribute(Xc)
								confirm(theme.strings.delete_confirm) &&
									Shopify.postLink('/account/addresses/' + e, {
										parameters: { _method: 'delete' },
									})
							})
						})
					const n = t.querySelectorAll(zc)
					n.length &&
						n.forEach((t) => {
							t.addEventListener('click', function (t) {
								t.preventDefault(),
									this.closest(Mc).classList.add(Jc),
									document.querySelector(_c).classList.remove(Jc)
							})
						})
				}
			}
			customerAddresses() {
				Shopify.CountryProvinceSelector &&
					new Shopify.CountryProvinceSelector(Vc, Wc, { hideElement: Nc }),
					this.section.querySelectorAll(Uc).forEach((t) => {
						const e = t.getAttribute(Xc),
							i = `${jc}_${e}`,
							s = `${Kc}_${e}`,
							o = `${Qc}_${e}`
						new Shopify.CountryProvinceSelector(i, s, { hideElement: o })
					})
			}
			validate() {
				this.accountForms.forEach((t) => {
					const e = t.querySelector('form'),
						i = e.querySelectorAll(Gc)
					e.addEventListener('submit', (t) => {
						let e = !1
						i.forEach((t) => {
							t.value
								? t.nextElementSibling.classList.remove(Yc)
								: (t.nextElementSibling.classList.add(Yc), (e = !0))
						}),
							e && t.preventDefault()
					})
				})
			}
			constructor(t) {
				;(this.section = t),
					(this.addressNewForm = this.section.querySelector(Oc)),
					(this.accountForms = this.section.querySelectorAll(Mc)),
					this.init(),
					this.validate()
			}
		})(Zc)
	const th = '[data-account-form]',
		eh = '[data-show-reset]',
		ih = '[data-hide-reset]',
		sh = '[data-recover-password]',
		oh = '[data-login-form]',
		nh = '[data-recover-success]',
		rh = '[data-recover-success-text]',
		ah = '#recover',
		lh = 'is-hidden'
	const ch = document.querySelector(th)
	ch &&
		new (class {
			init() {
				window.location.hash == ah
					? this.showRecoverPasswordForm()
					: this.hideRecoverPasswordForm(),
					this.success && this.successText.classList.remove(lh),
					this.showButton.addEventListener(
						'click',
						(t) => {
							t.preventDefault(), this.showRecoverPasswordForm()
						},
						!1,
					),
					this.hideButton.addEventListener(
						'click',
						(t) => {
							t.preventDefault(), this.hideRecoverPasswordForm()
						},
						!1,
					)
			}
			showRecoverPasswordForm() {
				return (
					this.recover.classList.remove(lh),
					this.login.classList.add(lh),
					(window.location.hash = ah),
					!1
				)
			}
			hideRecoverPasswordForm() {
				return (
					this.login.classList.remove(lh),
					this.recover.classList.add(lh),
					(window.location.hash = ''),
					!1
				)
			}
			constructor(t) {
				;(this.form = t),
					(this.showButton = t.querySelector(eh)),
					(this.hideButton = t.querySelector(ih)),
					(this.recover = t.querySelector(sh)),
					(this.login = t.querySelector(oh)),
					(this.success = t.querySelector(nh)),
					(this.successText = t.querySelector(rh)),
					this.init()
			}
		})(ch),
		ct('search-template', [bo, Yo])
	const hh = '[data-ticker-scale]',
		dh = '[data-ticker-text]',
		uh = 'data-clone',
		ph = 'data-marquee-speed',
		mh = 'ticker--animated',
		gh = 'ticker--unloaded',
		vh = 'ticker__comparitor',
		yh = 1.63,
		fh = 100
	const bh = '[data-bar]',
		wh = '[data-slide]',
		Eh = '[data-top-bar-slide]',
		Sh = '[data-ticker-frame]',
		Lh = '[data-slider]',
		kh = '[data-ticker-scale]',
		Ah = '[data-ticker-text]',
		qh = 'data-slide',
		Ch = 'data-slider-speed',
		Th = 'data-stop',
		Ph = 'style',
		Fh = 'data-target-referrer',
		Ih = 'desktop',
		xh = 'mobile',
		Hh = 'ticker--animated',
		Dh = {}
	const Mh = {
		onLoad() {
			Dh[this.id] = []
			const t = this.container.querySelector(bh)
			t &&
				Dh[this.id].push(
					new (class {
						init() {
							this.removeAnnouncement(),
								this.slider &&
									(this.initSlider(),
									document.addEventListener(
										'theme:resize:width',
										this.initSlider.bind(this),
									)),
								this.slider ||
									(this.initTickers(!0), this.tickerAnimationPause())
						}
						removeAnnouncement() {
							for (let t = 0; t < this.slides.length; t++) {
								const e = this.slides[t]
								e.hasAttribute(Fh) &&
									(-1 !== this.locationPath.indexOf(e.getAttribute(Fh)) ||
										window.Shopify.designMode ||
										e.parentNode.removeChild(e))
							}
						}
						initSlider() {
							if (this.slider.querySelectorAll(wh)) {
								let t = `${wh}`
								;(t =
									window.innerWidth < theme.sizes.small
										? `${wh}:not(.${Ih})`
										: `${wh}:not(.${xh})`),
									null != this.flkty && this.flkty.destroy(),
									(this.flkty = new e(this.slider, {
										cellSelector: t,
										pageDots: !1,
										prevNextButtons: !1,
										wrapAround: !0,
										autoPlay: parseInt(this.slider.getAttribute(Ch), 10),
										on: {
											ready: () => {
												setTimeout(() => {
													this.slider.dispatchEvent(
														new CustomEvent('slider-is-loaded', {
															bubbles: !0,
															detail: { slider: this },
														}),
													)
												}, 10)
											},
										},
									})),
									this.flkty.reposition()
							}
							this.slider.addEventListener('slider-is-loaded', () => {
								this.initTickers()
							})
						}
						initTickers(t = !1) {
							this.barHolder.querySelectorAll(Sh).forEach((e) => {
								const i = new (class {
									listen() {
										document.addEventListener(
											'theme:resize:width',
											this.resizeEvent,
										),
											this.checkWidth()
									}
									checkWidth() {
										const t =
											2 *
											window
												.getComputedStyle(this.frame)
												.paddingLeft.replace('px', '')
										if (
											this.frame.clientWidth - t <
												this.comparitor.clientWidth ||
											this.stopClone
										) {
											if (1 === this.scale.childElementCount) {
												if (
													(this.text.classList.add(mh),
													(this.clone = this.text.cloneNode(!0)),
													this.clone.setAttribute(uh, ''),
													this.scale.appendChild(this.clone),
													this.stopClone)
												)
													for (let t = 0; t < 10; t++) {
														const t = this.text.cloneNode(!0)
														t.setAttribute(uh, ''), this.scale.appendChild(t)
													}
												let t = this.frame.getAttribute(ph)
												null === t && (t = 100)
												const e = yh * (100 / parseInt(t, 10)),
													i = (this.text.clientWidth / fh) * e
												this.scale.style.setProperty(
													'--animation-time',
													`${i}s`,
												)
											}
										} else {
											this.text.classList.add(mh)
											let t = this.scale.querySelector(`[${uh}]`)
											t && this.scale.removeChild(t),
												this.text.classList.remove(mh)
										}
									}
									unload() {
										document.removeEventListener(
											'theme:resize:width',
											this.resizeEvent,
										)
									}
									constructor(t, e = !1) {
										;(this.frame = t),
											(this.stopClone = e),
											(this.scale = this.frame.querySelector(hh)),
											(this.text = this.frame.querySelector(dh)),
											(this.comparitor = this.text.cloneNode(!0)),
											this.comparitor.classList.add(vh),
											this.frame.appendChild(this.comparitor),
											this.scale.classList.remove(gh),
											(this.resizeEvent = n(() => this.checkWidth(), 100)),
											this.listen()
									}
								})(e, t)
								this.tickers.push(i)
								const s = e.querySelectorAll(wh)
								if (0 !== s.length) {
									const t = e.querySelectorAll(`${wh}.${xh}`),
										i = e.querySelectorAll(`${wh}.${Ih}`)
									s.length === t.length
										? e.parentNode.classList.add(xh)
										: s.length === i.length && e.parentNode.classList.add(Ih)
								}
							})
						}
						toggleTicker(t, e) {
							const i = t.target.closest(kh),
								s = document.querySelector(`[${qh}="${t.detail.blockId}"]`)
							e &&
								s &&
								(i.setAttribute(Th, ''),
								i.querySelectorAll(Ah).forEach((t) => {
									t.classList.remove(Hh),
										(t.style.transform = `translate3d(${-(
											s.offsetLeft -
											parseInt(getComputedStyle(s).marginLeft, 10)
										)}px, 0, 0)`)
								})),
								!e &&
									s &&
									(i.querySelectorAll(Ah).forEach((t) => {
										t.classList.add(Hh), t.removeAttribute(Ph)
									}),
									i.removeAttribute(Th))
						}
						tickerAnimationPause() {
							let t = 0,
								e = !1
							const i = this.barHolder.querySelector(Eh)
							i.addEventListener('mouseenter', () => {
								;(e = !0),
									(t = setTimeout(() => {
										e &&
											i.querySelectorAll(Ah).forEach((t) => {
												t.style.animationPlayState = 'paused'
											}),
											clearTimeout(t)
									}, 500))
							}),
								i.addEventListener('mouseleave', () => {
									;(e = !1),
										i.querySelectorAll(Ah).forEach((t) => {
											t.style.animationPlayState = 'running'
										})
								})
						}
						onBlockSelect(t) {
							const e = parseInt(
								[...t.target.parentNode.children].indexOf(t.target),
							)
							this.slider &&
								null !== this.flkty &&
								(this.flkty.select(e), this.flkty.pausePlayer()),
								this.slider || this.toggleTicker(t, !0)
						}
						onBlockDeselect(t) {
							this.slider && null !== this.flkty && this.flkty.unpausePlayer(),
								this.slider || this.toggleTicker(t, !1)
						}
						onUnload() {
							document.removeEventListener(
								'theme:resize:width',
								this.initSlider.bind(this),
							),
								this.tickers.length > 0 &&
									this.tickers.forEach((t) => {
										t.unload()
									})
						}
						constructor(t) {
							;(this.barHolder = t),
								(this.locationPath = location.href),
								(this.slides = this.barHolder.querySelectorAll(wh)),
								(this.slider = this.barHolder.querySelector(Lh)),
								(this.tickers = []),
								(this.flkty = null),
								this.init()
						}
					})(t),
				)
		},
		onBlockSelect(t) {
			Dh[this.id].length &&
				Dh[this.id].forEach((e) => {
					'function' == typeof e.onBlockSelect && e.onBlockSelect(t)
				})
		},
		onBlockDeselect(t) {
			Dh[this.id].length &&
				Dh[this.id].forEach((e) => {
					'function' == typeof e.onBlockSelect && e.onBlockDeselect(t)
				})
		},
		onUnload() {
			Dh[this.id].forEach((t) => {
				'function' == typeof t.onUnload && t.onUnload()
			})
		},
	}
	ct('announcement-bar', Mh), ct('marquee', Mh)
	const Oh = '[data-collapsible-trigger]',
		_h = 'is-expanded'
	ct('accordions', [
		{
			onBlockSelect(t) {
				const e = t.target.querySelector(Oh)
				requestAnimationFrame(() => {
					e.classList.contains(_h) || e.dispatchEvent(new Event('click'))
				})
			},
		},
		Tt,
	])
	const Bh = '[data-share-button]',
		$h = '[data-share-button-tooltip]',
		zh = 'is-visible',
		Rh = 'is-hiding',
		Vh = {}
	const Wh = {
		onLoad() {
			Vh[this.id] = new (class {
				init() {
					this.button &&
						this.button.addEventListener('click', () => {
							let t = window.location.href
							this.button.dataset.shareLink &&
								(t = this.button.dataset.shareLink),
								this.tooltip.classList.contains(zh) ||
									navigator.clipboard.writeText(t).then(() => {
										this.tooltip.classList.add(zh),
											setTimeout(() => {
												this.tooltip.classList.add(Rh),
													this.tooltip.classList.remove(zh),
													this.hideTransitionTimeout &&
														clearTimeout(this.hideTransitionTimeout),
													(this.hideTransitionTimeout = setTimeout(() => {
														this.tooltip.classList.remove(Rh)
													}, this.transitionSpeed))
											}, 1500)
									})
						})
				}
				constructor(t) {
					;(this.container = t),
						(this.button = this.container.querySelector(Bh)),
						(this.tooltip = this.container.querySelector($h)),
						(this.transitionSpeed = 200),
						(this.hideTransitionTimeout = 0),
						this.init()
				}
			})(this.container)
		},
	}
	ct('article', [Wh])
	const Nh = '[data-video-play]',
		Uh = 'data-video-play'
	const jh = {
			onLoad() {
				new (class {
					init() {
						this.videoPlay.length &&
							this.videoPlay.forEach((t) => {
								t.addEventListener('click', (e) => {
									if (t.hasAttribute(Uh) && '' !== t.getAttribute(Uh).trim()) {
										e.preventDefault()
										const i = [{ html: t.getAttribute(Uh) }]
										;(this.a11y.state.trigger = t), new ul(i)
									}
								})
							})
					}
					constructor(t) {
						;(this.container = t),
							(this.videoPlay = this.container.querySelectorAll(Nh)),
							(this.a11y = _t),
							this.init()
					}
				})(this.container)
			},
		},
		Kh = '[data-site-header]',
		Qh = '[data-main]'
	let Gh = {}
	const Xh = {
		onLoad() {
			Gh[this.id] = new (class {
				init() {
					var t
					if ('true' !== this.container.dataset.zoomAnimation) return
					const e = this.container,
						i = document.body.querySelector(Qh).children[0],
						s = this.container.parentNode === i,
						o =
							'true' ==
							(null === (t = this.header) || void 0 === t
								? void 0
								: t.dataset.transparent),
						n = () => {
							var t, i
							const n =
									s & o
										? 0
										: parseInt(
												(null === (t = this.header) || void 0 === t
													? void 0
													: t.dataset.height) ||
													(null === (i = this.header) || void 0 === i
														? void 0
														: i.offsetHeight),
										  ),
								r = e.getBoundingClientRect(),
								a = e.offsetHeight,
								l = s ? n - r.top : n - r.top + window.innerHeight
							let c = 0.1
							s && (c *= 1.5)
							let h = 1 + (l / a) * c
							;(h = h > 1 ? h : 1), e.style.setProperty('--scale', h)
						}
					n(),
						(this.zoomOnScrollEvent = gt(n, 5)),
						new IntersectionObserver(
							(t) => {
								t[0].isIntersecting
									? window.addEventListener('scroll', this.zoomOnScrollEvent)
									: window.removeEventListener('scroll', this.zoomOnScrollEvent)
							},
							{ root: null, rootMargin: '0px', threshold: 0 },
						).observe(e)
				}
				onUnload() {
					null !== this.zoomOnScrollEvent &&
						window.removeEventListener('scroll', this.zoomOnScrollEvent)
				}
				constructor(t) {
					;(this.container = t),
						(this.header = document.querySelector(Kh)),
						this.init()
				}
			})(this.container)
		},
		onUnload() {
			Gh[this.id].onUnload()
		},
	}
	ct('banner-image', [Xh, jh])
	const Jh = '[data-banner]',
		Yh = '[data-slider]',
		Zh = '[data-banners-media]',
		td = 'a, button',
		ed = 'data-index',
		id = 'data-slider-single-image',
		sd = 'tabindex',
		od = 'is-selected'
	let nd = {}
	ct('banner-with-text-columns', {
		onLoad() {
			nd[this.id] = new (class {
				initSliders() {
					if (this.slider.children.length <= 1) return
					let t = window.innerWidth < window.theme.sizes.small
					this.sliderMedia.children.length > 1 &&
						((this.flktyMedia = new e(this.sliderMedia, {
							draggable: !1,
							wrapAround: !1,
							fade: !0,
							prevNextButtons: !1,
							adaptiveHeight: !1,
							pageDots: !1,
							setGallerySize: !1,
						})),
						ae(this.sliderMedia)),
						(this.flkty = new e(this.slider, {
							draggable: t,
							prevNextButtons: !1,
							pageDots: !0,
							cellAlign: 'left',
							adaptiveHeight: !1,
							imagesLoaded: !0,
							lazyLoad: !0,
							on: {
								ready: () => {
									this.links.forEach((t) => {
										t.addEventListener('focus', () => {
											const e = Number(t.closest(Jh).getAttribute(ed))
											window.innerWidth >= theme.sizes.small &&
												this.syncContent(e)
										})
									}),
										this.banners.forEach((t) => {
											t.addEventListener('mouseenter', () => {
												const e = Number(t.getAttribute(ed))
												window.innerWidth >= theme.sizes.small &&
													!window.theme.touch &&
													this.syncContent(e)
											}),
												t.addEventListener('pointerup', () => {
													const e = Number(t.getAttribute(ed))
													window.innerWidth >= theme.sizes.small &&
														window.theme.touch &&
														this.syncContent(e)
												})
										}),
										this.slidesTabIndex()
								},
								change: (t) => {
									window.innerWidth < theme.sizes.small &&
										!this.singleImageEnabled &&
										this.flktyMedia.select(t),
										this.slidesTabIndex()
								},
							},
						})),
						ae(this.slider)
				}
				slidesTabIndex() {
					e.data(this.slider).cells.forEach((t) => {
						let e = '-1'
						t.element.classList.contains(od) && (e = '0'),
							t.element.querySelectorAll(td).forEach((t) => {
								t.setAttribute(sd, e)
							})
					})
				}
				syncContent(t = 0) {
					this.flkty.selectCell(t),
						this.flktyMedia && this.flktyMedia.selectCell(t)
				}
				resizeSlider() {
					this.flkty && (this.flkty.resize(), this.toggleDraggable()),
						this.flktyMedia && this.flktyMedia.resize()
				}
				toggleDraggable() {
					;(this.flkty.options.draggable =
						window.innerWidth < window.theme.sizes.small),
						this.flkty.updateDraggable()
				}
				onBlockSelect(t) {
					const e = parseInt(
						[...t.target.parentNode.children].indexOf(t.target),
					)
					this.flktyMedia && this.flktyMedia.selectCell(e)
				}
				onUnload() {
					document.removeEventListener(
						'theme:resize:width',
						this.sliderResizeEvent,
					)
				}
				constructor(t) {
					var e
					;(this.container = t.container),
						(this.slider = this.container.querySelector(Yh)),
						(this.singleImageEnabled =
							null === (e = this.slider) || void 0 === e
								? void 0
								: e.hasAttribute(id)),
						(this.banners = this.container.querySelectorAll(Jh)),
						(this.links = this.container.querySelectorAll('a')),
						(this.sliderMedia = this.container.querySelector(Zh)),
						(this.flkty = null),
						(this.flktyMedia = null),
						(this.sliderResizeEvent = () => this.resizeSlider()),
						this.slider &&
							(this.initSliders(),
							document.addEventListener(
								'theme:resize:width',
								this.sliderResizeEvent,
							))
				}
			})(this)
		},
		onBlockSelect(t) {
			nd[this.id].onBlockSelect(t)
		},
	}),
		ct('blog-posts', ws)
	const rd = '[data-slider]',
		ad = '[data-slider-item]',
		ld = '[data-media-container]',
		cd = 'a, button',
		hd = '.flickity-button',
		dd = 'carousel--inactive',
		ud = 'tabindex',
		pd = {}
	const md = {
		onLoad() {
			pd[this.id] = new (class {
				initSlider() {
					this.slider.classList.remove(dd),
						(this.flkty = new e(this.slider, {
							pageDots: !1,
							cellAlign: 'left',
							groupCells: !0,
							contain: !0,
							on: {
								ready: () => {
									this.setSliderArrowsPosition(this.slider),
										setTimeout(() => {
											this.changeTabIndex()
										}, 0)
								},
								change: () => {
									this.changeTabIndex()
								},
							},
						}))
				}
				destroySlider() {
					this.slider.classList.add(dd),
						null !== this.flkty && (this.flkty.destroy(), (this.flkty = null))
				}
				checkSlidesSize() {
					const t =
						this.container.querySelector(ad).currentStyle ||
						window.getComputedStyle(this.container.querySelector(ad))
					this.gutter = parseInt(t.marginRight)
					const e = this.slider.offsetWidth < this.getItemsWidth()
					window.innerWidth >= theme.sizes.small && e
						? this.initSlider()
						: this.destroySlider()
				}
				changeTabIndex() {
					const t = this.flkty.selectedIndex
					this.flkty.slides.forEach((e, i) => {
						e.cells.forEach((e) => {
							e.element.querySelectorAll(cd).forEach((e) => {
								e.setAttribute(ud, t === i ? '0' : '-1')
							})
						})
					})
				}
				getItemsWidth() {
					let t = 0
					const e = this.slider.querySelectorAll(ad)
					return (
						e.length &&
							e.forEach((e) => {
								t += e.offsetWidth + this.gutter
							}),
						t
					)
				}
				listen() {
					this.slider &&
						(this.checkSlidesSize(),
						document.addEventListener(
							'theme:resize:width',
							this.checkSlidesSizeOnResize,
						))
				}
				setSliderArrowsPosition(t) {
					const e = t.querySelectorAll(hd),
						i = t.querySelector(ld)
					e.length &&
						i &&
						e.forEach((t) => {
							t.style.top = i.offsetHeight / 2 + 'px'
						})
				}
				onBlockSelect(t) {
					if (null !== this.flkty) {
						const e = parseInt(
								[...t.target.parentNode.children].indexOf(t.target),
							),
							i = parseInt(this.flkty.slides[0].cells.length),
							s = Math.floor(e / i)
						this.flkty.select(s)
					} else {
						const e =
								this.slider.currentStyle ||
								window.getComputedStyle(this.slider),
							i = parseInt(e.paddingLeft),
							s = t.target.offsetLeft - i
						this.slider.scrollTo({ top: 0, left: s, behavior: 'smooth' })
					}
				}
				onUnload() {
					document.removeEventListener(
						'theme:resize:width',
						this.checkSlidesSizeOnResize,
					)
				}
				constructor(t) {
					;(this.container = t.container),
						(this.slider = this.container.querySelector(rd)),
						(this.flkty = null),
						(this.gutter = 0),
						(this.checkSlidesSizeOnResize = () => this.checkSlidesSize()),
						this.listen()
				}
			})(this)
		},
		onUnload(t) {
			pd[this.id].onUnload(t)
		},
		onBlockSelect(t) {
			pd[this.id].onBlockSelect(t)
		},
	}
	ct('columns-with-image', [md, jh])
	const gd = '[data-form-message-close]',
		vd = '[data-form-message]',
		yd = 'hide-down',
		fd = 'notification-visible'
	let bd = {}
	ct('contact-form', {
		onLoad() {
			bd[this.id] = new (class {
				hidePopups() {
					document.body.classList.add(fd)
				}
				showPopups() {
					document.body.classList.remove(fd)
				}
				closeFormMessage() {
					this.closeButton.addEventListener(
						'click',
						this.closeMessage.bind(this),
					)
				}
				closeMessage(t) {
					t.preventDefault(),
						this.messageWrapper.classList.add(yd),
						this.showPopups()
				}
				autoHideMessage() {
					setTimeout(() => {
						this.messageWrapper.classList.add(yd), this.showPopups()
					}, 1e4)
				}
				constructor(t) {
					;(this.container = t.container),
						(this.closeButton = this.container.querySelector(gd)),
						(this.messageWrapper = this.container.querySelector(vd)),
						this.messageWrapper &&
							(this.hidePopups(),
							this.closeFormMessage(),
							this.autoHideMessage())
				}
			})(this)
		},
	})
	const wd = '[data-video-id]',
		Ed = '[data-video-player]',
		Sd = '[data-video-template]',
		Ld = '[data-video-autoplay]',
		kd = '[data-video-wrapper]',
		Ad = '[data-video-bg-play]',
		qd = 'is-loading',
		Cd = 'is-paused',
		Td = {}
	const Pd = {
		onLoad() {
			Td[this.id] = []
			this.container.querySelectorAll(kd).forEach((t) => {
				Td[this.id].push(
					new (class {
						init() {
							this.videoId &&
								(new IntersectionObserver(
									(t, e) => {
										t.forEach((t) => {
											if (t.isIntersecting) {
												const i = this.videoTemplate.innerHTML
												;(this.videoPlayer.innerHTML = i),
													(this.video = this.container.querySelector(Ld)),
													this.videoPlayer.classList.remove(qd),
													this.container.classList.add(Cd),
													this.listen(),
													e.unobserve(t.target)
											}
										})
									},
									{
										root: null,
										rootMargin: '300px',
										threshold: [0, 0.1, 0.25, 0.5, 0.75, 1],
									},
								).observe(this.videoPlayer),
								this.videoPlayButton.addEventListener('click', (t) => {
									var e
									t.preventDefault(),
										null === (e = this.video) || void 0 === e || e.play()
								}))
						}
						listen() {
							this.video.addEventListener('play', () => {
								this.container.classList.remove(Cd)
							}),
								this.container.addEventListener(
									'touchstart',
									() => {
										this.video.play()
									},
									{ passive: !0 },
								)
						}
						constructor(t) {
							;(this.container = t),
								(this.videoId = this.container.querySelector(wd)),
								(this.videoPlayer = this.container.querySelector(Ed)),
								(this.videoTemplate = this.container.querySelector(Sd)),
								(this.videoPlayButton = this.container.querySelector(Ad)),
								this.init()
						}
					})(t),
				)
			})
		},
	}
	let Fd = class {
		write() {
			;((-1 !== document.cookie.indexOf('; ') &&
				!document.cookie.split('; ').find((t) => t.startsWith(this.name))) ||
				-1 === document.cookie.indexOf('; ')) &&
				(document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`)
		}
		read() {
			if (
				-1 !== document.cookie.indexOf('; ') &&
				document.cookie.split('; ').find((t) => t.startsWith(this.name))
			) {
				return document.cookie
					.split('; ')
					.find((t) => t.startsWith(this.name))
					.split('=')[1]
			}
			return !1
		}
		destroy() {
			document.cookie.split('; ').find((t) => t.startsWith(this.name)) &&
				(document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`)
		}
		constructor(t, e) {
			;(this.configuration = {
				expires: null,
				path: '/',
				domain: window.location.hostname,
				sameSite: 'none',
				secure: !0,
			}),
				(this.name = t),
				(this.value = e)
		}
	}
	const Id = '[data-newsletter-form]',
		xd = '[data-popup]',
		Hd = 'has-success',
		Dd = 'has-error',
		Md = 'newsletter_form_id',
		Od = {}
	const _d = {
			onLoad() {
				Od[this.id] = []
				this.container.querySelectorAll(Id).forEach((t) => {
					Od[this.id].push(
						new (class {
							init() {
								this.newsletter.addEventListener(
									'submit',
									this.newsletterSubmit,
								),
									this.showMessage()
							}
							newsletterSubmitEvent(t) {
								this.stopSubmit &&
									(t.preventDefault(),
									this.removeStorage(),
									this.writeStorage(),
									(this.stopSubmit = !1),
									this.newsletter.submit())
							}
							checkForChallengePage() {
								this.isChallengePage =
									window.location.pathname === theme.routes.root + 'challenge'
							}
							writeStorage() {
								void 0 !== this.sessionStorage &&
									this.sessionStorage.setItem(Md, this.newsletter.id)
							}
							readStorage() {
								this.formID = this.sessionStorage.getItem(Md)
							}
							removeStorage() {
								this.sessionStorage.removeItem(Md)
							}
							showMessage() {
								if ((this.readStorage(), this.newsletter.id === this.formID)) {
									const t = document.getElementById(this.formID),
										e =
											-1 !==
											window.location.search.indexOf('?customer_posted=true'),
										i =
											-1 !== window.location.search.indexOf('accepts_marketing')
									e
										? (t.classList.remove(Dd),
										  t.classList.add(Hd),
										  this.popup &&
												((this.cookie = new Fd(
													this.popup.dataset.cookieName,
													'user_has_closed',
												)),
												this.cookie.write()))
										: i && (t.classList.remove(Hd), t.classList.add(Dd)),
										(e || i) && this.scrollToForm(t)
								}
							}
							scrollToForm(t) {
								const e = t.getBoundingClientRect()
								visibilityHelper.isElementPartiallyVisible(t) ||
									visibilityHelper.isElementTotallyVisible(t) ||
									setTimeout(() => {
										window.scrollTo({ top: e.top, left: 0, behavior: 'smooth' })
									}, 400)
							}
							onUnload() {
								this.newsletter.removeEventListener(
									'submit',
									this.newsletterSubmit,
								)
							}
							constructor(t) {
								;(this.newsletter = t),
									(this.sessionStorage = window.sessionStorage),
									(this.popup = this.newsletter.closest(xd)),
									(this.stopSubmit = !0),
									(this.isChallengePage = !1),
									(this.formID = null),
									(this.formIdSuccess = null),
									this.checkForChallengePage(),
									(this.newsletterSubmit = (t) =>
										this.newsletterSubmitEvent(t)),
									this.isChallengePage || this.init()
							}
						})(t),
					)
				})
			},
			onUnload() {
				Od[this.id].forEach((t) => {
					'function' == typeof t.onUnload && t.onUnload()
				})
			},
		},
		Bd = '[data-product]',
		$d = '[data-slider]',
		zd = '[data-slide]',
		Rd = '[data-product-media-container]',
		Vd = '.flickity-button',
		Wd = 'a, button',
		Nd = 'tabindex',
		Ud = {}
	const jd = {
		onLoad() {
			Ud[this.id] = new (class {
				checkSlider() {
					window.innerWidth >= theme.sizes.small
						? this.productSlider.forEach((t) => {
								this.initProductSlider(t)
						  })
						: this.productSlider.forEach((t) => {
								this.destroyProductSlider(t)
						  })
				}
				initProductSlider(t) {
					const i = t.querySelectorAll(zd).length,
						s = t.dataset.slider
					i > 1 &&
						(void 0 !== this.flkty[s] && this.flkty[s].isActive
							? this.setSliderArrowsPosition(t)
							: (this.flkty[s] = new e(t, {
									prevNextButtons: !0,
									adaptiveHeight: !0,
									pageDots: !0,
									wrapAround: !0,
									on: {
										ready: () => {
											this.setSliderArrowsPosition(t)
										},
										change: (t) => {
											this.flkty[s].cells.forEach((e, i) => {
												e.element.querySelectorAll(Wd).forEach((e) => {
													e.setAttribute(Nd, i === t ? '0' : '-1')
												})
											})
										},
									},
							  })))
				}
				destroyProductSlider(t) {
					const e = t.dataset.slider
					'object' == typeof this.flkty[e] && this.flkty[e].destroy()
				}
				setSliderArrowsPosition(t) {
					const e = t.querySelectorAll(Vd),
						i = t.querySelector(Rd)
					e.length &&
						i &&
						e.forEach((t) => {
							t.style.top = i.offsetHeight / 2 + 'px'
						})
				}
				resizeSlider(t) {
					const i = t.target,
						s = e.data(i) || null
					s && s.resize()
				}
				listen() {
					this.checkSlider(),
						document.addEventListener(
							'theme:resize:width',
							this.checkSliderOnResize,
						),
						this.productSlider.forEach((t) => {
							t.addEventListener('theme:slider:resize', this.resizeSliderEvent)
						})
				}
				onUnload() {
					if (this.flkty)
						for (const t in this.flkty)
							this.flkty.hasOwnProperty(t) && this.flkty[t].destroy()
					document.removeEventListener(
						'theme:resize:width',
						this.checkSliderOnResize,
					),
						this.productSlider.forEach((t) => {
							t.removeEventListener(
								'theme:slider:resize',
								this.resizeSliderEvent,
							)
						})
				}
				constructor(t) {
					;(this.container = t),
						(this.product = this.container.querySelectorAll(Bd)),
						(this.productSlider = this.container.querySelectorAll($d)),
						(this.checkSliderOnResize = () => this.checkSlider()),
						(this.resizeSliderEvent = (t) => this.resizeSlider(t)),
						(this.flkty = []),
						(this.videoObj = []),
						(this.quickViewObj = []),
						this.listen()
				}
			})(this.container)
		},
		onUnload(t) {
			Ud[this.id].onUnload(t)
		},
	}
	ct('custom-content', [jd, _d, jh, Pd, ps])
	const Kd = '[data-slider]',
		Qd = '[data-slide]',
		Gd = '[data-product-media-container]',
		Xd = 'a, button',
		Jd = '.flickity-button',
		Yd = '[data-promo]',
		Zd = 'carousel',
		tu = 'carousel--inactive',
		eu = 'is-last-slide-visible',
		iu = 'featured-collection',
		su = 'collection-promo--full',
		ou = 'collection-promo--two-columns',
		nu = 'data-slider-id',
		ru = 'data-slider-show-image',
		au = 'tabindex',
		lu = {}
	let cu = class {
		initSlider(t) {
			const i = t.getAttribute(nu)
			t.classList.remove(tu),
				void 0 !== this.flkty[i] && this.flkty[i].isActive
					? this.setSliderArrowsPosition(t)
					: ((this.flkty[i] = new e(t, {
							pageDots: !1,
							cellSelector: Qd,
							cellAlign: 'left',
							groupCells: !0,
							contain: !0,
							wrapAround: !1,
							adaptiveHeight: !1,
							on: {
								ready: () => {
									this.setSliderArrowsPosition(t),
										setTimeout(() => {
											this.changeTabIndex(t)
										}, 0)
								},
								change: () => {
									this.changeTabIndex(t)
								},
							},
					  })),
					  this.handleLastSlideOverlayOnTablet(t))
		}
		destroySlider(t) {
			const e = t.getAttribute(nu)
			t.classList.contains(Zd) && t.classList.add(tu),
				'object' == typeof this.flkty[e] && this.flkty[e].destroy()
		}
		resetSlider(t) {
			const e = t.target,
				i = e.getAttribute(nu)
			'object' == typeof this.flkty[i]
				? this.flkty[i].select(0, !1, !0)
				: e.scrollTo({ left: 0, behavior: 'instant' })
		}
		resizeSlider(t) {
			const i = t.target,
				s = e.data(i) || null
			s && s.resize()
		}
		checkSlidesSize() {
			this.sliders.length &&
				this.sliders.forEach((t) => {
					const e = this.columns,
						i = window.innerWidth >= theme.sizes.large,
						s =
							window.innerWidth >= theme.sizes.small &&
							window.innerWidth < theme.sizes.large
					let o = t.querySelectorAll(Qd).length
					const n = t.querySelectorAll(Yd)
					n.length &&
						i &&
						n.forEach((t) => {
							t.classList.contains(su)
								? (o += e - 1)
								: t.classList.contains(ou) && (o += 1)
						}),
						t.hasAttribute(ru) && (o += 1),
						(i && o > e) || (s && o > 2)
							? this.initSlider(t)
							: this.destroySlider(t)
				})
		}
		changeTabIndex(t) {
			const e = t.getAttribute(nu),
				i = this.flkty[e].selectedIndex
			this.flkty[e].slides.forEach((t, e) => {
				t.cells.forEach((t) => {
					t.element.querySelectorAll(Xd).forEach((t) => {
						t.setAttribute(au, i === e ? '0' : '-1')
					})
				})
			})
		}
		setSliderArrowsPosition(t) {
			const e = t.querySelectorAll(Jd),
				i = t.querySelector(Gd)
			e.length &&
				i &&
				e.forEach((t) => {
					t.style.top = i.offsetHeight / 2 + 'px'
				})
		}
		handleLastSlideOverlayOnTablet(t) {
			const e = t.getAttribute(nu)
			this.flkty[e].on('select', () => {
				if (
					!(
						window.innerWidth >= theme.sizes.small &&
						window.innerWidth < theme.sizes.large
					)
				)
					return
				const i = this.flkty[e].selectedIndex,
					s = this.flkty[e].slides.length - 1 === i
				t.parentNode.classList.toggle(eu, s)
			})
		}
		handleLastSlideOverlayOnMobile() {
			this.sliders.forEach((t) => {
				t.addEventListener('scroll', (e) => {
					if (!(window.innerWidth < theme.sizes.small)) return
					const i = e.target.offsetWidth,
						s =
							Array.from(t.children).pop().getBoundingClientRect().left + 80 < i
					t.parentNode.classList.toggle(eu, s)
				})
			})
		}
		listen() {
			this.sliders.length &&
				(this.checkSlidesSize(),
				document.addEventListener(
					'theme:resize:width',
					this.checkSlidesSizeOnResize,
				),
				this.sliders.forEach((t) => {
					t.addEventListener('theme:tab:change', this.resetSliderEvent),
						t.addEventListener('theme:slider:resize', this.resizeSliderEvent)
				}))
		}
		onBlockSelect(t) {
			const i = t.target.closest(Kd),
				s = e.data(i) || null
			if (!i) return
			let o = t.target.parentNode,
				n = t.target
			if (
				(this.container.classList.contains(iu) &&
					((o = o.parentNode), (n = n.parentNode)),
				null !== s && s.isActive)
			) {
				const t = parseInt([...o.children].indexOf(n)),
					e = parseInt(s.slides[0].cells.length),
					i = Math.floor(t / e)
				s.select(i)
			} else {
				const t = i.currentStyle || window.getComputedStyle(i),
					e = parseInt(t.paddingLeft),
					s = n.offsetLeft - e
				i.scrollTo({ top: 0, left: s, behavior: 'smooth' })
			}
		}
		onUnload() {
			if (this.flkty)
				for (const t in this.flkty)
					this.flkty.hasOwnProperty(t) && this.flkty[t].destroy()
			document.removeEventListener(
				'theme:resize:width',
				this.checkSlidesSizeOnResize,
			),
				this.sliders.length &&
					this.sliders.forEach((t) => {
						t.removeEventListener('theme:tab:change', this.resetSliderEvent),
							t.removeEventListener(
								'theme:slider:resize',
								this.resizeSliderEvent,
							)
					})
		}
		constructor(t) {
			;(this.container = t),
				(this.columns = parseInt(this.container.dataset.columns)),
				(this.sliders = this.container.querySelectorAll(Kd)),
				(this.checkSlidesSizeOnResize = () => this.checkSlidesSize()),
				(this.resetSliderEvent = (t) => this.resetSlider(t)),
				(this.resizeSliderEvent = (t) => this.resizeSlider(t)),
				(this.flkty = []),
				this.listen(),
				this.handleLastSlideOverlayOnMobile()
		}
	}
	const hu = {
		onLoad() {
			lu[this.id] = []
			this.container.querySelectorAll(Kd).forEach((t) => {
				lu[this.id].push(new cu(this.container))
			})
		},
		onUnload() {
			lu[this.id].forEach((t) => {
				'function' == typeof t.onUnload && t.onUnload()
			})
		},
		onBlockSelect(t) {
			lu[this.id].forEach((e) => {
				'function' == typeof e.onBlockSelect && e.onBlockSelect(t)
			})
		},
	}
	ct('featured-collection', [ps, Re, hu]), ct('featured-video', [jh, Pd])
	const du = '[data-shop-pay-wrapper]',
		uu = 'shop-login-button',
		pu = 'shop-follow-button',
		mu = 'follow-on-shop-button',
		gu = 'heart-icon',
		vu = 'shop-logo',
		yu = {}
	const fu = '[data-collapsible-trigger-mobile]',
		bu = 'is-expanded'
	ct('footer', [
		na,
		_d,
		Tt,
		{
			onBlockSelect(t) {
				const e = t.target.querySelector(fu)
				requestAnimationFrame(() => {
					e && !e.classList.contains(bu) && e.dispatchEvent(new Event('click'))
				})
			},
			onBlockDeselect(t) {
				const e = t.target.querySelector(fu)
				requestAnimationFrame(() => {
					e && e.classList.contains(bu) && e.dispatchEvent(new Event('click'))
				})
			},
		},
		{
			onLoad() {
				yu[this.id] = new (class {
					init() {
						if (!this.shopLoginButton || !this.shopPayWrapper) return
						const t = this.shopPayWrapper.dataset.bg || 'transparent',
							e = this.shopPayWrapper.dataset.text || '#fff',
							i = this.shopPayWrapper.dataset.hover || '#fff'
						;(this.mainButtonStyles = `\n      :host {\n        --bg-color: ${t};\n        --text-color: ${e};\n        --hover-color: ${i};\n      }\n\n      .follow-icon-wrapper:before {\n        background: var(--bg-color);\n        border-color: var(--text-color);\n        transition: border 0.3s ease;\n      }\n\n      .button:not(.button--following):focus-visible .follow-icon-wrapper:before,\n      .button:not(.button--following):hover .follow-icon-wrapper:before {\n        background: var(--bg-color);\n        border-color: var(--hover-color);\n      }\n\n      .button {\n        background: transparent;\n        color: var(--text-color);\n      }\n\n      .following-text {\n        color: var(--text-color);\n      }\n\n      .button--following:focus-visible,\n      .button--following:hover {\n        background: var(--bg-color);\n      }\n\n      .button:not(.button--following):focus-visible .follow-icon-wrapper:before,\n      .button:not(.button--following):hover .follow-icon-wrapper:before {\n        background: var(--bg-color);\n        border-color: var(--hover-color);\n      }\n    `),
							(this.svgIconsStyles = `\n      :host {\n        color: ${e};\n      }\n    `),
							customElements.whenDefined(uu).then((t) => {
								requestAnimationFrame(() => {
									const t = this.shopLoginButton.shadowRoot,
										e = null == t ? void 0 : t.querySelector(pu),
										i = null == e ? void 0 : e.shadowRoot,
										s = null == i ? void 0 : i.querySelector(mu),
										o = null == s ? void 0 : s.shadowRoot
									o &&
										this.overwriteStyles(
											o.host.shadowRoot,
											this.mainButtonStyles,
										)
									const n = o.querySelector(gu),
										r = null == n ? void 0 : n.shadowRoot,
										a = o.querySelector(vu),
										l = null == a ? void 0 : a.shadowRoot
									r &&
										this.overwriteStyles(
											r.host.shadowRoot,
											this.svgIconsStyles,
										),
										l &&
											this.overwriteStyles(
												l.host.shadowRoot,
												this.svgIconsStyles,
											)
								})
							})
					}
					overwriteStyles(t, e) {
						let i = document.createElement('style')
						;(i.innerHTML = e), t.appendChild(i)
					}
					constructor(t) {
						;(this.container = t),
							(this.shopPayWrapper = document.querySelector(du)),
							(this.shopLoginButton = document.querySelector(uu)),
							this.init()
					}
				})(this.container)
			},
		},
	])
	const wu = '[data-hover-disclosure]',
		Eu = '[data-site-header]',
		Su = '[data-top-link]',
		Lu = '[data-header-background]',
		ku = '[data-nav-item]',
		Au = 'is-visible',
		qu = 'grandparent',
		Cu = 'site-header--menu-opened',
		Tu = 'has-scrolled',
		Pu = 'site-header--hovered',
		Fu = 'search-opened',
		Iu = 'data-hover-disclosure-toggle',
		xu = 'aria-haspopup',
		Hu = 'aria-expanded',
		Du = 'aria-controls'
	let Mu = {}
	const Ou = {
			onLoad() {
				Mu[this.id] = []
				this.container.querySelectorAll(wu).forEach((t) => {
					Mu[this.id].push(
						new (class {
							showDisclosure() {
								;(this.hasScrolled = document.body.classList.contains(Tu)),
									(this.headerHeight = this.hasScrolled
										? window.stickyHeaderHeight
										: this.header.offsetHeight),
									this.grandparent
										? ((this.dropdown.style.height = 'auto'),
										  (this.dropdownHeight =
												this.dropdown.offsetHeight + this.headerHeight))
										: (this.dropdownHeight = this.headerHeight),
									this.background.style.setProperty(
										'--header-background-height',
										`${this.dropdownHeight}px`,
									),
									this.trigger.setAttribute(Hu, !0),
									this.trigger.classList.add(Au),
									this.header.classList.add(Cu),
									this.trigger.classList.contains(qu) &&
										document.dispatchEvent(
											new CustomEvent('theme:scroll:lock', {
												bubbles: !0,
												detail: this.header,
											}),
										),
									this.updateHeaderHover()
							}
							hideDisclosure() {
								this.background.style.removeProperty(
									'--header-background-height',
								),
									this.trigger.classList.remove(Au),
									this.trigger.setAttribute(Hu, !1),
									this.header.classList.remove(Cu),
									document.body.classList.contains(Fu) ||
										document.dispatchEvent(
											new CustomEvent('theme:scroll:unlock', { bubbles: !0 }),
										)
							}
							updateHeaderHover() {
								requestAnimationFrame(() => {
									const t = this.header.matches(':hover'),
										e = this.header.classList.contains(Pu)
									t && !e && this.header.classList.add(Pu)
								})
							}
							handleTablets() {
								this.trigger.addEventListener('touchstart', (t) => {
									if (!this.trigger.classList.contains(Au)) {
										t.preventDefault()
										const e = this.header.querySelectorAll(`.${Au}${ku}`)
										if (e.length > 0)
											return void e.forEach((t) => {
												if (t !== this.trigger) {
													t.dispatchEvent(
														new Event('mouseleave', { bubbles: !0 }),
													)
													const e = () => {
														requestAnimationFrame(() => {
															this.showDisclosure()
														}),
															t.removeEventListener('transitionend', e)
													}
													t.addEventListener('transitionend', e)
												}
											})
										this.showDisclosure()
									}
								})
							}
							connectHoverToggle() {
								this.trigger.addEventListener('mouseenter', () =>
									this.showDisclosure(),
								),
									this.link.addEventListener('focus', () =>
										this.showDisclosure(),
									),
									this.trigger.addEventListener('mouseleave', () =>
										this.hideDisclosure(),
									),
									this.trigger.addEventListener('focusout', (t) => {
										this.trigger.contains(t.relatedTarget) ||
											this.hideDisclosure()
									}),
									this.disclosure.addEventListener('keyup', (t) => {
										t.code === theme.keyboardKeys.ESCAPE &&
											this.hideDisclosure()
									})
							}
							onBlockSelect(t) {
								this.disclosure.contains(t.target) && this.showDisclosure(t)
							}
							onBlockDeselect(t) {
								this.disclosure.contains(t.target) && this.hideDisclosure()
							}
							constructor(t) {
								;(this.disclosure = t),
									(this.header = t.closest(Eu)),
									(this.key = this.disclosure.id),
									(this.trigger = document.querySelector(
										`[${Iu}='${this.key}']`,
									)),
									(this.link = this.trigger.querySelector(Su)),
									(this.grandparent = this.trigger.classList.contains(qu)),
									(this.background = document.querySelector(Lu)),
									this.trigger.setAttribute(xu, !0),
									this.trigger.setAttribute(Hu, !1),
									this.trigger.setAttribute(Du, this.key),
									(this.dropdown = this.trigger.querySelector(wu)),
									this.connectHoverToggle(),
									this.handleTablets()
							}
						})(t),
					)
				})
			},
			onBlockSelect(t) {
				Mu[this.id].forEach((e) => {
					'function' == typeof e.onBlockSelect && e.onBlockSelect(t)
				})
			},
			onBlockDeselect(t) {
				Mu[this.id].forEach((e) => {
					'function' == typeof e.onBlockDeselect && e.onBlockDeselect(t)
				})
			},
		},
		_u = '[data-site-header]',
		Bu = '[data-announcement-wrapper]',
		$u = '[data-collection-filters]',
		zu = '[data-logo]',
		Ru = '[data-logo-text-link]',
		Vu = '[data-collapsible-trigger]',
		Wu = '#nav-drawer',
		Nu = '[data-drawer]',
		Uu = '[data-drawer-toggle]',
		ju = '[data-popdown-toggle]',
		Ku = '[data-mobile-menu]',
		Qu = '[data-nav]',
		Gu = '[data-nav-icons]',
		Xu = '[data-nav-item]',
		Ju = '[data-nav-link-mobile]',
		Yu = '[data-nav-search-open]',
		Zu = '[data-wrapper]',
		tp = '[data-header-background]',
		ep = '[data-cart-page]',
		ip = '[data-takes-space]',
		sp = {
			jsDrawerOpenAll: [
				'js-drawer-open',
				'js-drawer-open-cart',
				'js-quick-view-visible',
				'js-quick-view-from-cart',
			],
			headerTransparent: 'site-header--transparent',
			headerLoading: 'site-header--loading',
			headerHovered: 'site-header--hovered',
			headerMenuOpened: 'site-header--menu-opened',
			hasScrolled: 'has-scrolled',
			hideHeader: 'hide-header',
			navCompress: 'nav--compress',
			logoCompress: 'logo--compress',
			isVisible: 'is-visible',
			isOpen: 'is-open',
			searchOpened: 'search-opened',
			noOutline: 'no-outline',
			cloneClass: 'js__header__clone',
		},
		op = 'data-nav-alignment',
		np = {}
	ct('header', [
		{
			onLoad() {
				np[this.id] = new (class {
					updateHeaderHover() {
						requestAnimationFrame(() => {
							const t = this.header.matches(':hover'),
								e = this.header.classList.contains(sp.headerHovered)
							t && !e && this.header.classList.add(sp.headerHovered)
						})
					}
					handleTouchstart(t) {
						const e = this.header.contains(t.target),
							i = this.header.querySelector(`.${sp.isVisible}${Xu}`)
						!e && i && i.dispatchEvent(new Event('mouseleave', { bubbles: !0 }))
					}
					handleTextLinkLogos() {
						if (null === this.logoTextLink) return
						const t = this.header.offsetHeight
						document.documentElement.style.setProperty(
							'--header-height',
							`${t}px`,
						),
							document.documentElement.style.setProperty(
								'--header-sticky-height',
								`${t}px`,
							)
					}
					initStickyHeader() {
						if (
							((this.hasScrolled = !1),
							(this.hasCollectionFilters = document.querySelector($u)),
							(this.position = this.header.dataset.position),
							'fixed' === this.position && !this.hasCollectionFilters)
						)
							return (
								this.header.classList.remove(sp.headerLoading),
								this.headerState(),
								void document.addEventListener(
									'theme:scroll',
									this.headerStateEvent,
								)
							)
						document.body.classList.remove(sp.hasScrolled),
							window.isHeaderTransparent &&
								this.header.classList.add(sp.headerTransparent),
							this.header.classList.remove(sp.headerLoading)
					}
					headerState(t) {
						const e = parseInt(
								this.header.dataset.height || this.header.offsetHeight,
							),
							i = document.querySelector(Bu),
							s = e + (i ? i.offsetHeight : 0),
							o = window.pageYOffset || document.documentElement.scrollTop,
							n = t && t.detail && t.detail.up
						;(this.hasScrolled = o > s),
							document.body.classList.toggle(sp.hasScrolled, this.hasScrolled)
						const r = o < s + window.stickyHeaderHeight && n
						if (
							(document.body.classList.toggle(sp.hideHeader, r),
							window.isHeaderTransparent)
						) {
							const t = !this.hasScrolled || r
							this.header.classList.toggle(sp.headerTransparent, t)
						}
						if (this.header.classList.contains(sp.headerHovered)) {
							const t = this.hasScrolled ? window.stickyHeaderHeight : e
							this.background.style.setProperty(
								'--header-background-height',
								`${t}px`,
							)
							const i = this.header.querySelector(`.${sp.isVisible}${Xu}`)
							i && i.dispatchEvent(new Event('mouseenter', { bubbles: !0 }))
						}
					}
					handleBackgroundEvents() {
						this.headerWrapper.addEventListener(
							'mouseenter',
							this.updateBackgroundHeightEvent,
						),
							this.headerWrapper.addEventListener(
								'mouseleave',
								this.updateBackgroundHeightEvent,
							),
							this.header.addEventListener(
								'focusout',
								this.updateBackgroundHeightEvent,
							),
							document.addEventListener(
								'theme:cart:close',
								this.updateBackgroundHeightEvent,
							),
							document.addEventListener(
								'theme:search:close',
								this.updateBackgroundHeightEvent,
							)
					}
					updateBackgroundHeight(t) {
						const e = matchMedia('(pointer:fine)').matches,
							i = !document.body.classList.contains(sp.noOutline),
							s = e && !i
						if (!t) return
						let o = sp.jsDrawerOpenAll.some((t) =>
							document.body.classList.contains(t),
						)
						;('mouseenter' === t.type || o) &&
							((this.headerHeight = this.hasScrolled
								? window.stickyHeaderHeight
								: this.header.offsetHeight),
							this.header.classList.add(sp.headerHovered),
							this.header.classList.contains(sp.headerMenuOpened) ||
								this.background.style.setProperty(
									'--header-background-height',
									`${this.headerHeight}px`,
								)),
							'mouseenter' !== t.type &&
								requestAnimationFrame(() => {
									if (
										((o = sp.jsDrawerOpenAll.some((t) =>
											document.body.classList.contains(t),
										)),
										o)
									)
										return
									if ('focusout' === t.type && !e) return
									if ('theme:search:close' === t.type && !s) return
									if (this.hasScrolled) return
									const n = null === document.activeElement.closest(_u),
										r = document.body.classList.contains(sp.searchOpened),
										a = this.header.classList.contains(sp.headerMenuOpened)
									r ||
										a ||
										(('focusout' !== t.type || n) &&
											(this.header.classList.remove(sp.headerHovered),
											this.background.style.setProperty(
												'--header-background-height',
												'0px',
											),
											i || document.activeElement.blur()))
								})
					}
					listenWidth() {
						document.addEventListener('theme:resize', this.checkWidthEvent),
							this.checkWidth()
					}
					checkWidth() {
						window.innerWidth < this.minWidth
							? (this.nav.classList.add(sp.navCompress),
							  this.logo.classList.add(sp.logoCompress))
							: (this.nav.classList.remove(sp.navCompress),
							  this.logo.classList.remove(sp.logoCompress))
					}
					getMinWidth() {
						const t =
								this.headerWrapper.currentStyle ||
								window.getComputedStyle(this.headerWrapper),
							e = 2 * parseInt(t.paddingLeft),
							i = this.header.cloneNode(!0)
						i.classList.add(sp.cloneClass), document.body.appendChild(i)
						const s = i.querySelectorAll(ip),
							o = (function (t, e) {
								let i = []
								t.forEach((t) => {
									i.push(t.clientWidth)
								})
								let [s, o, n] = i
								if ('left' === e) {
									const t = s
									;(s = o), (o = t)
								}
								return 'right' !== e && (s > n ? (n = s) : (s = n)), s + o + n
							})(s, this.header.getAttribute(op))
						return document.body.removeChild(i), o + 20 * s.length + e
					}
					initMobileNav() {
						var t
						if (
							((this.mobileMenu = this.headerSection.querySelector(Ku)),
							(this.navDrawer = this.headerSection.querySelector(Wu)),
							(this.drawerToggle = this.navDrawer.querySelector(Uu)),
							(this.navSearchOpen = this.navDrawer.querySelectorAll(Yu)),
							null === (t = this.navSearchOpen) ||
								void 0 === t ||
								t.forEach((t) => {
									t.addEventListener('click', (t) => {
										t.preventDefault()
										const e = this.drawerToggle.closest(`${Nu}.${sp.isOpen}`),
											i = matchMedia('(pointer:coarse)').matches
												? this.mobileMenu.querySelector(ju)
												: this.nav.querySelector(ju)
										this.drawerToggle.dispatchEvent(
											new Event('click', { bubbles: !0 }),
										)
										const s = (t) => {
											t.target === e &&
												(requestAnimationFrame(() =>
													i.dispatchEvent(new Event('click', { bubbles: !0 })),
												),
												e.removeEventListener('transitionend', s))
										}
										e.addEventListener('transitionend', s)
									})
								}),
							'link' === theme.settings.mobileMenuBehaviour)
						)
							return
						const e = this.headerSection.querySelectorAll(Ju)
						e.length &&
							e.forEach((t) => {
								t.addEventListener('click', (e) => {
									const i = t.parentNode.querySelectorAll(Vu).length,
										s = t.nextElementSibling
									i &&
										(e.preventDefault(),
										s.dispatchEvent(new Event('click'), { bubbles: !0 }))
								})
							})
					}
					onUnload() {
						document.documentElement.style.removeProperty('--header-height'),
							document.documentElement.style.removeProperty(
								'--header-sticky-height',
							),
							this.initStickyHeader(),
							document.body.classList.remove(...sp.jsDrawerOpenAll),
							document.removeEventListener(
								'theme:scroll',
								this.headerStateEvent,
							),
							document.removeEventListener(
								'theme:resize',
								this.checkWidthEvent,
							),
							document.removeEventListener(
								'theme:cart:close',
								this.updateBackgroundHeightEvent,
							),
							document.removeEventListener(
								'theme:search:close',
								this.updateBackgroundHeightEvent,
							),
							document.body.removeEventListener(
								'touchstart',
								this.handleTouchstartEvent,
							),
							document.dispatchEvent(
								new CustomEvent('theme:scroll:unlock', { bubbles: !0 }),
							),
							'function' == typeof window.cart.unload && window.cart.unload()
					}
					constructor(t) {
						;(this.container = t),
							(this.background = document.querySelector(tp)),
							(this.header = t),
							(this.headerSection = t.parentNode),
							(this.headerWrapper = t.querySelector(Zu)),
							(this.logo = t.querySelector(zu)),
							(this.logoTextLink = t.querySelector(Ru)),
							(this.nav = t.querySelector(Qu)),
							(this.navIcons = t.querySelector(Gu)),
							(this.headerStateEvent = (t) => this.headerState(t)),
							(this.handleTouchstartEvent = (t) => this.handleTouchstart(t)),
							(this.updateBackgroundHeightEvent = (t) =>
								this.updateBackgroundHeight(t)),
							m(),
							(this.minWidth = this.getMinWidth()),
							(this.checkWidthEvent = () => this.checkWidth()),
							this.listenWidth(),
							this.initMobileNav(),
							this.handleTextLinkLogos(),
							this.initStickyHeader(),
							this.handleBackgroundEvents(),
							document.querySelector(ep) || (window.cart = new dc()),
							document.body.addEventListener(
								'touchstart',
								this.handleTouchstartEvent,
								{ passive: !0 },
							),
							this.updateHeaderHover()
					}
				})(this.container)
			},
			onUnload() {
				np[this.id].onUnload()
			},
		},
		Ou,
		un,
	])
	const rp = '[data-slider]'
	let ap = {}
	ct('icons-row', {
		onLoad() {
			ap[this.id] = new (class {
				onBlockSelect(t) {
					const e =
							this.slider.currentStyle || window.getComputedStyle(this.slider),
						i = parseInt(e.paddingLeft),
						s = t.target.offsetLeft - i
					this.slider.scrollTo({ top: 0, left: s, behavior: 'smooth' })
				}
				constructor(t) {
					;(this.container = t.container),
						(this.slider = this.container.querySelector(rp))
				}
			})(this)
		},
		onBlockSelect(t) {
			ap[this.id].onBlockSelect(t)
		},
	})
	const lp = '[data-accordion-item]',
		cp = '[data-accordion-button]',
		hp = 'is-expanded',
		dp = {}
	ct('image-accordions', {
		onLoad() {
			dp[this.id] = new (class {
				init() {
					this.imageAccordionsItems.forEach((t) => {
						t.addEventListener(
							'mouseenter',
							this.accordionExpandEvent.bind(this, t),
						)
					}),
						this.buttons.forEach((t) => {
							t.addEventListener(
								'focusin',
								this.accordionFocusEvent.bind(this, t),
							)
						})
				}
				accordionExpand(t) {
					t.classList.contains(hp) ||
						(this.imageAccordionsItems.forEach((t) => {
							t.classList.remove(hp)
						}),
						t.classList.add(hp))
				}
				accordionFocus(t) {
					t.closest(lp).dispatchEvent(new Event('mouseenter'))
				}
				onBlockSelect(t) {
					const e = t.target
					e && e.dispatchEvent(new Event('mouseenter'))
				}
				constructor(t) {
					;(this.container = t.container),
						(this.imageAccordionsItems = this.container.querySelectorAll(lp)),
						(this.buttons = this.container.querySelectorAll(cp)),
						(this.accordionExpandEvent = (t) => this.accordionExpand(t)),
						(this.accordionFocusEvent = (t) => this.accordionFocus(t)),
						this.init()
				}
			})(this)
		},
		onBlockSelect(t) {
			dp[this.id].onBlockSelect(t)
		},
	}),
		ct('image-with-text', jh),
		ct('list-collections', hu)
	const up = {},
		pp = '[data-slider-gallery]',
		mp = '[data-slider-info]',
		gp = '[data-slide-item]'
	ct('locations', {
		onLoad() {
			up[this.id] = new (class {
				initSlider() {
					const t = this.container.querySelectorAll(gp).length
					let i = e.data(this.slider) || null,
						s = e.data(this.sliderNav) || null
					t <= 1 ||
						((i = new e(this.slider, {
							fade: !0,
							wrapAround: !0,
							adaptiveHeight: !0,
							prevNextButtons: !1,
							pageDots: !1,
						})),
						ae(this.slider),
						(s = new e(this.sliderNav, {
							fade: !0,
							wrapAround: !0,
							imagesLoaded: !0,
							lazyLoad: !0,
							asNavFor: this.slider,
							prevNextButtons: !0,
							pageDots: !1,
						})),
						s.on('change', () => {
							i.selectCell(s.selectedIndex)
						}),
						i.on('change', () => {
							s.selectCell(i.selectedIndex)
						}))
				}
				onBlockSelect(t) {
					const i = e.data(this.slider) || null,
						s = e.data(this.sliderNav) || null,
						o = parseInt([...t.target.parentNode.children].indexOf(t.target))
					null !== i && i.select(o), null !== s && s.select(o)
				}
				constructor(t) {
					;(this.container = t.container),
						(this.slider = this.container.querySelector(pp)),
						(this.sliderNav = this.container.querySelector(mp)),
						this.initSlider()
				}
			})(this)
		},
		onBlockSelect(t) {
			up[this.id].onBlockSelect(t)
		},
	})
	const vp = {},
		yp = '[data-slider]',
		fp = '[data-slide-item]',
		bp = '[data-pointer]',
		wp = '[data-product-media-container]',
		Ep = '[data-quick-view-item-holder]',
		Sp = '.flickity-button',
		Lp = 'a, button',
		kp = '[data-tooltip]',
		Ap = 'data-pointer',
		qp = 'data-hotspot',
		Cp = 'tabindex',
		Tp = 'product-grid-item__image--hovered',
		Pp = 'pointer--selected',
		Fp = 'is-selected',
		Ip = 'is-active',
		xp = 'pswp--open'
	const Hp = {
		onLoad() {
			vp[this.id] = new (class {
				listen() {
					this.slider &&
						(this.checkSlidesSize(),
						document.addEventListener(
							'theme:resize:width',
							this.checkSlidesSizeOnResize,
						),
						this.slider.addEventListener(
							'theme:slider:resize',
							this.resizeSliderEvent,
						)),
						this.pointers.length > 0 &&
							this.pointers.forEach((t) => {
								t.addEventListener('click', this.pointersInit),
									t.addEventListener('mouseover', this.pointersOver),
									t.addEventListener('mouseleave', this.pointersOut)
							})
				}
				checkSlidesSize() {
					const t = window.innerWidth >= theme.sizes.small
					this.initTooltips(),
						t
							? this.slides.length > 2
								? this.initSlider()
								: (this.destroySlider(), this.slidesTabIndex())
							: !t && this.slides.length > 1
							? this.initSlider()
							: this.destroySlider()
				}
				initTooltips() {
					;(this.tooltips = this.container.querySelectorAll(kp)),
						this.tooltips.forEach((t) => {
							new ze(t)
						})
				}
				initSlider() {
					null !== this.flkty
						? this.setSliderArrowsPosition()
						: (this.flkty = new e(this.slider, {
								prevNextButtons: !0,
								wrapAround: !0,
								adaptiveHeight: !1,
								cellAlign: 'left',
								groupCells: !1,
								contain: !0,
								on: {
									ready: () => {
										this.slidesTabIndex(),
											this.setSliderArrowsPosition(),
											this.dotPointers()
									},
									change: () => {
										this.slidesTabIndex(), this.dotPointers()
									},
								},
						  }))
				}
				setSliderArrowsPosition() {
					if (!(window.innerWidth >= theme.sizes.small)) return
					const t = this.slider.querySelectorAll(Sp),
						e = this.slider.querySelector(wp)
					t.length &&
						e &&
						t.forEach((t) => {
							t.style.top = e.offsetHeight / 2 + 'px'
						})
				}
				slidesTabIndex() {
					this.slides.length < 3
						? this.slider.querySelectorAll(Lp).forEach((t) => {
								t.setAttribute(Cp, '0')
						  })
						: e.data(this.slider).cells.forEach((t) => {
								let e = '-1'
								t.element.classList.contains(Fp) && (e = '0'),
									t.element.querySelectorAll(Lp).forEach((t) => {
										t.setAttribute(Cp, e)
									})
						  })
				}
				destroySlider() {
					'object' == typeof this.flkty &&
						null !== this.flkty &&
						(this.flkty.destroy(), (this.flkty = null))
				}
				resizeSlider(t) {
					const i = t.target,
						s = e.data(i) || null
					s && s.resize()
				}
				dotPointers(t) {
					if (0 === this.pointers.length) return
					if (
						(this.pointers.forEach((t) => {
							t.classList.remove(Pp)
						}),
						t)
					) {
						var e
						const i = t.target.getAttribute(Ap)
						return void (
							null === (e = this.flkty) ||
							void 0 === e ||
							e.select(i)
						)
					}
					const i = null == this.flkty ? 0 : this.flkty.selectedIndex
					i >= 0 && this.pointers[i].classList.add(Pp)
				}
				dotPointerIn(t) {
					const e = t.target.getAttribute(Ap),
						i = this.slides[e].querySelector(wp),
						s = matchMedia('(pointer:coarse)').matches
					window.innerWidth < theme.sizes.small || s || this.observeImage(i),
						this.pointers.forEach((t) => {
							t.style.setProperty('--look-animation', 'none')
						})
				}
				dotPointerOut(t) {
					const e = t.target.getAttribute(Ap),
						i = this.slides[e].querySelector(wp)
					i.classList.remove(Tp),
						i.dispatchEvent(new Event('mouseleave')),
						this.observer && this.observer.disconnect(),
						this.pointers.forEach((t) => {
							t.style.removeProperty('--look-animation')
						})
				}
				observeImage(t) {
					;(this.observer = new IntersectionObserver(
						(t, e) => {
							t.forEach((t) => {
								const e = t.target
								0 == t.intersectionRatio ||
									(e.dispatchEvent(new Event('mouseenter')),
									e.classList.add(Tp))
							})
						},
						{ root: this.slider, threshold: [0.95, 1] },
					)),
						this.observer.observe(t)
				}
				triggerClick(t) {
					requestAnimationFrame(() => t.dispatchEvent(new Event('click')))
				}
				destroyQuickViewPopup() {
					var t, e
					const i =
						null === (t = this.quickViewPopup) ||
						void 0 === t ||
						null === (e = t.loadPhotoswipe) ||
						void 0 === e
							? void 0
							: e.pswpElement
					i &&
						i.classList.contains(xp) &&
						this.quickViewPopup.loadPhotoswipe.popup.close()
				}
				onBlockSelect(t) {
					this.debouncedBlockSelectCallback(t)
				}
				debouncedBlockSelect(t) {
					var e, i
					const s =
						null === (e = this.quickViewPopup) ||
						void 0 === e ||
						null === (i = e.loadPhotoswipe) ||
						void 0 === i
							? void 0
							: i.pswpElement
					s
						? setTimeout(() => {
								if (s.classList.contains(xp)) {
									const e =
											this.quickViewPopup.loadPhotoswipe.pswpElement.querySelector(
												`[${qp}="${t.target.getAttribute(qp)}"]`,
											),
										i =
											this.quickViewPopup.loadPhotoswipe.pswpElement.querySelectorAll(
												Ep,
											)
									e.classList.add(Ip),
										i.forEach((t) => {
											t !== e && t.classList.remove(Ip)
										})
								} else this.triggerClick(t.target)
						  })
						: setTimeout(() => this.triggerClick(t.target), 400)
				}
				onUnload() {
					this.destroyQuickViewPopup(),
						document.removeEventListener(
							'theme:resize:width',
							this.checkSlidesSizeOnResize,
						),
						this.slider &&
							this.slider.removeEventListener(
								'theme:slider:resize',
								this.resizeSliderEvent,
							)
				}
				onDeselect() {
					this.destroyQuickViewPopup()
				}
				constructor(t) {
					;(this.container = t),
						(this.slider = this.container.querySelector(yp)),
						(this.slides = this.container.querySelectorAll(fp)),
						(this.pointers = this.container.querySelectorAll(bp)),
						(this.flkty = null),
						(this.observer = null),
						(this.checkSlidesSizeOnResize = () => this.checkSlidesSize()),
						(this.resizeSliderEvent = (t) => this.resizeSlider(t)),
						(this.pointersInit = (t) => this.dotPointers(t)),
						(this.pointersOver = (t) => this.dotPointerIn(t)),
						(this.pointersOut = (t) => this.dotPointerOut(t)),
						(this.debouncedBlockSelectCallback = n(
							(t) => this.debouncedBlockSelect(t),
							500,
						)),
						(this.quickViewPopup = new Il(this.container)),
						this.listen()
				}
			})(this.container)
		},
		onUnload() {
			vp[this.id].onUnload()
		},
		onBlockSelect(t) {
			vp[this.id].onBlockSelect(t)
		},
		onDeselect() {
			vp[this.id].onDeselect()
		},
	}
	ct('look', [Hp])
	const Dp = '[data-grid]'
	ct('mosaic', {
		onBlockSelect(t) {
			const e = t.target.closest(Dp),
				i = e.currentStyle || window.getComputedStyle(e),
				s = parseInt(i.paddingLeft),
				o = t.target.offsetLeft - s
			e.scrollTo({ top: 0, left: o, behavior: 'smooth' })
		},
	}),
		ct('newsletter', _d),
		ct('overlapping-images', jh)
	const Mp = '[data-toggle-admin]',
		Op = '[data-toggle-newsletter]',
		_p = '[data-form-admin]',
		Bp = '[data-form-newsletter]'
	let $p = {}
	ct('password-template', {
		onLoad() {
			$p[this.id] = new (class {
				init() {
					this.toggleAdmin.addEventListener('click', (t) => {
						t.preventDefault(), this.showPasswordForm()
					}),
						this.toggleNewsletter.addEventListener('click', (t) => {
							t.preventDefault(), this.hidePasswordForm()
						}),
						'#login' == window.location.hash || this.adminErrors
							? this.showPasswordForm()
							: this.hidePasswordForm()
				}
				showPasswordForm() {
					pn(this.adminForm),
						mn(this.newsletterForm),
						(window.location.hash = '#login')
				}
				hidePasswordForm() {
					pn(this.newsletterForm),
						mn(this.adminForm),
						(window.location.hash = '')
				}
				constructor(t) {
					;(this.container = t.container),
						(this.toggleAdmin = this.container.querySelector(Mp)),
						(this.toggleNewsletter = this.container.querySelector(Op)),
						(this.adminForm = this.container.querySelector(_p)),
						(this.newsletterForm = this.container.querySelector(Bp)),
						(this.adminErrors = this.adminForm.querySelector('.errors')),
						(this.newsletterErrors =
							this.newsletterForm.querySelector('.errors')),
						this.init()
				}
			})(this)
		},
	})
	const zp = '[data-large-promo]',
		Rp = '[data-large-promo-inner]',
		Vp = '[data-tracking-consent]',
		Wp = '[data-tracking-consent-inner]',
		Np = '[data-confirm-cookies]',
		Up = '[data-popup-bar]',
		jp = '[data-popup-bar-holder]',
		Kp = '[data-popup-bar-toggle]',
		Qp = '[data-popup-body]',
		Gp = '[data-popup-close]',
		Xp = '[data-popup-underlay]',
		Jp = '[data-newsletter-form]',
		Yp = 'data-target-referrer',
		Zp = 'data-prevent-scroll-lock',
		tm = 'has-success',
		em = 'has-error',
		im = 'selected',
		sm = 'has-block-selected',
		om = 'popup--expanded',
		nm = 'popup--visible',
		rm = 'mobile',
		am = 'desktop',
		lm = 'popup--bar',
		cm = 'popup-bar-is-visible'
	let hm = {},
		dm = 0,
		um = 0,
		pm = [],
		mm = class {
			always() {
				this.showPopup()
			}
			delayed(t = 10) {
				setTimeout(() => {
					this.showPopup()
				}, 1e3 * t)
			}
			bottom() {
				document.addEventListener('theme:scroll', this.showPopupOnScrollEvent)
			}
			idle() {
				if (!(!0 === this.checkPopupTarget())) return
				let t = 0
				const e = [
						'mousemove',
						'mousedown',
						'click',
						'touchmove',
						'touchstart',
						'touchend',
						'keydown',
						'keypress',
					],
					i = ['load', 'resize', 'scroll'],
					s = () => {
						;(t = setTimeout(() => {
							;(t = 0), this.showPopup()
						}, 6e4)),
							e.forEach((t) => {
								document.addEventListener(t, o)
							}),
							i.forEach((t) => {
								window.addEventListener(t, o)
							})
					},
					o = () => {
						t && clearTimeout(t),
							e.forEach((t) => {
								document.removeEventListener(t, o)
							}),
							i.forEach((t) => {
								window.removeEventListener(t, o)
							}),
							s()
					}
				s()
			}
			showPopup() {
				const t = { id: this.popup.id, body: this.popupBody }
				pm.push(t)
				if (!0 === this.checkPopupTarget()) {
					if (
						((um += 1),
						this.popup.classList.add(nm),
						this.popup.classList.contains(lm) &&
							document.body.classList.add(cm),
						this.a11y.trapFocus({ container: this.popupBody }),
						this.popup.hasAttribute(Zp))
					)
						return !1
					this.scrollLock()
				}
			}
			checkPopupTarget() {
				const t = this.popup.parentNode.classList.contains(rm),
					e = this.popup.parentNode.classList.contains(am)
				return !(
					(t && window.innerWidth >= theme.sizes.small) ||
					(e && window.innerWidth < theme.sizes.small)
				)
			}
			scrollLock() {
				document.dispatchEvent(
					new CustomEvent('theme:scroll:lock', {
						bubbles: !0,
						detail: this.popupBody,
					}),
				)
			}
			showPopupOnScroll() {
				window.scrollY + window.innerHeight >= document.body.clientHeight &&
					(this.showPopup(),
					document.removeEventListener(
						'theme:scroll',
						this.showPopupOnScrollEvent,
					))
			}
			onUnload() {
				document.removeEventListener(
					'theme:scroll',
					this.showPopupOnScrollEvent,
				)
			}
			constructor(t, e) {
				if (
					((this.popupContainer = t),
					(this.popup = e),
					(this.popupBody = e.querySelector(Qp)),
					(this.delay = t.dataset.popupDelay),
					(this.isSubmitted =
						-1 !== window.location.href.indexOf('accepts_marketing') ||
						-1 !== window.location.href.indexOf('customer_posted=true')),
					(this.a11y = _t),
					(this.showPopupOnScrollEvent = () => this.showPopupOnScroll()),
					('always' === this.delay || this.isSubmitted) && this.always(),
					this.delay && this.delay.includes('delayed') && !this.isSubmitted)
				) {
					const t = this.delay.includes('_')
						? parseInt(this.delay.split('_')[1])
						: 10
					this.delayed(t)
				}
				'bottom' !== this.delay || this.isSubmitted || this.bottom(),
					'idle' !== this.delay || this.isSubmitted || this.idle()
			}
		},
		gm = class {
			constructor(t) {
				if (
					((this.popupContainer = t),
					(this.locationPath = location.href),
					!this.popupContainer.hasAttribute(Yp))
				)
					return !1
				;-1 !==
					this.locationPath.indexOf(this.popupContainer.getAttribute(Yp)) ||
					window.Shopify.designMode ||
					this.popupContainer.parentNode.removeChild(this.popupContainer)
			}
		}
	ct('popups', [
		{
			onLoad() {
				;(hm[this.id] = []), window.Shopify.designMode && (um = 0)
				const t = this.container.querySelectorAll(zp)
				t.length &&
					t.forEach((t) => {
						hm[this.id].push(
							new (class {
								init() {
									;(!1 !== this.cookie.read() && !window.Shopify.designMode) ||
										(window.Shopify.designMode
											? this.showPopup()
											: new mm(this.popupContainer, this.popup),
										this.form &&
											setTimeout(() => {
												this.form.classList.contains(tm) &&
													(this.showPopupIfNoCookie(), (um -= 1))
											}),
										this.initClosers())
								}
								checkPopupTarget() {
									const t = this.popup.parentNode.classList.contains(rm),
										e = this.popup.parentNode.classList.contains(am)
									return !(
										(t && window.innerWidth >= theme.sizes.small) ||
										(e && window.innerWidth < theme.sizes.small)
									)
								}
								showPopupIfNoCookie() {
									this.showPopup()
								}
								initClosers() {
									this.close.addEventListener(
										'click',
										this.closePopup.bind(this),
									),
										this.underlay.addEventListener(
											'click',
											this.closePopup.bind(this),
										),
										this.popupContainer.addEventListener('keyup', (t) => {
											t.code === theme.keyboardKeys.ESCAPE && this.closePopup(t)
										})
								}
								closePopup(t) {
									t.preventDefault(), this.hidePopup(), this.cookie.write()
								}
								scrollLock() {
									this.resetScrollUnlock(),
										this.a11y.trapFocus({ container: this.popupBody }),
										document.dispatchEvent(
											new CustomEvent('theme:scroll:lock', {
												bubbles: !0,
												detail: this.popupBody,
											}),
										)
								}
								scrollUnlock() {
									this.resetScrollUnlock(),
										(dm = setTimeout(() => {
											document.dispatchEvent(
												new CustomEvent('theme:scroll:unlock', { bubbles: !0 }),
											)
										}, 300))
								}
								resetScrollUnlock() {
									dm && clearTimeout(dm)
								}
								showPopup() {
									const t = !0 === this.checkPopupTarget(),
										e = { id: this.popupId, body: this.popup }
									pm.push(e),
										t &&
											((um += 1),
											this.popup.classList.add(nm),
											this.scrollLock())
								}
								hidePopup() {
									this.popup.classList.remove(nm)
									const t = pm.findIndex((t) => t.id === this.popupId)
									if (
										((um -= 1),
										pm.splice(t, 1),
										1 == um && document.body.classList.contains(cm))
									)
										this.scrollUnlock()
									else if (um < 1)
										this.scrollUnlock(), this.a11y.removeTrapFocus()
									else if (pm.length > 0) {
										const t = pm[pm.length - 1].body
										this.a11y.trapFocus({ container: t })
									}
								}
								onBlockSelect(t) {
									this.popupContainer.contains(t.target) &&
										!this.popup.classList.contains(nm) &&
										(this.popup.classList.add(im),
										this.popupContainer.classList.add(sm),
										this.showPopup())
								}
								onBlockDeselect(t) {
									this.popupContainer.contains(t.target) &&
										(this.popup.classList.remove(im),
										this.popupContainer.classList.remove(sm),
										this.hidePopup())
								}
								onUnload() {
									this.scrollUnlock()
								}
								onDeselect() {
									this.popup.classList.remove(im),
										this.popupContainer.classList.remove(sm),
										this.hidePopup()
								}
								constructor(t) {
									;(this.popupContainer = t),
										(this.popup = this.popupContainer.querySelector(Rp)),
										(this.popupBody = this.popup.querySelector(Qp)),
										(this.popupId = this.popup.id),
										(this.close = this.popup.querySelector(Gp)),
										(this.underlay = this.popup.querySelector(Xp)),
										(this.form = this.popup.querySelector(Jp)),
										(this.cookie = new Fd(
											this.popupContainer.dataset.cookieName,
											'user_has_closed',
										)),
										(this.isTargeted = new gm(this.popupContainer)),
										(this.a11y = _t),
										this.init()
								}
							})(t),
						)
					})
				const e = this.container.querySelectorAll(Up)
				e.length &&
					e.forEach((t) => {
						hm[this.id].push(
							new (class {
								init() {
									;(!1 !== this.cookie.read() && !window.Shopify.designMode) ||
										(window.Shopify.designMode
											? this.showPopup()
											: new mm(this.popupContainer, this.popup),
										this.initPopupToggleButton(),
										this.initClosers(),
										this.form &&
											setTimeout(() => {
												this.form.classList.contains(tm) &&
													this.showPopupIfNoCookie(),
													this.form.classList.contains(em) &&
														this.toggle.dispatchEvent(new Event('click'))
											}))
								}
								checkPopupTarget() {
									const t = this.popup.parentNode.classList.contains(rm),
										e = this.popup.parentNode.classList.contains(am)
									return !(
										(t && window.innerWidth >= theme.sizes.small) ||
										(e && window.innerWidth < theme.sizes.small)
									)
								}
								showPopupIfNoCookie() {
									this.showPopup(),
										this.toggle.dispatchEvent(new Event('click'))
								}
								initPopupToggleButton() {
									this.toggle.addEventListener('click', (t) => {
										t.preventDefault(),
											this.popup.classList.toggle(om),
											this.popup.classList.contains(om)
												? this.scrollLock()
												: this.scrollUnlock()
									})
								}
								showPopup() {
									const t = { id: this.popupId, body: this.popup }
									pm.push(t),
										this.a11y.trapFocus({ container: this.popupBody }),
										!0 === this.checkPopupTarget() &&
											((um += 1),
											document.body.classList.add(cm),
											this.popup.classList.add(nm))
								}
								hidePopup() {
									this.popup.classList.remove(nm),
										document.body.classList.remove(cm)
									const t = pm.findIndex((t) => t.id === this.popupId)
									if ((pm.splice(t, 1), um >= 1 && (um -= 1), um < 1))
										this.scrollUnlock(), this.a11y.removeTrapFocus()
									else if (pm.length > 0) {
										const t = pm[pm.length - 1].body
										this.a11y.trapFocus({ container: t })
									}
								}
								initClosers() {
									this.close.addEventListener(
										'click',
										this.closePopup.bind(this),
									),
										this.underlay.addEventListener('click', () =>
											this.toggle.dispatchEvent(new Event('click')),
										),
										this.popupContainer.addEventListener('keyup', (t) => {
											t.code === theme.keyboardKeys.ESCAPE &&
												(this.popup.classList.remove(om), this.scrollUnlock())
										})
								}
								closePopup(t) {
									t.preventDefault(), this.cookie.write(), this.hidePopup()
								}
								scrollLock() {
									document.dispatchEvent(
										new CustomEvent('theme:scroll:lock', {
											bubbles: !0,
											detail: this.popupBody,
										}),
									)
								}
								scrollUnlock() {
									this.resetScrollUnlock(),
										(dm = setTimeout(() => {
											document.dispatchEvent(
												new CustomEvent('theme:scroll:unlock', { bubbles: !0 }),
											)
										}, 300))
								}
								resetScrollUnlock() {
									dm && clearTimeout(dm)
								}
								onBlockSelect(t) {
									this.popupContainer.contains(t.target) &&
										!this.popup.classList.contains(nm) &&
										(this.showPopup(),
										this.popup.classList.add(om),
										this.popup.classList.add(im),
										this.popup.parentNode.classList.add(sm),
										this.resetScrollUnlock(),
										this.scrollLock())
								}
								onBlockDeselect(t) {
									this.popupContainer.contains(t.target) &&
										(this.popup.classList.remove(om),
										this.popup.classList.remove(im),
										this.popup.parentNode.classList.remove(sm),
										this.hidePopup())
								}
								onUnload() {
									this.scrollUnlock()
								}
								onDeselect() {
									this.popup.classList.remove(om),
										this.popup.classList.remove(im),
										this.popup.parentNode.classList.remove(sm),
										this.hidePopup()
								}
								constructor(t) {
									;(this.popupContainer = t),
										(this.popup = this.popupContainer.querySelector(jp)),
										(this.popupBody = this.popup.querySelector(Qp)),
										(this.popupId = this.popup.id),
										(this.close = this.popup.querySelector(Gp)),
										(this.underlay = this.popup.querySelector(Xp)),
										(this.toggle = this.popup.querySelector(Kp)),
										(this.cookie = new Fd(
											this.popupContainer.dataset.cookieName,
											'user_has_closed',
										)),
										(this.form = this.popup.querySelector(Jp)),
										(this.isTargeted = new gm(this.popupContainer)),
										(this.a11y = _t),
										this.init()
								}
							})(t),
						)
					})
				const i = this.container.querySelectorAll(Vp)
				i.length &&
					i.forEach((t) => {
						hm[this.id].push(
							new (class {
								init() {
									this.enableTracking && this.showPopup(), this.clickEvents()
								}
								clickEvents() {
									this.close.addEventListener('click', (t) => {
										t.preventDefault(),
											window.Shopify.customerPrivacy.setTrackingConsent(
												!1,
												() => this.hidePopup(),
											)
									}),
										this.acceptButton.addEventListener('click', (t) => {
											t.preventDefault(),
												window.Shopify.customerPrivacy.setTrackingConsent(
													!0,
													() => this.hidePopup(),
												)
										}),
										document.addEventListener('trackingConsentAccepted', () => {
											console.log('trackingConsentAccepted event fired')
										})
								}
								showPopup() {
									const t = { id: this.popupId, body: this.popup }
									pm.push(t),
										this.popup.classList.add(nm),
										this.a11y.trapFocus({ container: this.popup })
								}
								hidePopup() {
									this.popup.classList.remove(nm)
									const t = pm.findIndex((t) => t.id === this.popupId)
									if ((pm.splice(t, 1), um < 1)) this.a11y.removeTrapFocus()
									else if (pm.length > 0) {
										const t = pm[pm.length - 1].body
										this.a11y.trapFocus({ container: t })
									}
								}
								onBlockSelect(t) {
									this.popupContainer.contains(t.target) &&
										this.enableTracking &&
										!this.popup.classList.contains(nm) &&
										(this.showPopup(),
										this.popup.classList.add(im),
										this.popup.parentNode.classList.add(sm))
								}
								onBlockDeselect(t) {
									this.popupContainer.contains(t.target) &&
										(this.popup.classList.remove(im),
										this.popupContainer.classList.remove(sm),
										this.hidePopup())
								}
								onDeselect() {
									this.popup.classList.remove(im),
										this.popupContainer.classList.remove(sm),
										this.hidePopup()
								}
								constructor(t) {
									;(this.popupContainer = t),
										(this.popup = this.popupContainer.querySelector(Wp)),
										(this.popupId = this.popup.id),
										(this.close = this.popup.querySelector(Gp)),
										(this.acceptButton = this.popup.querySelector(Np)),
										(this.enable =
											'true' === this.popupContainer.dataset.enable),
										(this.a11y = _t),
										window.Shopify.loadFeatures(
											[{ name: 'consent-tracking-api', version: '0.1' }],
											(t) => {
												if (t) throw t
												const e =
														window.Shopify.customerPrivacy.userCanBeTracked(),
													i =
														window.Shopify.customerPrivacy.getTrackingConsent()
												;(this.enableTracking =
													!e && 'no_interaction' === i && this.enable),
													window.Shopify.designMode &&
														(this.enableTracking = !0),
													this.init()
											},
										)
								}
							})(t),
						)
					})
			},
			onDeselect() {
				hm[this.id].forEach((t) => {
					'function' == typeof t.onDeselect && t.onDeselect()
				})
			},
			onBlockSelect(t) {
				hm[this.id].forEach((e) => {
					'function' == typeof e.onBlockSelect && e.onBlockSelect(t)
				})
			},
			onBlockDeselect(t) {
				hm[this.id].forEach((e) => {
					'function' == typeof e.onBlockDeselect && e.onBlockDeselect(t)
				})
			},
			onUnload(t) {
				hm[this.id].forEach((e) => {
					'function' == typeof e.onUnload && e.onUnload(t)
				})
			},
		},
		_d,
	])
	const vm = '[data-press-items]',
		ym = '[data-logo-slider]',
		fm = '[data-logo-slide]',
		bm = 'a, button',
		wm = 'data-logo-index',
		Em = 'tabindex'
	let Sm = {}
	const Lm = {
		onLoad() {
			Sm[this.id] = new (class {
				checkSlides() {
					const t = this.container.offsetWidth,
						i = this.container.querySelectorAll(fm),
						s = e.data(this.sliderNav) || null
					null !== s &&
						((s.options.draggable = !1),
						(s.options.wrapAround = !1),
						(s.options.contain = !0),
						this.getSlidesWidth() > t &&
							i.length > 2 &&
							((s.options.draggable = !0),
							(s.options.wrapAround = !0),
							(s.options.contain = !1)),
						s.resize(),
						s.updateDraggable())
				}
				getSlidesWidth() {
					const t = this.container.querySelectorAll(fm)
					let e = 0
					return (
						t.length &&
							t.forEach((t) => {
								e += t.offsetWidth
							}),
						e
					)
				}
				initSlider() {
					let t = e.data(this.slider) || null,
						i = e.data(this.sliderNav) || null
					const s = parseInt(this.container.dataset.duration),
						o = 'true' === this.container.dataset.autoplay && s
					;(t = new e(this.slider, {
						fade: !0,
						wrapAround: !0,
						adaptiveHeight: !0,
						prevNextButtons: !1,
						pageDots: !1,
						autoPlay: o,
					})),
						(i = new e(this.sliderNav, {
							draggable: !1,
							wrapAround: !1,
							contain: !0,
							imagesLoaded: !0,
							lazyLoad: !0,
							asNavFor: this.slider,
							prevNextButtons: !1,
							adaptiveHeight: !1,
							pageDots: !1,
							on: {
								ready: () => {
									this.container.querySelectorAll(fm).forEach((e) => {
										e.addEventListener('keyup', (i) => {
											if (
												i.code === theme.keyboardKeys.ENTER ||
												i.code === theme.keyboardKeys.NUMPADENTER ||
												i.code === theme.keyboardKeys.SPACE
											) {
												const i = Number(e.getAttribute(wm))
												t.selectCell(i)
											}
										})
									})
								},
							},
						})),
						ae(this.slider),
						ae(this.sliderNav),
						i.on('change', (e) => {
							t.selectCell(e)
						}),
						t.on('change', (e) => {
							i.selectCell(e),
								t.cells.forEach((t, i) => {
									t.element.querySelectorAll(bm).forEach((t) => {
										t.setAttribute(Em, i === e ? '0' : '-1')
									})
								})
						})
				}
				resizeSlider() {
					const t = e.data(this.slider)
					t && t.resize()
				}
				onBlockSelect(t) {
					const i = e.data(this.slider) || null,
						s = e.data(this.sliderNav) || null,
						o = parseInt([...t.target.parentNode.children].indexOf(t.target))
					null !== i && (i.select(o), i.pausePlayer()),
						null !== s && s.select(o)
				}
				onBlockDeselect() {
					const t = e.data(this.slider) || null
					'true' === this.container.dataset.autoplay &&
						null !== t &&
						t.playPlayer()
				}
				onUnload() {
					document.removeEventListener(
						'theme:resize:width',
						this.sliderResizeEvent,
					)
				}
				constructor(t) {
					;(this.container = t.container),
						(this.slider = this.container.querySelector(vm)),
						(this.sliderNav = this.container.querySelector(ym)),
						(this.sliderResizeEvent = () => this.checkSlides()),
						this.initSlider(),
						this.checkSlides(),
						window.addEventListener('load', this.resizeSlider.bind(this)),
						document.addEventListener(
							'theme:resize:width',
							this.sliderResizeEvent,
						)
				}
			})(this)
		},
		onUnload(t) {
			Sm[this.id].onUnload(t)
		},
		onBlockSelect(t) {
			Sm[this.id].onBlockSelect(t)
		},
		onBlockDeselect() {
			Sm[this.id].onBlockDeselect()
		},
	}
	ct('press', Lm)
	const km = '[data-product-single-media-slider]',
		Am = '[data-product-info]',
		qm = '[data-header-sticky]',
		Cm = '[data-header-height]',
		Tm = 'is-sticky',
		Pm = 'data-sticky-enabled'
	window.theme.variables = { productPageSticky: !1 }
	const Fm = {}
	const Im = {
			onLoad() {
				Fm[this.id] = new (class {
					init() {
						this.stickyEnabled &&
							(this.stickyScrollCheck(),
							document.addEventListener('theme:resize', this.resizeEvent)),
							this.initSticky()
					}
					initSticky() {
						theme.variables.productPageSticky &&
							((this.requestAnimationSticky = requestAnimationFrame(() =>
								this.calculateStickyPosition(),
							)),
							this.productInfo.addEventListener('theme:form:sticky', (t) => {
								this.removeAnimationFrame(),
									(this.requestAnimationSticky = requestAnimationFrame(() =>
										this.calculateStickyPosition(t),
									))
							}),
							document.addEventListener('theme:scroll', this.scrollEvent))
					}
					scrollEvents(t) {
						null !== t.detail &&
							((this.scrollTop = t.detail.position),
							(this.scrollDirectionDown = t.detail.down)),
							this.requestAnimationSticky ||
								(this.requestAnimationSticky = requestAnimationFrame(() =>
									this.calculateStickyPosition(),
								))
					}
					resizeEvents() {
						this.stickyScrollCheck(),
							document.removeEventListener('theme:scroll', this.scrollEvent),
							this.initSticky()
					}
					stickyScrollCheck() {
						const t =
								(window.innerWidth ||
									document.documentElement.clientWidth ||
									document.body.clientWidth) >= window.theme.sizes.large,
							e = this.container.querySelector(Am)
						if (e)
							if (t) {
								const t = this.container.querySelector(Am),
									i = this.container.querySelector(km)
								if (!t || !i) return
								t.offsetHeight < i.offsetHeight
									? ((theme.variables.productPageSticky = !0),
									  e.classList.add(Tm))
									: ((theme.variables.productPageSticky = !1),
									  e.classList.remove(Tm))
							} else
								(theme.variables.productPageSticky = !1), e.classList.remove(Tm)
					}
					calculateStickyPosition(t = null) {
						const e = Boolean(t && t.detail),
							i = Boolean(
								e && t.detail.element && 'accordion' === t.detail.element,
							),
							s = this.productInfo.offsetHeight,
							o = window.innerHeight - s - this.defaultTopBottomSpacings,
							n = Math.abs(this.scrollTop - this.scrollLastPosition)
						this.scrollDirectionDown
							? (this.stickyScrollTop -= n)
							: (this.stickyScrollTop += n),
							this.stickyFormLoad &&
								(document.querySelector(qm) && document.querySelector(Cm)
									? (this.stickyDefaultTop = parseInt(
											document.querySelector(Cm).getBoundingClientRect().height,
									  ))
									: (this.stickyDefaultTop = this.defaultTopBottomSpacings),
								(this.stickyScrollTop = this.stickyDefaultTop)),
							(this.stickyScrollTop = Math.min(
								Math.max(this.stickyScrollTop, o),
								this.stickyDefaultTop,
							))
						const r = this.stickyScrollTop - this.currentPoint
						;(this.currentPoint = this.stickyFormLoad
							? this.stickyScrollTop
							: this.currentPoint + 0.5 * r),
							this.productInfo.style.setProperty(
								'--sticky-top',
								`${this.currentPoint}px`,
							),
							(this.scrollLastPosition = this.scrollTop),
							(this.stickyFormLoad = !1),
							(i && this.onChangeCounter <= 10) ||
							(i && this.stickyFormLastHeight !== s) ||
							(this.stickyScrollTop !== this.currentPoint &&
								this.requestAnimationSticky)
								? (i && (this.onChangeCounter += 1),
								  i &&
										this.stickyFormLastHeight !== s &&
										(this.onChangeCounter = 11),
								  (this.requestAnimationSticky = requestAnimationFrame(() =>
										this.calculateStickyPosition(t),
								  )))
								: this.requestAnimationSticky && this.removeAnimationFrame(),
							(this.stickyFormLastHeight = s)
					}
					removeAnimationFrame() {
						this.requestAnimationSticky &&
							(cancelAnimationFrame(this.requestAnimationSticky),
							(this.requestAnimationSticky = null),
							(this.onChangeCounter = 0))
					}
					onUnload() {
						this.stickyEnabled &&
							document.removeEventListener('theme:resize', this.resizeEvent),
							theme.variables.productPageSticky &&
								document.removeEventListener('theme:scroll', this.scrollEvent)
					}
					constructor(t) {
						;(this.container = t.container),
							(this.stickyEnabled = 'true' === this.container.getAttribute(Pm)),
							(this.productInfo = this.container.querySelector(Am)),
							(this.stickyScrollTop = 0),
							(this.scrollLastPosition = 0),
							(this.stickyDefaultTop = 0),
							(this.currentPoint = 0),
							(this.defaultTopBottomSpacings = 30),
							(this.scrollTop = window.scrollY),
							(this.scrollDirectionDown = !0),
							(this.requestAnimationSticky = null),
							(this.stickyFormLoad = !0),
							(this.stickyFormLastHeight = null),
							(this.onChangeCounter = 0),
							(this.scrollEvent = (t) => this.scrollEvents(t)),
							(this.resizeEvent = (t) => this.resizeEvents(t)),
							this.init()
					}
				})(this)
			},
			onUnload() {
				Fm[this.id].onUnload()
			},
		},
		xm = '[data-product-single-media-group]',
		Hm = '[data-product-single-media-slider]',
		Dm = '[data-zoom-wrapper]',
		Mm = 'pswp-zoom-gallery',
		Om = 'pswp-zoom-gallery--single',
		_m = 'is-moving',
		Bm = 'data-image-width',
		$m = 'data-image-height'
	const zm = '[data-complementary-products]',
		Rm = '[data-button-quick-view]',
		Vm = 'data-url'
	let Wm = class extends HTMLElement {
		connectedCallback() {
			new IntersectionObserver(
				((t, e) => {
					t[0].isIntersecting &&
						(e.unobserve(this),
						this.hasAttribute(Vm) &&
							'' !== this.getAttribute(Vm) &&
							fetch(this.getAttribute(Vm))
								.then((t) => t.text())
								.then((t) => {
									const e = document.createElement('div')
									e.innerHTML = t
									const i = e.querySelector(zm)
									i &&
										i.innerHTML.trim().length &&
										(this.innerHTML = i.innerHTML),
										e.querySelector(Rm) && new Il(this)
								})
								.catch((t) => {
									console.error(t)
								}))
				}).bind(this),
				{ rootMargin: '0px 0px 400px 0px' },
			).observe(this)
		}
		constructor() {
			super()
		}
	}
	const Nm = '[data-recipient-checkbox]',
		Um = '[data-recipient-email]',
		jm = '[data-recipient-name]',
		Km = '[data-recipient-message]',
		Qm = '[data-recipient-send-on]',
		Gm = '[data-recipient-control]',
		Xm = '[data-recipient-offset]',
		Jm = '[data-product-form]',
		Ym = '[data-cart-drawer]',
		Zm = 'js-quick-view-visible'
	let tg = class extends HTMLElement {
		connectedCallback() {
			this.recipientCheckbox &&
				(this.disableInputFields(),
				this.recipientCheckbox.addEventListener('change', this.onChangeEvent),
				document.addEventListener('theme:cart:added', this.onCartAddedEvent))
		}
		onChange(t) {
			if (!t.target.checked)
				return this.clearInputFields(), void this.disableInputFields()
			this.enableInputFields()
		}
		onCartAdded() {
			const t = this.closest(Jm).offsetTop,
				e = document.body.classList.contains(Zm)
			if (!(!0 === this.recipientCheckbox.checked)) return
			e || window.scrollTo({ top: t, left: 0, behavior: 'smooth' })
			const i = (t) => {
				t.target === this.cartDrawer &&
					(requestAnimationFrame(() => {
						;(this.recipientCheckbox.checked = !1),
							this.recipientCheckbox.dispatchEvent(new Event('change'))
					}),
					this.cartDrawer.removeEventListener('transitionend', i))
			}
			this.cartDrawer.addEventListener('transitionend', i)
		}
		inputFields() {
			return [
				this.recipientEmail,
				this.recipientName,
				this.recipientMessage,
				this.recipientSendOn,
			]
		}
		disableableFields() {
			return [...this.inputFields(), this.recipientOffset]
		}
		clearInputFields() {
			this.inputFields().forEach((t) => (t.value = ''))
		}
		enableInputFields() {
			this.disableableFields().forEach((t) => (t.disabled = !1))
		}
		disableInputFields() {
			this.disableableFields().forEach((t) => (t.disabled = !0))
		}
		disconnectedCallback() {
			this.recipientCheckbox.removeEventListener('change', this.onChangeEvent),
				document.removeEventListener('theme:cart:added', this.onCartAddedEvent)
		}
		constructor() {
			super(),
				(this.recipientCheckbox = this.querySelector(Nm)),
				(this.recipientControl = this.querySelector(Gm)),
				(this.recipientControl.disabled = !0),
				(this.recipientEmail = this.querySelector(Um)),
				(this.recipientName = this.querySelector(jm)),
				(this.recipientMessage = this.querySelector(Km)),
				(this.recipientSendOn = this.querySelector(Qm)),
				(this.recipientOffset = this.querySelector(Xm)),
				this.recipientOffset &&
					(this.recipientOffset.value = new Date().getTimezoneOffset()),
				(this.cartDrawer = document.querySelector(Ym)),
				(this.onChangeEvent = (t) => this.onChange(t)),
				(this.onCartAddedEvent = () => this.onCartAdded())
		}
	}
	const eg = '[data-product-single-media-slider]',
		ig = '[data-thumbnail-id]',
		sg = '[data-product-single-media-thumbs]',
		og = '[data-product-single-media-wrapper]',
		ng = '[data-model]',
		rg = '.product-single__thumbnail-link',
		ag = '[data-deferred-media]',
		lg = '[data-deferred-media-button]',
		cg = '[data-product-rating]',
		hg = '#shopify-product-reviews',
		dg = 'a, button',
		ug = '[data-upsell-holder]',
		pg = '[data-upsell-slider]',
		mg = '[data-slider]',
		gg = 'featured-product',
		vg = 'featured-product--onboarding',
		yg = 'has-media-active',
		fg = 'is-selected',
		bg = 'media--hidden',
		wg = 'no-outline',
		Eg = 'is-moving',
		Sg = 'data-media-id',
		Lg = 'data-section-id',
		kg = 'data-thumbnail-id',
		Ag = 'data-tall-layout',
		qg = 'loaded',
		Cg = 'tabindex',
		Tg = {}
	const Pg = {
		onLoad() {
			Tg[this.id] = new (class {
				productSlider() {
					this.checkSlider(),
						document.addEventListener(
							'theme:resize:width',
							this.checkSliderOnResize,
						)
				}
				checkSlider() {
					!this.tallLayout || window.innerWidth < theme.sizes.large
						? this.initProductSlider()
						: this.destroyProductSlider()
				}
				resizeFlickityNav() {
					null !== this.flktyNav && this.flktyNav.resize()
				}
				initProductSlider() {
					const t = this.container.querySelector(eg),
						i = this.container.querySelector(sg),
						s = this.container.querySelectorAll(og)
					if (
						s.length > 1 &&
						((this.flkty = new e(t, {
							wrapAround: !0,
							pageDots: !1,
							adaptiveHeight: !0,
							on: {
								ready: () => {
									t.setAttribute(Cg, '-1'),
										s.forEach((t) => {
											if (!t.classList.contains(fg)) {
												const e = t.querySelectorAll(dg)
												e.length &&
													e.forEach((t) => {
														t.setAttribute(Cg, '-1')
													})
											}
										})
								},
								dragStart: () => {
									t.classList.add(Eg)
								},
								dragMove: () => {
									this.isFlickityDragging = !0
								},
								staticClick: () => {
									this.isFlickityDragging = !1
								},
								settle: (e) => {
									const i = this.flkty.selectedElement.getAttribute(Sg)
									this.flkty.cells.forEach((t, i) => {
										const s = t.element.querySelectorAll(dg)
										s.length &&
											s.forEach((t) => {
												t.setAttribute(Cg, i === e ? '0' : '-1')
											})
									}),
										this.switchMedia(i),
										t.classList.remove(Eg)
								},
							},
						})),
						s.length &&
							s.forEach((t) => {
								t.addEventListener('theme:media:play', () => {
									;(this.flkty.options.draggable = !1),
										this.flkty.updateDraggable(),
										t.closest(eg).classList.add(yg)
								}),
									t.addEventListener('theme:media:pause', () => {
										;(this.flkty.options.draggable = !0),
											this.flkty.updateDraggable(),
											t.closest(eg).classList.remove(yg)
									})
							}),
						ae(t),
						null !== i)
					) {
						;(this.flktyNav = new e(i, {
							asNavFor: t,
							contain: !0,
							pageDots: !1,
							prevNextButtons: !1,
							resize: !0,
							on: {
								ready: () => {
									i.setAttribute(Cg, '-1')
								},
							},
						})),
							null !== this.flktyNav &&
								document.addEventListener(
									'theme:resize:width',
									this.flktyNavOnResize,
								),
							ae(i)
						const s = this.container.querySelectorAll(rg)
						s.length &&
							s.forEach((t) => {
								t.addEventListener('click', (t) => {
									t.preventDefault()
								})
							})
					}
				}
				destroyProductSlider() {
					null !== this.flkty &&
						(this.flkty.destroy(),
						this.flktyNav.destroy(),
						(this.flkty = null),
						(this.flktyNav = null))
				}
				initUpsellSlider() {
					const t = this.container.querySelector(pg)
					if (this.container.querySelectorAll(ug).length > 1) {
						const i = new e(t, {
							wrapAround: !0,
							pageDots: !0,
							adaptiveHeight: !0,
							prevNextButtons: !1,
						})
						i.on('change', (t) => {
							i.cells.forEach((e, i) => {
								const s = e.element.querySelectorAll(dg)
								s.length &&
									s.forEach((e) => {
										e.setAttribute(Cg, i === t ? '0' : '-1')
									})
							})
						})
					}
				}
				initFeatureSlider() {
					this.featureSliders.forEach((t) => {
						Array.from(t.children).length > 1 &&
							(this.flktyFeature = new e(t, {
								wrapAround: !0,
								pageDots: !0,
								adaptiveHeight: !0,
								prevNextButtons: !1,
							}))
					})
				}
				handleMediaFocus(t) {
					if (
						t.code !== theme.keyboardKeys.ENTER &&
						t.code !== theme.keyboardKeys.TAB
					)
						return
					const i = t.currentTarget.getAttribute(kg),
						s = this.container.querySelector(`[${Sg}="${i}"]`),
						o = parseInt([...s.parentNode.children].indexOf(s)),
						n = this.container.querySelector(eg),
						r = this.container.querySelector(sg),
						a = e.data(n) || null,
						l = e.data(r) || null
					a &&
						a.isActive &&
						o > -1 &&
						(t.code === theme.keyboardKeys.ENTER ||
							t.code === theme.keyboardKeys.NUMPADENTER) &&
						a.select(o),
						l && l.isActive && o > -1 && l.select(o)
				}
				switchMedia(t) {
					const e = document.querySelectorAll(`${og}`),
						i = this.container.querySelector(`${og}[${Sg}="${t}"]`),
						s = !document.body.classList.contains(wg)
					e.length &&
						e.forEach((t) => {
							t.dispatchEvent(new CustomEvent('theme:media:hidden'), {
								bubbles: !0,
							}),
								t.classList.add(bg)
						}),
						s && i.focus(),
						i.closest(eg).classList.remove(yg),
						i.classList.remove(bg),
						i.dispatchEvent(new CustomEvent('theme:media:visible'), {
							bubbles: !0,
						})
					const o = i.querySelector(ag)
					o &&
						'true' !== o.getAttribute(qg) &&
						i.querySelector(lg).dispatchEvent(new Event('click'))
				}
				initMediaSwitch() {
					const t = this.container.querySelectorAll(ig)
					t.length &&
						t.forEach((t) => {
							t.addEventListener('keyup', this.handleMediaFocus.bind(this)),
								t.addEventListener('click', (t) => {
									t.preventDefault()
								})
						})
				}
				initProductVideo() {
					this.videos = new Ee(this.container)
				}
				initProductModel() {
					const t = this.container.querySelectorAll(ng)
					t.length &&
						t.forEach((t) => {
							theme.ProductModel.init(t, this.sectionId)
						})
				}
				initShopifyXrLaunch() {
					document.addEventListener('shopify_xr_launch', () => {
						this.container
							.querySelector(`${ng}:not(.${bg})`)
							.dispatchEvent(new CustomEvent('xrLaunch'))
					})
				}
				onUnload() {
					null !== this.flktyNav &&
						document.removeEventListener(
							'theme:resize:width',
							this.flktyNavOnResize,
						),
						document.removeEventListener(
							'theme:resize:width',
							this.checkSliderOnResize,
						)
				}
				scrollToReviews() {
					const t = this.container.querySelector(cg)
					t &&
						['click', 'keydown'].forEach((e) => {
							t.addEventListener(e, (t) => {
								if (
									(t.code !== theme.keyboardKeys.ENTER &&
										t.code !== theme.keyboardKeys.NUMPADENTER) ||
									'click' != t.type
								) {
									const t = document.querySelector(hg)
									if (!t) return
									t.scrollIntoView({ behavior: 'smooth' })
								}
							})
						})
				}
				onBlockSelect(t) {
					const i = e.data(t.target.closest(mg)),
						s = parseInt([...t.target.parentNode.children].indexOf(t.target))
					i && i.select(s)
				}
				constructor(t) {
					;(this.container = t.container),
						(this.sectionId = this.container.getAttribute(Lg)),
						(this.tallLayout = 'true' === this.container.getAttribute(Ag)),
						(this.featureSliders = this.container.querySelectorAll(mg)),
						(this.flkty = null),
						(this.flktyNav = null),
						(this.isFlickityDragging = !1),
						(this.enableHistoryState = !this.container.classList.contains(gg)),
						(this.checkSliderOnResize = () => this.checkSlider()),
						(this.flktyNavOnResize = () => this.resizeFlickityNav()),
						this.scrollToReviews(),
						this.initUpsellSlider(),
						this.initFeatureSlider(),
						new Il(this.container),
						this.container.classList.contains(vg) ||
							(new (class {
								init() {
									this.zoomWrappers.length &&
										this.zoomWrappers.forEach((t, e) => {
											t.addEventListener('click', (i) => {
												i.preventDefault(),
													(this.slider && this.slider.classList.contains(_m)) ||
														((this.a11y.state.trigger = t), this.createZoom(e))
											})
										})
								}
								createZoom(t) {
									const e = this
									let i = [],
										s = 0
									this.zoomWrappers.forEach((o) => {
										const n = o.getAttribute('href'),
											r = parseInt(o.getAttribute(Bm)),
											a = parseInt(o.getAttribute($m))
										if (
											(i.push({ src: n, w: r, h: a, msrc: n }),
											(s += 1),
											e.zoomWrappers.length === s)
										) {
											let e = `${Mm}`
											1 === s && (e = `${Mm} ${Om}`),
												new ul(i, {
													barsSize: { top: 60, bottom: 60 },
													history: !1,
													focus: !1,
													index: t,
													mainClass: e,
													showHideOpacity: !0,
													showAnimationDuration: 250,
													hideAnimationDuration: 250,
													closeOnScroll: !1,
													closeOnVerticalDrag: !1,
													captionEl: !1,
													closeEl: !0,
													closeElClasses: ['caption-close'],
													tapToClose: !1,
													clickToCloseNonZoomable: !1,
													maxSpreadZoom: 2,
													loop: !0,
													spacing: 0,
													allowPanToNext: !0,
													pinchToClose: !1,
												})
										}
									})
								}
								constructor(t) {
									;(this.container = t),
										(this.mediaContainer = this.container.querySelector(xm)),
										(this.slider = this.container.querySelector(Hm)),
										(this.zoomWrappers = this.container.querySelectorAll(Dm)),
										(this.zoomEnable =
											'true' === this.mediaContainer.dataset.gallery),
										(this.a11y = _t),
										this.zoomEnable && this.init()
								}
							})(this.container),
							this.productSlider(),
							this.initMediaSwitch(),
							this.initProductVideo(),
							this.initProductModel(),
							this.initShopifyXrLaunch())
				}
			})(this)
		},
		onUnload: function () {
			Tg[this.id].onUnload()
		},
		onBlockSelect(t) {
			Tg[this.id].onBlockSelect(t)
		},
	}
	ct('product-template', [Or, Pg, Zi, ts, Wh, Tt, Re, na, un, Im]),
		ct('featured-product', [Or, Pg, Zi, ts, Wh, Tt, Re, na, un, Im]),
		customElements.get('complementary-products') ||
			customElements.define('complementary-products', Wm),
		customElements.get('recipient-form') ||
			customElements.define('recipient-form', tg)
	const Fg = 'is-disabled',
		Ig = 'data-circle-text-parallax'
	const xg = 'href',
		Hg = 'data-media-id',
		Dg = 'data-deferred-media-loaded',
		Mg = '[data-product-content-wrapper]',
		Og = '[data-product-single-media-wrapper]',
		_g = '[data-model]',
		Bg = '[data-product-link]',
		$g = '[data-product-single-media-image]',
		zg = '[data-slider-contents]',
		Rg = '[data-slider-images]',
		Vg = '[data-tab-button]',
		Wg = '[data-tab-item]',
		Ng = '[data-circle-text]',
		Ug = {
			aosAnimate: 'aos-animate',
			tabButtonActive: 'products-list__nav__button--active',
			tabItemActive: 'products-list__item--active',
			mediaHidden: 'media--hidden',
			isDisabled: 'is-disabled',
		},
		jg = {}
	ct('products-list', {
		onLoad() {
			jg[this.id] = new (class {
				listen() {
					;(this.slidersImages.length > 0 || this.slidersContents.length > 0) &&
						document.addEventListener('theme:resize', this.sliderResizeEvent)
				}
				resizeSlider() {
					this.flktyImages.length > 0 &&
						requestAnimationFrame(() => {
							this.flktyImages.forEach((t) => t.resize())
						}),
						this.flktyContent.length > 0 &&
							requestAnimationFrame(() => {
								this.flktyContent.forEach((t) => t.resize())
							})
				}
				initButtons() {
					this.tabButtons.length &&
						this.tabButtons.forEach((t) => {
							t.addEventListener('click', (e) => {
								if (t.classList.contains(Ug.tabButtonActive)) return
								const i = t.getAttribute(xg),
									s = this.container.querySelector(i),
									o = s.querySelector(Og),
									n = o ? o.dataset.mediaId : null,
									r = s.querySelector(Ng)
								this.tabButtons.forEach((t) => {
									t.classList.remove(Ug.tabButtonActive)
								}),
									this.tabItems.forEach((t) => {
										const e = t.querySelector(Ng)
										t.classList.remove(Ug.tabItemActive),
											null == e || e.classList.add(Ug.isDisabled),
											theme.settings.animations &&
												t.querySelectorAll(`.${Ug.aosAnimate}`).forEach((t) => {
													t.classList.remove(Ug.aosAnimate),
														setTimeout(() => {
															t.classList.add(Ug.aosAnimate)
														})
												})
									}),
									t.classList.add(Ug.tabButtonActive),
									s.classList.add(Ug.tabItemActive),
									document.dispatchEvent(new Event('theme:resize')),
									r &&
										(r.classList.remove(Ug.isDisabled),
										document.dispatchEvent(new Event('theme:scroll'))),
									this.handleProductVideos(s, n),
									e.preventDefault()
							})
						})
				}
				initSliders() {
					this.slidersImages.forEach((t, i) => {
						const s = t.closest(Wg).querySelector(zg),
							o = new e(t, {
								fade: !0,
								pageDots: !1,
								prevNextButtons: !0,
								wrapAround: !0,
								adaptiveHeight: !0,
								asNavFor: s,
								on: {
									change: (t) => {
										this.flktyContent.length > 0 &&
											this.flktyContent[i].select(t)
									},
								},
							})
						o.on('settle', (e) => {
							const i = t.querySelectorAll(Og)
							for (let t = 0; t < i.length; t++)
								t === e
									? i[t].querySelector($g).removeAttribute('tabindex')
									: i[t].querySelector($g).setAttribute('tabindex', '-1')
						}),
							this.flktyImages.push(o)
					}),
						this.slidersContents.forEach((t) => {
							const i = new e(t, {
								fade: !0,
								pageDots: !1,
								prevNextButtons: !1,
								wrapAround: !0,
								adaptiveHeight: !0,
							})
							i.on('settle', (e) => {
								const i = t.querySelectorAll(Mg)
								for (let t = 0; t < i.length; t++)
									t === e
										? i[t].querySelectorAll(Bg).forEach((t) => {
												t.removeAttribute('tabindex')
										  })
										: i[t].querySelectorAll(Bg).forEach((t) => {
												t.setAttribute('tabindex', '-1')
										  })
							}),
								this.flktyContent.push(i)
						})
				}
				initProductVideos() {
					this.tabItems.forEach((t) => {
						t.classList.contains(Ug.tabItemActive) &&
							this.handleProductVideos(t)
					})
				}
				loadVideos(t, e = null) {
					new IntersectionObserver(
						(i, s) => {
							i.forEach((i) => {
								if (i.isIntersecting) {
									const o = new Ee(t)
									this.videos.push(o),
										t.setAttribute(Dg, ''),
										this.playToggle(e),
										s.unobserve(i.target)
								}
							})
						},
						{
							root: null,
							rootMargin: '300px',
							threshold: [0, 0.1, 0.25, 0.5, 0.75, 1],
						},
					).observe(t)
				}
				handleProductVideos(t, e = null) {
					t.hasAttribute(Dg) ? this.playToggle(e) : this.loadVideos(t, e)
				}
				playToggle(t) {
					this.videos.forEach((e) => {
						'function' == typeof e.pauseContainerMedia &&
							t &&
							(e.pauseContainerMedia(t, this.container), this.switchMedia(t)),
							t ||
								0 !== Object.keys(e.players).length ||
								this.pauseContainerMedia(this.container)
					})
				}
				switchMedia(t) {
					const e = this.container.querySelector(`${Og}[${Hg}="${t}"]`)
					!document.body.classList.contains(Ug.noOutline) && e.focus(),
						e.classList.remove(Ug.mediaHidden),
						e.dispatchEvent(new CustomEvent('theme:media:visible'), {
							bubbles: !0,
						})
				}
				pauseContainerMedia(t) {
					const e = t.querySelectorAll(Og)
					0 !== e.length &&
						e.forEach((t) => {
							t.dispatchEvent(new CustomEvent('theme:media:hidden'), {
								bubbles: !0,
							}),
								t.classList.add(Ug.mediaHidden)
						})
				}
				initProductModel() {
					const t = this.container.querySelectorAll(_g)
					t.length &&
						t.forEach((t) => {
							theme.ProductModel.init(t, this.sectionId)
						})
				}
				initShopifyXrLaunch() {
					document.addEventListener('shopify_xr_launch', () => {
						this.container
							.querySelector(`${_g}:not(.${Ug.mediaHidden})`)
							.dispatchEvent(new CustomEvent('xrLaunch'))
					})
				}
				initCircleText() {
					this.container.querySelectorAll(Ng).forEach((t) => {
						new (class {
							init() {
								this.circleText.hasAttribute(Ig) &&
									document.addEventListener('theme:scroll', this.scrollEvent)
							}
							updateParallax() {
								if (this.circleText.classList.contains(Fg)) return
								const t = Math.round(window.innerHeight),
									e = Math.round(window.scrollY),
									i = e + t,
									s = Math.round(
										this.circleText.getBoundingClientRect().top + e,
									),
									o = this.circleText.offsetHeight
								if (s < i && !(s + o < e)) {
									const e = (100 * (i - s - o / 2)) / t
									let n = ((this.rotateDegree * e) / 100) * -1
									e > 0 &&
										(this.circleText.style.transform = `rotate(${
											this.adjustRotateDegree + n
										}deg)`)
								}
							}
							unload() {
								document.removeEventListener('theme:scroll', this.scrollEvent)
							}
							constructor(t) {
								;(this.circleText = t),
									(this.rotateDegree = 70),
									(this.adjustRotateDegree = this.rotateDegree / 2),
									(this.scrollEvent = () => this.updateParallax()),
									this.init()
							}
						})(t)
					})
				}
				onBlockSelect(t) {
					t.target.dispatchEvent(new Event('click'))
				}
				onUnload() {
					;(this.slidersImages.length > 0 || this.slidersContents.length > 0) &&
						document.removeEventListener('theme:resize', this.sliderResizeEvent)
				}
				constructor(t) {
					;(this.container = t.container),
						(this.sectionId = this.container.dataset.sectionId),
						(this.tabButtons = this.container.querySelectorAll(Vg)),
						(this.tabItems = this.container.querySelectorAll(Wg)),
						(this.slidersImages = this.container.querySelectorAll(Rg)),
						(this.slidersContents = this.container.querySelectorAll(zg)),
						(this.videos = []),
						(this.flktyImages = []),
						(this.flktyContent = []),
						(this.sliderResizeEvent = () => this.resizeSlider()),
						this.initButtons(),
						this.initSliders(),
						this.initProductVideos(),
						this.initProductModel(),
						this.initShopifyXrLaunch(),
						this.initCircleText(),
						this.listen()
				}
			})(this)
		},
		onUnload() {
			jg[this.id].onUnload()
		},
		onBlockSelect(t) {
			jg[this.id].onBlockSelect(t)
		},
	})
	const Kg = '[data-product-block]',
		Qg = '[data-related-products]',
		Gg = 'data-section-id',
		Xg = 'data-product-id',
		Jg = 'data-limit',
		Yg = {}
	ct('related-products', {
		onLoad() {
			Yg[this.id] = new (class {
				init() {
					const t = this.container.getAttribute(Gg),
						e = this.container.getAttribute(Xg),
						i = this.container.getAttribute(Jg),
						s = `${theme.routes.product_recommendations_url}?section_id=${t}&limit=${i}&product_id=${e}`
					fetch(s)
						.then((t) => t.text())
						.then((t) => {
							const e = document.createElement('div')
							e.innerHTML = t
							const i = e.querySelector(Qg)
							i.querySelectorAll(Kg).length &&
								((this.relatedProducts.innerHTML = i.innerHTML),
								(this.productGrid = new us(this.container)),
								(this.gridSlider = new cu(this.container)))
						})
				}
				onDeselect() {
					this.productGrid && this.productGrid.onDeselect()
				}
				onUnload() {
					this.productGrid && this.productGrid.onUnload(),
						this.gridSlider && this.gridSlider.onUnload()
				}
				constructor(t) {
					;(this.container = t),
						(this.relatedProducts = this.container.querySelector(Qg)),
						this.init()
				}
			})(this.container)
		},
		onDeselect() {
			Yg[this.id].onDeselect()
		},
		onUnload() {
			Yg[this.id].onUnload()
		},
	})
	const Zg = {},
		tv = '[data-slider]',
		ev = '[data-item]',
		iv = '[data-button-show]',
		sv = '[data-button-hide]',
		ov = '[data-item-products]',
		nv = '[data-item-products-slider]',
		rv = '[data-item-product]',
		av = 'a, button',
		lv = 'blog-item--active',
		cv = 'blog-item__products--visible',
		hv = 'flickity-enabled',
		dv = 'is-selected',
		uv = {
			slider: 'data-slider',
			slidePosition: 'data-slide-position',
			sectionId: 'data-section-id',
			tabIndex: 'tabindex',
		}
	const pv = {
		onLoad() {
			Zg[this.id] = new (class {
				initSlider() {
					;(this.flkty = new e(this.slider, {
						prevNextButtons: !0,
						pageDots: !1,
						cellAlign: 'left',
						wrapAround: !1,
						groupCells: !0,
						contain: !0,
						on: {
							ready: () => {
								this.handleFocus()
							},
						},
					})),
						this.flkty.on('change', () => {
							const t = this.container.querySelectorAll(ev)
							this.handleFocus(),
								t.length &&
									t.forEach((t) => {
										const e = t.querySelector(ov)
										t.classList.remove(lv),
											e && t.querySelector(ov).classList.remove(cv)
									}),
								this.flkty &&
									!this.flkty.options.draggable &&
									((this.flkty.options.draggable = !0),
									this.flkty.updateDraggable())
						})
				}
				destroySlider() {
					null !== this.flkty && (this.flkty.destroy(), (this.flkty = null))
				}
				checkSlidesSize() {
					const t =
						this.container.querySelector(ev).currentStyle ||
						window.getComputedStyle(this.container.querySelector(ev))
					this.gutter = parseInt(t.marginRight)
					const e = this.slider.offsetWidth + this.gutter < this.getItemsWidth()
					window.innerWidth >= theme.sizes.small && e
						? this.initSlider()
						: this.destroySlider()
				}
				getItemsWidth() {
					let t = 0
					const e = this.slider.querySelectorAll(ev)
					return (
						e.length &&
							e.forEach((e) => {
								t += e.offsetWidth + this.gutter
							}),
						t
					)
				}
				bindButtons() {
					const t = this.container.querySelectorAll(nv),
						i = this.container.querySelectorAll(iv),
						s = this.container.querySelectorAll(sv)
					i.length &&
						i.forEach((t) => {
							t.addEventListener('click', (e) => {
								e.preventDefault(),
									this.container.querySelectorAll(ev).forEach((t) => {
										const e = t.querySelector(ov)
										t.classList.remove(lv),
											e && (e.classList.remove(cv), this.changeTabIndex(e))
									})
								const i = t.closest(ev),
									s = i.querySelector(ov)
								if ((i.classList.add(lv), s)) {
									s.classList.add(cv), this.changeTabIndex(s, 'enable')
									const t = s.querySelector(nv),
										e = t.querySelectorAll(rv)
									if (t.classList.contains(hv)) {
										const i = t
											.querySelector(`.${dv}`)
											.getAttribute(uv.slidePosition)
										e.forEach((t, e) => {
											t.setAttribute(uv.tabIndex, e === i ? '0' : '-1')
										})
									}
								}
								null !== this.flkty &&
									((this.flkty.options.draggable = !1),
									this.flkty.updateDraggable()),
									(this.a11y.state.trigger = t)
							})
						}),
						s.length &&
							s.forEach((t) => {
								t.addEventListener('click', (e) => {
									e.preventDefault()
									const i = t.closest(ev),
										s = i.querySelector(ov)
									i.classList.remove(lv),
										s && (s.classList.remove(cv), this.changeTabIndex(s)),
										null !== this.flkty &&
											((this.flkty.options.draggable = !0),
											this.flkty.updateDraggable()),
										this.a11y.state.trigger.focus()
								})
							}),
						t.length &&
							t.forEach((t) => {
								if (t.querySelectorAll(rv).length > 1) {
									const i = new e(t, {
										prevNextButtons: !0,
										contain: !0,
										pageDots: !1,
										wrapAround: !0,
										on: {
											change: (t) => {
												i.cells.forEach((e, i) => {
													e.element.querySelectorAll(av).forEach((e) => {
														e.setAttribute(uv.tabIndex, i === t ? '0' : '-1')
													})
												})
											},
										},
									})
								}
							}),
						this.slider.addEventListener('keyup', (t) => {
							if (t.code === theme.keyboardKeys.ESCAPE) {
								const e = t.target.hasAttribute(uv.slider)
									? t.target.querySelectorAll(ev)
									: t.target.closest(tv).querySelectorAll(ev)
								e.length &&
									(e.forEach((t) => {
										const e = t.querySelector(ov)
										t.classList.remove(lv),
											e && (e.classList.remove(cv), this.changeTabIndex(e))
									}),
									this.flkty &&
										((this.flkty.options.draggable = !0),
										this.flkty.updateDraggable())),
									this.a11y.state.trigger.focus()
							}
						})
				}
				handleFocus() {
					const t = this.container.querySelectorAll(ev)
					t.length &&
						t.forEach((t) => {
							const e = t.classList.contains(dv),
								i = t.querySelector(ov)
							e
								? (this.changeTabIndex(t, 'enable'),
								  i && this.changeTabIndex(i))
								: (this.changeTabIndex(t), i && i.classList.remove(cv))
						})
				}
				listen() {
					this.slider &&
						(this.checkSlidesSize(),
						document.addEventListener(
							'theme:resize:width',
							this.checkSlidesSizeOnResize,
						)),
						document.addEventListener('mousedown', this.clickOutsideItemEvent)
				}
				changeTabIndex(t, e = '') {
					const i = 'enable' === e ? '0' : '-1'
					t.querySelectorAll(av).forEach((t) => {
						t.setAttribute(uv.tabIndex, i)
					})
				}
				onBlockSelect(t) {
					if (null !== this.flkty) {
						const e = parseInt(
								[...t.target.parentNode.children].indexOf(t.target),
							),
							i = parseInt(this.flkty.slides[0].cells.length),
							s = Math.floor(e / i)
						this.flkty.select(s)
					} else {
						const e =
								this.slider.currentStyle ||
								window.getComputedStyle(this.slider),
							i = parseInt(e.paddingLeft),
							s = t.target.offsetLeft - i
						this.slider.scrollTo({ top: 0, left: s, behavior: 'smooth' })
					}
				}
				onUnload() {
					document.removeEventListener(
						'theme:resize:width',
						this.checkSlidesSizeOnResize,
					),
						document.removeEventListener(
							'mousedown',
							this.clickOutsideItemEvent,
						)
				}
				constructor(t) {
					;(this.container = t.container),
						(this.flkty = null),
						(this.slider = this.container.querySelector(tv)),
						(this.checkSlidesSizeOnResize = () => this.checkSlidesSize()),
						(this.isFullWidth = this.container.hasAttribute(uv.fullWidth)),
						(this.gutter = 0),
						(this.a11y = _t),
						(this.clickOutsideItemEvent = (t) => {
							if (!t.target.matches(ev) && !t.target.closest(ev)) {
								const t = this.container.querySelectorAll(ev)
								t.length &&
									t.forEach((t) => {
										const e = t.querySelector(ov)
										e && (e.classList.remove(cv), this.changeTabIndex(e)),
											t.classList.remove(lv)
									})
							}
						}),
						this.bindButtons(),
						this.listen()
				}
			})(this)
		},
		onUnload(t) {
			Zg[this.id].onUnload(t)
		},
		onBlockSelect(t) {
			Zg[this.id].onBlockSelect(t)
		},
	}
	ct('shoppable-blog', pv)
	const mv = '[data-scroll-down]',
		gv = '[data-site-header]',
		vv = '[data-slide]',
		yv = 'a, button',
		fv = '[data-slider]',
		bv = 'data-style',
		wv = 'data-current-style',
		Ev = 'tabindex',
		Sv = 'data-slide-position',
		Lv = 'site-header--fixed',
		kv = {}
	ct('slider', [
		{
			onLoad() {
				kv[this.id] = new (class {
					initSlider() {
						const t = this.container.querySelectorAll(vv).length,
							i = parseInt(this.container.dataset.duration),
							s = 'true' === this.container.dataset.pageDots && t > 1,
							o = 'true' === this.container.dataset.navArrows && t > 1
						let n = 'true' === this.container.dataset.autoplay
						if ((n && (n = i), t > 1))
							(this.flkty = new e(this.container, {
								fade: !0,
								cellSelector: vv,
								autoPlay: n,
								wrapAround: !0,
								adaptiveHeight: !0,
								setGallerySize: !0,
								imagesLoaded: !0,
								pageDots: s,
								prevNextButtons: o,
								on: {
									ready: () => {
										const t = this.container
											.querySelector(`${vv}[${Sv}="1"]`)
											.getAttribute(bv)
										this.container.setAttribute(wv, t),
											requestAnimationFrame(this.resizeEvent),
											document.addEventListener('theme:vars', this.resizeEvent)
									},
									change: (t) => {
										const e = this.flkty.selectedElement.getAttribute(bv)
										this.container.setAttribute(wv, e),
											this.flkty.cells.forEach((e, i) => {
												e.element.querySelectorAll(yv).forEach((e) => {
													e.setAttribute(Ev, i === t ? '0' : '-1')
												})
											})
									},
								},
							})),
								ae(this.container)
						else if (1 === t) {
							const t = this.container.querySelector(vv).getAttribute(bv)
							this.container.setAttribute(wv, t)
						}
					}
					bindScrollButton() {
						const t = this.container.querySelector(mv)
						t &&
							t.addEventListener('click', (t) => {
								t.preventDefault()
								const e = this.header.classList.contains(Lv) ? 60 : 0,
									i = parseInt(
										Math.ceil(
											this.container.offsetTop +
												this.container.offsetHeight -
												e,
										),
									)
								window.scrollTo({ top: i, left: 0, behavior: 'smooth' })
							})
					}
					onBlockSelect(t) {
						const e = parseInt(
							[...t.target.parentNode.children].indexOf(t.target),
						)
						null !== this.flkty &&
							(this.flkty.select(e), this.flkty.pausePlayer())
					}
					onBlockDeselect(t) {
						'true' === t.target.closest(fv).dataset.autoplay &&
							null !== this.flkty &&
							this.flkty.playPlayer()
					}
					onReorder() {
						null !== this.flkty && this.flkty.resize()
					}
					onUnload() {
						null !== this.flkty &&
							(document.removeEventListener('theme:vars', this.resizeEvent),
							this.flkty.destroy(),
							(this.flkty = null))
					}
					constructor(t) {
						;(this.container = t.container),
							(this.header = document.querySelector(gv)),
							(this.flkty = null),
							(this.resizeEvent = () => {
								this.flkty.resize()
							}),
							this.initSlider(),
							this.bindScrollButton()
					}
				})(this)
			},
			onReorder(t) {
				kv[this.id].onReorder(t)
			},
			onUnload(t) {
				kv[this.id].onUnload(t)
			},
			onBlockSelect(t) {
				kv[this.id].onBlockSelect(t)
			},
			onBlockDeselect(t) {
				kv[this.id].onBlockDeselect(t)
			},
		},
		jh,
		Xh,
	]),
		ct('subcollections', hu),
		ct('tab-collections', [ps, hu, Yo])
	const Av = {},
		qv = '[data-slider]',
		Cv = '[data-item]',
		Tv = 'flickity-enabled',
		Pv = 'data-section-id'
	ct('testimonials', {
		onLoad() {
			Av[this.id] = new (class {
				initSlider() {
					const t = this.slider.querySelectorAll(Cv).length
					let i = this.slider.classList.contains(Tv)
					;(2 == t && window.innerWidth >= theme.sizes.small) ||
					1 == t ||
					window.innerWidth < theme.sizes.small
						? i && this.flkty.destroy()
						: ((this.flkty = new e(this.slider, {
								cellSelector: Cv,
								prevNextButtons: !0,
								pageDots: !1,
								groupCells: !0,
								cellAlign: 'left',
								contain: !0,
								adaptiveHeight: !1,
						  })),
						  this.flkty.resize(),
						  this.flkty.slideableWidth > this.flkty.size.width ||
								this.flkty.destroy())
				}
				onBlockSelect(t) {
					if (null !== this.flkty) {
						const e = parseInt(
								[...t.target.parentNode.children].indexOf(t.target),
							),
							i = parseInt(this.flkty.slides[0].cells.length),
							s = Math.floor(e / i)
						this.flkty.select(s)
					} else {
						const e =
								this.slider.currentStyle ||
								window.getComputedStyle(this.slider),
							i = parseInt(e.paddingLeft),
							s = t.target.offsetLeft - i
						this.slider.scrollTo({ top: 0, left: s, behavior: 'smooth' })
					}
				}
				onUnload() {
					document.removeEventListener(
						'theme:resize:width',
						this.sliderResizeEvent,
					)
				}
				constructor(t) {
					;(this.container = t.container),
						(this.sectionId = this.container.getAttribute(Pv)),
						(this.slider = this.container.querySelector(qv)),
						(this.sliderResizeEvent = () => this.initSlider()),
						(this.flkty = null),
						this.initSlider(),
						document.addEventListener(
							'theme:resize:width',
							this.sliderResizeEvent,
						)
				}
			})(this)
		},
		onUnload(t) {
			Av[this.id].onUnload(t)
		},
		onBlockSelect(t) {
			Av[this.id].onBlockSelect(t)
		},
	})
	const Fv = 'no-outline',
		Iv = '[data-skip-content]',
		xv = 'a[href="#"]'
	document.documentElement.style.setProperty(
		'--scrollbar-width',
		`${(() => {
			const t = document.createElement('div')
			;(t.style.visibility = 'hidden'),
				(t.style.overflow = 'scroll'),
				(t.style.msOverflowStyle = 'scrollbar'),
				document.body.appendChild(t)
			const e = document.createElement('div')
			t.appendChild(e)
			const i = t.offsetWidth - e.offsetWidth
			return t.parentNode.removeChild(t), i
		})()}px`,
	),
		document.addEventListener('DOMContentLoaded', function () {
			ht('*')
			'true' === document.body.dataset.animations &&
				o.init({ once: !0, offset: 50, duration: 600, startEvent: 'load' }),
				new (class {
					init() {
						;(this.body = document.body),
							(this.inPageLink = document.querySelector(Iv)),
							(this.linkesWithOnlyHash = document.querySelectorAll(xv)),
							(this.isFocused = !1),
							this.focusHash(),
							this.bindInPageLinks(),
							this.clickEvents(),
							this.focusEvents(),
							this.focusEventsOff()
					}
					clickEvents() {
						this.inPageLink &&
							this.inPageLink.addEventListener('click', (t) => {
								t.preventDefault()
							}),
							this.linkesWithOnlyHash &&
								this.linkesWithOnlyHash.forEach((t) => {
									t.addEventListener('click', (t) => {
										t.preventDefault()
									})
								})
					}
					focusEvents() {
						document.addEventListener('keyup', (t) => {
							t.code === theme.keyboardKeys.TAB &&
								(this.body.classList.remove(Fv), (this.isFocused = !0))
						})
					}
					focusEventsOff() {
						document.addEventListener('mousedown', () => {
							this.body.classList.add(Fv), (this.isFocused = !1)
						})
					}
					forceFocus(t, e) {
						e = e || {}
						var i = t.tabIndex
						;(t.tabIndex = -1),
							(t.dataset.tabIndex = i),
							t.focus(),
							void 0 !== e.className && t.classList.add(e.className),
							t.addEventListener('blur', function s(o) {
								o.target.removeEventListener(o.type, s),
									(t.tabIndex = i),
									delete t.dataset.tabIndex,
									void 0 !== e.className && t.classList.remove(e.className)
							})
					}
					focusHash(t) {
						t = t || {}
						let e = window.location.hash
						void 0 !== theme.settings.newHash &&
							((e = theme.settings.newHash), (window.location.hash = `#${e}`))
						const i = document.getElementById(e.slice(1))
						if (i && t.ignore && i.matches(t.ignore)) return !1
						e && i && this.forceFocus(i, t)
					}
					bindInPageLinks(t) {
						return (
							(t = t || {}),
							Array.prototype.slice
								.call(document.querySelectorAll('a[href^="#"]'))
								.filter((e) => {
									if ('#' === e.hash || '' === e.hash) return !1
									if (t.ignore && e.matches(t.ignore)) return !1
									if (
										((i = e.hash.substr(1)),
										null === document.getElementById(i))
									)
										return !1
									var i,
										s = document.querySelector(e.hash)
									return (
										!!s &&
										(e.addEventListener('click', () => {
											this.forceFocus(s, t)
										}),
										!0)
									)
								})
						)
					}
					constructor() {
						this.init()
					}
				})(),
				!customElements.get('product-grid-item-swatch') &&
					window.theme.settings.enableColorSwatchesCollection &&
					customElements.define('product-grid-item-swatch', Xi)
			'scrollBehavior' in document.documentElement.style ||
				$t({ url: theme.assets.smoothscroll })
		})
})(
	themeVendor.ScrollLock,
	themeVendor.Flickity,
	themeVendor.themeCurrency,
	themeVendor.ajaxinate,
	themeVendor.AOS,
)
